// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"hMVcW":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PromptFieldValue", ()=>PromptFieldValue);
parcelHelpers.export(exports, "PromptField", ()=>PromptField);
/**
 * PromptFieldAttachmentList displays a list of file attachments within a PromptField.
 */ parcelHelpers.export(exports, "PromptFieldAttachmentList", ()=>PromptFieldAttachmentList);
/**
 * PromptTokenField renders an editable text input for a prompt, and supports inserting inline
 * object references as tokens via autocomplete.
 */ parcelHelpers.export(exports, "PromptTokenField", ()=>PromptTokenField);
/**
 * A PromptToken displays a non-editable inline object reference within a PromptTokenField.
 */ parcelHelpers.export(exports, "PromptToken", ()=>PromptToken);
/**
 * PromptFieldToolbar contains action buttons related to the PromptField.
 */ parcelHelpers.export(exports, "PromptFieldToolbar", ()=>PromptFieldToolbar);
/** PromptFieldSubmitButton submits the PromptField. */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
parcelHelpers.export(exports, "PromptFieldSubmitButton", ()=>PromptFieldSubmitButton);
/**
 * PromptFieldVoiceButton triggers voice input for the PromptField.
 */ parcelHelpers.export(exports, "PromptFieldVoiceButton", ()=>PromptFieldVoiceButton);
/**
 * InsertMenuButton renders an ActionButton with a plus icon that opens a menu.
 */ parcelHelpers.export(exports, "InsertMenuButton", ()=>InsertMenuButton);
/**
 * AttachFileMenuItem triggers a system file dialog to attach files within an InsertMenuButton.
 */ parcelHelpers.export(exports, "AttachFileMenuItem", ()=>AttachFileMenuItem);
/**
 * InsertTokenMenuItem inserts a token (i.e. object reference) into the PromptField within an
 * InsertMenuButton.
 */ parcelHelpers.export(exports, "InsertTokenMenuItem", ()=>InsertTokenMenuItem);
/**
 * InsertTextMenuItem inserts plain text into the PromptField from within an InsertMenuButton.
 */ parcelHelpers.export(exports, "InsertTextMenuItem", ()=>InsertTextMenuItem);
// specifically for menu items that only trigger a callback in the autocomplete menu
// since they dont end up inserting a token or text, we need to clear the partial text that the user used
// to filter the menu
/**
 * CommandMenuItem performs an immediate action from within an InsertMenuButton.
 */ parcelHelpers.export(exports, "CommandMenuItem", ()=>CommandMenuItem);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButton = require("@react-spectrum/s2/ActionButton");
var _attach = require("@react-spectrum/s2/icons/Attach");
var _attachDefault = parcelHelpers.interopDefault(_attach);
var _attachmentList = require("./AttachmentList");
var _autocomplete = require("react-aria-components/Autocomplete");
var _button = require("@react-spectrum/s2/Button");
var _centerBaseline = require("@react-spectrum/s2/CenterBaseline");
var _react = require("react");
var _useFocusVisible = require("react-aria/private/interactions/useFocusVisible");
var _s2 = require("@react-spectrum/s2");
var _card = require("@react-spectrum/s2/Card");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _useDrop = require("react-aria-components/useDrop");
var _link = require("@react-spectrum/s2/Link");
var _linkButton = require("@react-spectrum/s2/LinkButton");
var _menu = require("@react-spectrum/s2/Menu");
var _microphone = require("@react-spectrum/s2/icons/Microphone");
var _microphoneDefault = parcelHelpers.interopDefault(_microphone);
var _react1 = require("./loader/react");
var _add = require("@react-spectrum/s2/icons/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _popover = require("@react-spectrum/s2/Popover");
var _useTokenFieldState = require("react-stately/useTokenFieldState");
var _promptFieldContainer = require("./PromptFieldContainer");
var _chat = require("./Chat");
var _slots = require("react-aria-components/slots");
var _arrowUpSend = require("@react-spectrum/s2/icons/ArrowUpSend");
var _arrowUpSendDefault = parcelHelpers.interopDefault(_arrowUpSend);
var _useTokenField = require("react-aria/useTokenField");
var _stopProcessing = require("@react-spectrum/s2/icons/StopProcessing");
var _stopProcessingDefault = parcelHelpers.interopDefault(_stopProcessing);
var _toggleButton = require("@react-spectrum/s2/ToggleButton");
var _tokenField = require("react-aria-components/TokenField");
var _tooltip = require("@react-spectrum/s2/Tooltip");
var _useControlledState = require("react-stately/useControlledState");
var _useEffectEvent = require("react-aria/private/utils/useEffectEvent");
var _useDOMRef = require("./useDOMRef");
var _useFocusWithin = require("react-aria/useFocusWithin");
var _useKeyboard = require("react-aria/useKeyboard");
var _i18Nprovider = require("react-aria/I18nProvider");
var _useLocalizedStringFormatter = require("react-aria/useLocalizedStringFormatter");
var _useVoiceInput = require("./useVoiceInput");
// TODO: make this customizable
const tokenRegex = /(?<=\s|^)(https?:\/\/)?(www\.)?([^/\s]+\.[a-z]{2,}(\/\S+)?)(?=\s)/g;
function tokenizeURLs(text) {
    if (text.length === 0) return [
        {
            type: 'text',
            text
        }
    ];
    tokenRegex.lastIndex = 0;
    let match = null;
    let start = 0;
    let segments = [];
    while(match = tokenRegex.exec(text)){
        if (match.index > start) segments.push({
            type: 'text',
            text: text.slice(start, match.index)
        });
        segments.push({
            type: 'token',
            text: match[3],
            value: {
                type: 'url',
                url: match[0]
            }
        });
        start = match.index + match[0].length;
    }
    if (start < text.length) segments.push({
        type: 'text',
        text: text.slice(start)
    });
    return segments;
}
class PromptFieldValue extends (0, _useTokenFieldState.TokenFieldValue) {
    tokenize(text) {
        return tokenizeURLs(text);
    }
    replaceRangeWithSegments(start, end, segments, coalesce = true) {
        let slice = this.slice(start, end).segments;
        let token = slice[0];
        if (slice.length === 1 && token.type === 'token' && (token.value?.type === 'placeholder' && token.value.placeholderType === 'token' || token.value?.type === 'custom') && segments.length === 1 && segments[0].type === 'text' && !segments[0].text.startsWith(token.value.anchor)) segments = [
            {
                type: 'token',
                text: token.value.anchor,
                value: {
                    type: 'anchor',
                    valueType: token.value.valueType
                }
            },
            ...segments
        ];
        return super.replaceRangeWithSegments(start, end, segments, coalesce);
    }
}
const PromptFieldContext = /*#__PURE__*/ (0, _react.createContext)({
    attachments: [],
    setAttachments: ()=>{},
    prompt: new PromptFieldValue([]),
    setPrompt: ()=>{},
    inputRef: /*#__PURE__*/ (0, _react.createRef)(),
    isGenerating: false,
    isListening: false,
    setListening: ()=>{},
    size: 'M'
});
// to communicate the anchor position to the menu items in the completion popover
// need this so we can replace the inline filter text rather than inserting it at the current caret
// aka the difference between a slash command and using the + menu which won't have filter text
const PromptCompletionAnchorContext = /*#__PURE__*/ (0, _react.createContext)(null);
function matchMimeType(mimeType, acceptedMimeTypes) {
    return acceptedMimeTypes.some((type)=>{
        if (type === '*/*') return true;
        if (type.endsWith('/*')) return mimeType.startsWith(type.slice(0, -2));
        return mimeType === type;
    });
}
const PromptField = /*#__PURE__*/ (0, _react.forwardRef)(function PromptField(props, ref) {
    let { children, acceptedAttachmentTypes, isGenerating, onStop, styles, onAddAttachments, onRemoveAttachments, variant = 'balanced', brandColor, size = 'M' } = props;
    // Not using RAC DropZone because it adds its own focusable button,
    // and we want to avoid an extra tab. We support pasting files directly into the input.
    let inputRef = (0, _react.useRef)(null);
    let domRef = (0, _useDOMRef.useFocusableRef)(ref, inputRef);
    let stringFormatter = (0, _useLocalizedStringFormatter.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/ai');
    let [prompt, setPrompt] = (0, _useControlledState.useControlledState)(props.value, props.defaultValue ?? new PromptFieldValue([]), props.onChange);
    let [attachments, setAttachments] = (0, _useControlledState.useControlledState)(props.attachments, props.defaultAttachments ?? [], props.onAttachmentsChange);
    let { dropProps, isDropTarget } = (0, _useDrop.useDrop)({
        ref: inputRef,
        hasDropButton: true,
        isDisabled: !acceptedAttachmentTypes,
        getDropOperation (types) {
            return acceptedAttachmentTypes && types.has(acceptedAttachmentTypes) ? 'copy' : 'cancel';
        },
        async onDrop (e) {
            let files = await Promise.all(e.items.filter((0, _useDrop.isFileDropItem)).filter((item)=>matchMimeType(item.type, acceptedAttachmentTypes)).map(async (item)=>({
                    id: crypto.randomUUID(),
                    file: await item.getFile(),
                    image: item.type.startsWith('image/') ? URL.createObjectURL(await item.getFile()) : ''
                })));
            onAddAttachments?.(files);
            setAttachments((attachments)=>[
                    ...attachments,
                    ...files
                ]);
        }
    });
    let [isListening, setListening] = (0, _react.useState)(false);
    let { onFocusChange } = (0, _react.useContext)((0, _chat.PromptFocusContext));
    let { focusWithinProps } = (0, _useFocusWithin.useFocusWithin)({
        onFocusWithinChange: onFocusChange
    });
    let isPromptControlled = props.value !== undefined;
    let isAttachmentsControlled = props.attachments !== undefined;
    let onSubmit = ()=>{
        if (prompt.segments.length === 0) return;
        props.onSubmit?.(prompt, attachments);
        if (!isPromptControlled) setPrompt(new PromptFieldValue([]));
        if (!isAttachmentsControlled) setAttachments([]);
        inputRef.current?.focus();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PromptFieldContext.Provider, {
        value: {
            attachments,
            setAttachments,
            acceptedAttachmentTypes,
            prompt,
            setPrompt,
            inputRef,
            onSubmit,
            isGenerating: isGenerating ?? false,
            isListening,
            setListening,
            onStop,
            onAddAttachments,
            onRemoveAttachments,
            size
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slots.Provider), {
            values: [
                [
                    (0, _button.ButtonContext),
                    {
                        staticColor: 'auto',
                        size
                    }
                ],
                [
                    (0, _linkButton.LinkButtonContext),
                    {
                        staticColor: 'auto',
                        size
                    }
                ],
                [
                    (0, _actionButton.ActionButtonContext),
                    {
                        staticColor: 'auto',
                        size
                    }
                ],
                [
                    (0, _toggleButton.ToggleButtonContext),
                    {
                        staticColor: 'auto',
                        size
                    }
                ]
            ],
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                ref: domRef,
                ...focusWithinProps,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _promptFieldContainer.PromptFieldContainer), {
                        ...dropProps,
                        role: "group",
                        size: size,
                        variant: variant,
                        brandColor: brandColor,
                        isGenerating: isGenerating ?? false,
                        isDropTarget: isDropTarget,
                        styles: styles,
                        inputRef: inputRef,
                        children: children
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: " uk17 ucJ9TBTb17 ud3Euai17 uea17 ugb17 uhd17 uje17 u2NhKxcl17 uic17 -_6BNtrc-b17 vFHT6Dd17 xb17 _xa17 _Fd17 _FnuYUweb17 pn17 _Wa17",
                        children: [
                            stringFormatter.format('promptfield.aiDisclaimer'),
                            ' ',
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
                                variant: "secondary",
                                href: "https://www.adobe.com/legal/licenses-terms/adobe-gen-ai-user-guidelines.html",
                                target: "_blank",
                                onPress: props.onAITermsPress,
                                children: stringFormatter.format('promptfield.aiUserGuidlines')
                            })
                        ]
                    })
                ]
            })
        })
    });
});
function PromptFieldAttachmentList(props) {
    let { children } = props;
    let { attachments, setAttachments, onRemoveAttachments, inputRef } = (0, _react.useContext)(PromptFieldContext);
    let stringFormatter = (0, _useLocalizedStringFormatter.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/ai');
    if (attachments.length === 0) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentList.AttachmentList), {
        ...props,
        "aria-label": stringFormatter.format('promptfield.attachments'),
        onRemove: (keys)=>{
            let removedAttachments = attachments.filter((attachment)=>keys.has(attachment.id));
            onRemoveAttachments?.(removedAttachments);
            setAttachments((attachments)=>attachments.filter((attachment)=>!keys.has(attachment.id)));
            if (removedAttachments.length === attachments.length) inputRef.current?.focus();
        },
        items: attachments,
        children: children || ((attachment)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentList.Attachment), {
                children: attachment.image && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.Image), {
                    src: attachment.image,
                    slot: "thumbnail"
                })
            }))
    });
}
function PromptTokenField(props) {
    let { completionTrigger, renderCompletions, children, pixelLoader, shouldAnimatePixelLoader = false, placeholder, menuWidth, onKeyDown: onKeyDownProp } = props;
    let { prompt, setPrompt, acceptedAttachmentTypes, setAttachments, onAddAttachments, inputRef, onSubmit, isGenerating, isListening, size } = (0, _react.useContext)(PromptFieldContext);
    let stringFormatter = (0, _useLocalizedStringFormatter.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/ai');
    let [isFocused, setFocused] = (0, _react.useState)(false);
    let [filterAnchor, filterValue, filterType] = (0, _react.useMemo)(()=>{
        // If on a placeholder token, show suggestions.
        let slice = prompt.slice(prompt.selectedRange.start, prompt.selectedRange.end);
        let segment = slice.segments.length === 1 ? slice.segments[0] : null;
        if (segment?.type === 'token' && (segment.value?.type === 'placeholder' && segment.value.placeholderType === 'token' || segment.value?.type === 'custom')) return [
            prompt.selectedRange.start,
            segment.value.anchor,
            segment.value.valueType ?? null
        ];
        if (completionTrigger) {
            // Find a preceding anchor token. This tells us what kind of object to filter for.
            let anchorTokenIndex = -1;
            let filterType = null;
            for(let index = Math.min(prompt.selectedRange.anchor.index, prompt.segments.length - 1); index >= 0; index--){
                let segment = prompt.segments[index];
                if (segment.type === 'token' && segment.value?.type === 'anchor') {
                    anchorTokenIndex = index;
                    filterType = segment.value?.valueType;
                    break;
                }
            }
            let filterAnchor = prompt.findText(prompt.caretPosition, (0, _useTokenFieldState.TokenFieldValue).Direction.Backward, completionTrigger);
            // If anchor token is after text anchor, use it.
            if (anchorTokenIndex >= 0 && (!filterAnchor || anchorTokenIndex > filterAnchor.index)) filterAnchor = {
                index: anchorTokenIndex,
                offset: 0
            };
            // Filter text is the text between the anchor and the caret position.
            if (filterAnchor != null) {
                let filterValue = prompt.slice(filterAnchor, prompt.caretPosition).toString();
                return [
                    filterAnchor,
                    filterValue,
                    filterType
                ];
            }
        }
        return [
            null,
            null,
            null
        ];
    }, [
        completionTrigger,
        prompt
    ]);
    let items = (0, _react.useMemo)(()=>{
        return filterValue != null ? renderCompletions?.(filterValue, filterType) : null;
    }, [
        filterValue,
        filterType,
        renderCompletions
    ]);
    let tab = (dir)=>{
        let nextPrompt = selectNextToken(prompt, dir);
        if (nextPrompt) {
            setPrompt(nextPrompt);
            return true;
        }
        return false;
    };
    let { keyboardProps } = (0, _useKeyboard.useKeyboard)({
        onKeyDown: onKeyDownProp,
        shortcuts: {
            Tab: ()=>tab(1),
            'Shift+Tab': ()=>tab(-1)
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: function anonymous(props) {
            let rules = " ";
            rules += ' sd17';
            if (props.size === "S") rules += ' UH5kTnc17';
            else if (props.size === "M") rules += ' Ui9a9Xd17';
            if (props.size === "S") rules += ' qH5kTnc17';
            else if (props.size === "M") rules += ' qi9a9Xd17';
            rules += ' ea17';
            if (props.isFocused) rules += ' pt17';
            else rules += ' pgBmXAd17';
            rules += ' plOVIhfc6LxY917';
            rules += ' plOVIhfc6LxY917';
            rules += ' Yd17';
            rules += ' XELcMn17';
            rules += ' _2pHNWpc17';
            if (props.size === "S") rules += ' Sj17';
            else if (props.size === "M") rules += ' SrEMFue17';
            rules += ' Za17';
            if (props.isFocused) rules += ' -_2o6eae-pt17';
            else rules += ' -_2o6eae-pm17';
            rules += ' -_2o6eae-lOVIhfcp6LxY917';
            rules += ' -_2o6eae-lOVIhfcp6LxY917';
            if (props.isFocused) rules += ' -A9vNs-_Ib17';
            else rules += ' -A9vNs-_IZvfurc17';
            rules += ' -A9vNs-lOVIhfc_Ib17';
            rules += ' -A9vNs-lOVIhfc_Ib17';
            return rules;
        }({
            size,
            isFocused: isFocused || prompt.segments.length > 0
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _centerBaseline.CenterBaseline), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.PixelLoader), {
                    size: 21,
                    isPlaying: isGenerating && shouldAnimatePixelLoader,
                    icon: pixelLoader,
                    color: "var(--loader-color)",
                    className: " _ISjFApd17 Yf17 XELcMn17 _2pHNWpc17"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _autocomplete.Autocomplete), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenField.TokenField), {
                        value: prompt,
                        onChange: setPrompt,
                        allowsNewlines: true,
                        className: " _ub17",
                        "aria-label": stringFormatter.format('promptfield.label'),
                        isReadOnly: isListening,
                        onSubmit: onSubmit,
                        onKeyDown: keyboardProps.onKeyDown,
                        onFocus: (e)=>{
                            if (e.isTrusted) {
                                setFocused(true);
                                // If shift tabbing into the prompt field, select the last placeholder if any.
                                if (e.relatedTarget && (0, _useFocusVisible.getInteractionModality)() === 'keyboard' && e.currentTarget.compareDocumentPosition(e.relatedTarget) & Node.DOCUMENT_POSITION_FOLLOWING) {
                                    let lastPlaceholder = prompt.segments.findLastIndex((s)=>s.type === 'token');
                                    if (lastPlaceholder >= 0) setPrompt((value)=>value.withSelectedRange(new (0, _useTokenFieldState.TokenFieldValue).SelectedRange({
                                            index: lastPlaceholder,
                                            offset: 0
                                        }, {
                                            index: lastPlaceholder,
                                            offset: 1
                                        })));
                                }
                            }
                        },
                        onBlur: (e)=>{
                            if (e.isTrusted) setFocused(false);
                        },
                        onPaste: acceptedAttachmentTypes ? (e)=>{
                            let clipboardData = e.clipboardData;
                            let attachments = [];
                            for (let item of clipboardData.items)if (matchMimeType(item.type, acceptedAttachmentTypes)) {
                                let file = item.getAsFile();
                                attachments.push({
                                    id: crypto.randomUUID(),
                                    file,
                                    image: file.type.startsWith('image/') ? URL.createObjectURL(file) : ''
                                });
                            }
                            if (attachments.length > 0) {
                                onAddAttachments?.(attachments);
                                setAttachments((prev)=>[
                                        ...prev,
                                        ...attachments
                                    ]);
                            }
                        } : undefined,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenField.TokenInput), {
                            "data-placeholder": placeholder || stringFormatter.format(size === 'S' ? 'promptfield.placeholder.small' : 'promptfield.placeholder'),
                            ref: inputRef,
                            className: "H42Gde" + function anonymous(props) {
                                let rules = " ";
                                if (props.size === "S") {
                                    rules += ' uk17';
                                    rules += ' ucJ9TBTb17';
                                    rules += ' ud3Euai17';
                                    rules += ' uea17';
                                    rules += ' ugb17';
                                    rules += ' uhd17';
                                    rules += ' uje17';
                                    rules += ' u2NhKxcl17';
                                    rules += ' uic17';
                                } else if (props.size === "M") {
                                    rules += ' uk17';
                                    rules += ' ucJ9TBTb17';
                                    rules += ' ud3Euai17';
                                    rules += ' uea17';
                                    rules += ' ugb17';
                                    rules += ' uhd17';
                                    rules += ' uje17';
                                    rules += ' u2NhKxcl17';
                                    rules += ' uic17';
                                } else {
                                    rules += ' uk17';
                                    rules += ' ucJ9TBTb17';
                                    rules += ' ud3Euai17';
                                    rules += ' uea17';
                                    rules += ' ugb17';
                                    rules += ' uhd17';
                                    rules += ' uje17';
                                    rules += ' u2NhKxcl17';
                                    rules += ' uic17';
                                }
                                if (props.size === "S") {
                                    rules += ' -_6BNtrc-c17';
                                    rules += ' vFHT6Dd17';
                                } else if (props.size === "M") {
                                    rules += ' -_6BNtrc-d17';
                                    rules += ' vFHT6Dd17';
                                } else {
                                    rules += ' -_6BNtrc-d17';
                                    rules += ' vFHT6Dd17';
                                }
                                if (props.size === "S") {
                                    rules += ' xb17';
                                    rules += ' _xa17';
                                } else if (props.size === "M") {
                                    rules += ' xb17';
                                    rules += ' _xa17';
                                } else {
                                    rules += ' xb17';
                                    rules += ' _xa17';
                                }
                                if (props.size === "S") {
                                    rules += ' _Fb17';
                                    rules += ' _FnuYUwec17';
                                } else if (props.size === "M") {
                                    rules += ' _Fb17';
                                    rules += ' _FnuYUwec17';
                                } else {
                                    rules += ' _Fb17';
                                    rules += ' _FnuYUwec17';
                                }
                                rules += ' pt17';
                                if (props.isFocused) rules += ' paczhogc17';
                                else rules += ' paHdRngc17';
                                rules += ' palOVIhfcYMPQu17';
                                rules += ' palOVIhfcYMPQu17';
                                rules += ' Za17';
                                rules += ' _Le17';
                                rules += ' rD17';
                                rules += ' Yc17';
                                rules += ' XELcMn17';
                                rules += ' _2pHNWpc17';
                                return rules;
                            }({
                                size,
                                isFocused
                            }),
                            children: (0, _react.useCallback)((token)=>{
                                if (token.value?.type === 'anchor') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenField.Token), {
                                    children: token.text
                                });
                                else return children ? children(token) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(PromptToken, {
                                    token: token,
                                    children: token.text
                                });
                            }, [
                                children
                            ])
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PromptTokenFieldPopover, {
                        filterAnchor: filterAnchor,
                        items: (0, _react.useDeferredValue)(items),
                        isFocused: isFocused,
                        menuWidth: menuWidth
                    })
                ]
            })
        ]
    });
}
function selectNextToken(prompt, dir, placeholder = false) {
    let index = prompt.caretPosition.index;
    for(let i = index + dir; i >= 0 && i < prompt.segments.length; i += dir){
        let segment = prompt.segments[i];
        if (segment.type === 'token' && (!placeholder || segment.value?.type === 'placeholder')) return prompt.withSelectedRange(new (0, _useTokenFieldState.TokenFieldValue).SelectedRange({
            index: i,
            offset: 0
        }, {
            index: i,
            offset: segment.text.length
        }));
    }
    return null;
}
function PromptTokenFieldPopover(props) {
    let { filterAnchor, items, isFocused, menuWidth } = props;
    let { inputRef, prompt } = (0, _react.useContext)(PromptFieldContext);
    let resolvedItems = items instanceof Promise ? (0, _react.use)(items) : items;
    let isOpen = isFocused && filterAnchor != null && resolvedItems != null && resolvedItems.length > 0;
    // Cache items so that popover content doesn't flicker to empty while animating out
    let [menuItems, setMenuItems] = (0, _react.useState)(resolvedItems);
    if (resolvedItems !== menuItems && resolvedItems != null && resolvedItems.length > 0) setMenuItems(resolvedItems);
    let key = 'popover';
    if (filterAnchor) {
        // If on a token, anchor to the end of the previous text segment.
        if (filterAnchor.index > 0 && filterAnchor.offset === 0) filterAnchor = {
            index: filterAnchor.index - 1,
            offset: prompt.segments[filterAnchor.index - 1].text.length
        };
        // Reposition the popover when the anchor changes.
        key = `${filterAnchor.index}:${filterAnchor.offset}`;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
        triggerRef: inputRef,
        isOpen: isOpen,
        isNonModal: true,
        hideArrow: true,
        placement: "bottom start",
        UNSAFE_style: menuWidth != null ? {
            width: menuWidth
        } : undefined,
        getTargetRect: (target)=>{
            return (0, _tokenField.tokenFieldPositionToDOMRange)(target, filterAnchor).getBoundingClientRect();
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PromptCompletionAnchorContext.Provider, {
            value: props.filterAnchor ?? null,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.Menu), {
                children: menuItems
            })
        })
    }, key);
}
function PromptToken(props1) {
    let { size } = (0, _react.useContext)(PromptFieldContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenField.Token), {
        ...props1,
        className: (renderProps)=>(function anonymous(props) {
                let rules = " ";
                if (props.size === "S") {
                    rules += ' uk17';
                    rules += ' ucJ9TBTb17';
                    rules += ' ud3Euai17';
                    rules += ' uea17';
                    rules += ' ugb17';
                    rules += ' uhd17';
                    rules += ' uje17';
                    rules += ' u2NhKxcl17';
                    rules += ' uic17';
                } else if (props.size === "M") {
                    rules += ' uk17';
                    rules += ' ucJ9TBTb17';
                    rules += ' ud3Euai17';
                    rules += ' uea17';
                    rules += ' ugb17';
                    rules += ' uhd17';
                    rules += ' uje17';
                    rules += ' u2NhKxcl17';
                    rules += ' uic17';
                }
                if (props.size === "S") {
                    rules += ' -_6BNtrc-b17';
                    rules += ' vFHT6Dd17';
                } else if (props.size === "M") {
                    rules += ' -_6BNtrc-c17';
                    rules += ' vFHT6Dd17';
                }
                if (props.size === "S") {
                    rules += ' xb17';
                    rules += ' _xa17';
                } else if (props.size === "M") {
                    rules += ' xb17';
                    rules += ' _xa17';
                }
                rules += ' _Fa8Mfn17';
                if (props.isSelected) rules += ' px17';
                else rules += ' pt17';
                if (props.isSelected) rules += ' g_h17';
                else rules += ' gN7dngc17';
                if (props.isPlaceholder) rules += ' _La17';
                else rules += ' _Lf17';
                rules += ' _Mb17';
                if (props.isPlaceholder) rules += ' OGaGngc17';
                else rules += ' ON7dngc17';
                rules += ' _Ka17';
                rules += ' oh17';
                rules += ' nh17';
                rules += ' kh17';
                rules += ' jh17';
                rules += ' _nhhfj0d17';
                rules += ' _ma17';
                rules += ' St17';
                rules += ' Rt17';
                if (props.size === "S") rules += ' Tj17';
                else if (props.size === "M") rules += ' TflWog17';
                if (props.size === "S") rules += ' Qj17';
                else if (props.size === "M") rules += ' QflWog17';
                rules += ' ri17';
                rules += ' -_8sjo0b-t5ZbAob17';
                return rules;
            })({
                ...renderProps,
                isPlaceholder: props1.token.value?.type === 'placeholder',
                size
            }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.IconContext).Provider, {
            value: {
                styles: " ZObNfn17 FObNfn17 sg17 _5HtsLPe17 HR3ltQc17"
            },
            children: props1.children
        })
    });
}
function PromptFieldToolbar(props) {
    let { children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: " sd17 _Ce17 eb17 JB1JKEb17",
        children: children
    });
}
function PromptFieldSubmitButton(props) {
    let { prompt, isGenerating, onSubmit, onStop } = (0, _react.useContext)(PromptFieldContext);
    let stringFormatter = (0, _useLocalizedStringFormatter.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/ai');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
        variant: "primary",
        staticColor: "auto",
        // TODO: should it be possible to submit a prompt with only attachments?
        isDisabled: prompt.segments.length === 0 && !isGenerating,
        "aria-label": isGenerating ? stringFormatter.format('promptfield.stopButton') : stringFormatter.format('promptfield.submitButton'),
        onPress: isGenerating ? onStop : onSubmit,
        children: isGenerating ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stopProcessingDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowUpSendDefault.default), {})
    });
}
function PromptFieldVoiceButton(props) {
    let { lang: langProp, isDisabled: isDisabledProp, onError, onToggle } = props;
    let { locale } = (0, _i18Nprovider.useLocale)();
    let lang = langProp ?? locale;
    let { prompt, setPrompt, inputRef, setListening } = (0, _react.useContext)(PromptFieldContext);
    let isDisabled = isDisabledProp;
    let stringFormatter = (0, _useLocalizedStringFormatter.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/ai');
    let basePromptRef = (0, _react.useRef)(prompt);
    let updateBasePrompt = (0, _useEffectEvent.useEffectEvent)(()=>{
        basePromptRef.current = prompt;
    });
    let { isSupported, isListening: isVoiceListening, transcript, toggle, stop } = (0, _useVoiceInput.useVoiceInput)({
        lang,
        onError,
        onListeningChange: setListening
    });
    let restoreFocus = (0, _useEffectEvent.useEffectEvent)(()=>{
        if (!inputRef.current) return;
        // similar to useInsertPromptSegment, calling programatic focus on the input causes the caret positioning
        // to be inaccurate
        let finalPrompt = buildVoicePrompt(basePromptRef.current, transcript);
        inputRef.current.focus();
        (0, _useTokenField.setTokenFieldSelection)(inputRef.current, finalPrompt.selectedRange);
        setPrompt(finalPrompt);
    });
    let onToggleEvent = (0, _useEffectEvent.useEffectEvent)((isListening)=>{
        onToggle?.(isListening);
    });
    let wasListeningRef = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        if (isVoiceListening) {
            updateBasePrompt();
            wasListeningRef.current = true;
            onToggleEvent(true);
        } else if (wasListeningRef.current) {
            wasListeningRef.current = false;
            restoreFocus();
            onToggleEvent(false);
        }
    }, [
        isVoiceListening
    ]);
    let applyVoiceTranscript = (0, _useEffectEvent.useEffectEvent)(()=>{
        if (!transcript || !isVoiceListening) return;
        setPrompt(buildVoicePrompt(basePromptRef.current, transcript));
    });
    (0, _react.useEffect)(()=>{
        applyVoiceTranscript();
    }, [
        transcript,
        isVoiceListening
    ]);
    (0, _react.useEffect)(()=>{
        if (isDisabled && isVoiceListening) stop();
    }, [
        isDisabled,
        isVoiceListening,
        stop
    ]);
    if (!isSupported) return null;
    let label = isVoiceListening ? stringFormatter.format('voicebutton.stopListening') : stringFormatter.format('voicebutton.startListening');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tooltip.TooltipTrigger), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleButton.ToggleButton), {
                staticColor: "auto",
                isQuiet: true,
                isSelected: isVoiceListening,
                isDisabled: isDisabled,
                "aria-label": label,
                onPress: toggle,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _microphoneDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.Tooltip), {
                children: label
            })
        ]
    });
}
function buildVoicePrompt(base, voiceText) {
    if (!voiceText) return base;
    return base.replaceRange(base.caretPosition, base.caretPosition, voiceText);
}
function InsertMenuButton(props) {
    let { children, onOpenChange } = props;
    let stringFormatter = (0, _useLocalizedStringFormatter.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/ai');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuTrigger), {
        onOpenChange: onOpenChange,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionButton.ActionButton), {
                isQuiet: true,
                staticColor: "auto",
                "aria-label": stringFormatter.format('promptfield.insertButton'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.Menu), {
                children: children
            })
        ]
    });
}
function AttachFileMenuItem(props) {
    let { onAction, ...otherProps } = props;
    let { acceptedAttachmentTypes, setAttachments, onAddAttachments } = (0, _react.useContext)(PromptFieldContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuItem), {
        ...otherProps,
        onAction: ()=>{
            onAction?.();
            let input = document.createElement('input');
            input.type = 'file';
            if (acceptedAttachmentTypes) input.accept = acceptedAttachmentTypes.join(',');
            input.multiple = true;
            input.onchange = (e)=>{
                let files = e.currentTarget.files;
                if (files && acceptedAttachmentTypes) {
                    let attachments = Array.from(files).filter((file)=>matchMimeType(file.type, acceptedAttachmentTypes)).map((file)=>({
                            id: crypto.randomUUID(),
                            file,
                            image: file.type.startsWith('image/') ? URL.createObjectURL(file) : ''
                        }));
                    if (attachments.length > 0) {
                        onAddAttachments?.(attachments);
                        setAttachments((prev)=>[
                                ...prev,
                                ...attachments
                            ]);
                    }
                }
            };
            input.click();
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.Text), {
                children: "Attach a file"
            })
        ]
    });
}
// either replace the filter text (aka token replace) or insert value at current caret position (aka plain text inject)
function useInsertPromptSegment(segments) {
    let { setPrompt, inputRef } = (0, _react.useContext)(PromptFieldContext);
    let anchor = (0, _react.useContext)(PromptCompletionAnchorContext);
    let pendingSelection = (0, _react.useRef)(null);
    return ()=>{
        setPrompt((value)=>{
            // Add a space only if not already followed by one, but move the cursor past the space in any case.
            let insert = [
                ...segments
            ];
            let endPosition = value.selectedRange.end;
            if (insert.length) {
                let space = value.findText(endPosition, (0, _useTokenFieldState.TokenFieldValue).Direction.Forward, ' ');
                let hasFollowingSpace = space && value.slice(endPosition, space).segments.length === 0;
                insert.push({
                    type: 'text',
                    text: ' '
                });
                if (hasFollowingSpace && space) {
                    space.offset++;
                    endPosition = space;
                }
            }
            let newValue = value.replaceRangeWithSegments(anchor ?? value.selectedRange.start, endPosition, insert, false // Don't coalesce in undo/redo history.
            );
            newValue = selectNextToken(newValue, 1, true) || newValue;
            pendingSelection.current = newValue.selectedRange;
            return newValue;
        });
        if (anchor == null) // Wait for popover animation, then restore cursor to after the inserted content.
        setTimeout(()=>{
            if (inputRef.current && pendingSelection.current) {
                let range = pendingSelection.current;
                pendingSelection.current = null;
                inputRef.current.focus();
                // we need to update the position manually since TokenField's update caret logic only happens if the field is focused
                // but this insert can happen from the + menu aka the field isn't focused until this gets called which is too late
                (0, _useTokenField.setTokenFieldSelection)(inputRef.current, range);
                // the above focus and setCursor call can cause the internally tracked caret position to be reset incorrectly
                // seemingly due to TokenField's isProgrammaticSelectionChange being flipped to false by setCursor and thus reset to 0 by the .focus
                // fix this by resetting to proper position below
                // happens when injecting multiple tokens one after another via + menu
                setPrompt((value)=>value.withSelectedRange(range));
            }
        }, 400);
    };
}
function InsertTokenMenuItem(props) {
    let insert = useInsertPromptSegment([
        props.token
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.MenuItem), {
        ...props,
        onAction: ()=>{
            insert();
            props.onAction?.();
        }
    });
}
function InsertTextMenuItem(props) {
    let insert = useInsertPromptSegment([
        {
            type: 'text',
            text: props.text
        }
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.MenuItem), {
        ...props,
        onAction: ()=>{
            insert();
            props.onAction?.();
        }
    });
}
function CommandMenuItem(props) {
    let insert = useInsertPromptSegment([]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.MenuItem), {
        ...props,
        onAction: ()=>{
            insert();
            props.onAction?.();
        }
    });
}

},{"0":"fdK4a","1":"2vhrH","2":"hUt7M","3":"aN5wx","4":"6tkC4","5":"krggG","6":"8AmI3","7":"7kGDo","8":"lKVd4","react/jsx-runtime":"2Is6Z","@react-spectrum/s2/ActionButton":"lNDRs","@react-spectrum/s2/icons/Attach":"5Pkgy","./AttachmentList":"6EVOZ","react-aria-components/Autocomplete":"92IrI","@react-spectrum/s2/Button":"gZHck","@react-spectrum/s2/CenterBaseline":"1vpL9","react":"a1TxN","react-aria/private/interactions/useFocusVisible":"9a2nM","@react-spectrum/s2":"jQAJE","@react-spectrum/s2/Card":[["Image","4LTiE"],["Text","10r6w"]],"../intl/*.json":"1VKfy","react-aria-components/useDrop":[["isFileDropItem","hoHDi"],["useDrop","ejYww"]],"@react-spectrum/s2/Link":"42COX","@react-spectrum/s2/LinkButton":"gZHck","@react-spectrum/s2/Menu":"1F0Yz","@react-spectrum/s2/icons/Microphone":"bcho2","./loader/react":"b3f74","@react-spectrum/s2/icons/Add":"brWL3","@react-spectrum/s2/Popover":"62puW","react-stately/useTokenFieldState":"bUglb","./PromptFieldContainer":"6FR4V","./Chat":"dQLun","react-aria-components/slots":"bA6Cz","@react-spectrum/s2/icons/ArrowUpSend":"hsWhe","react-aria/useTokenField":"YD96B","@react-spectrum/s2/icons/StopProcessing":"6D2fm","@react-spectrum/s2/ToggleButton":"6wKQe","react-aria-components/TokenField":[["Token","jdTUJ"],["TokenField","jdTUJ"],["TokenInput","jdTUJ"],["tokenFieldPositionToDOMRange","YD96B"]],"@react-spectrum/s2/Tooltip":"aI82z","react-stately/useControlledState":"iZt2P","react-aria/private/utils/useEffectEvent":"fVIcf","./useDOMRef":"dTAFx","react-aria/useFocusWithin":"lT0uI","react-aria/useKeyboard":"jUMGt","react-aria/I18nProvider":"l34Wn","react-aria/useLocalizedStringFormatter":"4LM0k","./useVoiceInput":"le7XT","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fdK4a":[function() {},{}],"2vhrH":[function() {},{}],"hUt7M":[function() {},{}],"aN5wx":[function() {},{}],"6tkC4":[function() {},{}],"krggG":[function() {},{}],"8AmI3":[function() {},{}],"7kGDo":[function() {},{}],"lKVd4":[function() {},{}],"6EVOZ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AttachmentList", ()=>AttachmentList);
parcelHelpers.export(exports, "Attachment", ()=>Attachment);
/**
 * AttachmentPreview renders a preview of a file attachment.
 */ parcelHelpers.export(exports, "AttachmentPreview", ()=>AttachmentPreview);
var _jsxRuntime = require("react/jsx-runtime");
var _alertTriangle = require("@react-spectrum/s2/icons/AlertTriangle");
var _alertTriangleDefault = parcelHelpers.interopDefault(_alertTriangle);
var _audioWave = require("@react-spectrum/s2/icons/AudioWave");
var _audioWaveDefault = parcelHelpers.interopDefault(_audioWave);
var _button = require("react-aria-components/Button");
var _chevronLeft = require("@react-spectrum/s2/icons/ChevronLeft");
var _chevronLeftDefault = parcelHelpers.interopDefault(_chevronLeft);
var _chevronRight = require("@react-spectrum/s2/icons/ChevronRight");
var _chevronRightDefault = parcelHelpers.interopDefault(_chevronRight);
var _content = require("@react-spectrum/s2/Content");
var _react = require("react");
var _cross = require("../ui-icons/Cross");
var _crossDefault = parcelHelpers.interopDefault(_cross);
var _slots = require("react-aria-components/slots");
var _file = require("@react-spectrum/s2/icons/File");
var _fileDefault = parcelHelpers.interopDefault(_file);
var _fileText = require("@react-spectrum/s2/icons/FileText");
var _fileTextDefault = parcelHelpers.interopDefault(_fileText);
var _image = require("@react-spectrum/s2/Image");
var _imageCoordinator = require("@react-spectrum/s2/ImageCoordinator");
var _image1 = require("@react-spectrum/s2/icons/Image");
var _imageDefault = parcelHelpers.interopDefault(_image1);
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _mergeStyles = require("@react-spectrum/s2/mergeStyles");
var _play = require("@react-spectrum/s2/icons/Play");
var _playDefault = parcelHelpers.interopDefault(_play);
var _pressScale = require("@react-spectrum/s2/pressScale");
var _progressCircle = require("@react-spectrum/s2/ProgressCircle");
var _tagGroup = require("react-aria-components/TagGroup");
var _text = require("@react-spectrum/s2/Text");
var _useDOMRef = require("./useDOMRef");
var _i18Nprovider = require("react-aria/I18nProvider");
var _useLocalizedStringFormatter = require("react-aria/useLocalizedStringFormatter");
const controlSizeM = {
    default: 32,
    size: {
        XS: 20,
        S: 24,
        L: 40,
        XL: 48
    }
};
const closeButton = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf17';
    else rules += ' _Le17';
    rules += ' Oh17';
    rules += ' OlOVIhfcebS7sd17';
    rules += ' OlOVIhfcebS7sd17';
    rules += ' _Mc17';
    rules += ' _Kd17';
    rules += ' sd17';
    rules += ' eb17';
    rules += ' _Ca17';
    if (props.size === "XL") rules += ' ZBaYFfc17';
    else if (props.size === "L") rules += ' Z3JjxG17';
    else if (props.size === "S") rules += ' ZCe2o8c17';
    else if (props.size === "XS") rules += ' ZifsFYc17';
    else rules += ' Z4dY0ec17';
    if (props.size === "XL") rules += ' FBaYFfc17';
    else if (props.size === "L") rules += ' F3JjxG17';
    else if (props.size === "S") rules += ' FCe2o8c17';
    else if (props.size === "XS") rules += ' FifsFYc17';
    else rules += ' F4dY0ec17';
    rules += ' _va17';
    rules += ' og17';
    rules += ' ng17';
    rules += ' kg17';
    rules += ' jg17';
    rules += ' Td17';
    rules += ' Qd17';
    rules += ' Sd17';
    rules += ' Rd17';
    rules += ' _je17';
    rules += ' Yd17';
    rules += ' Xb17';
    rules += ' _2b17';
    if (props.isPressed) rules += ' gE17';
    else if (props.isFocusVisible) rules += ' gE17';
    else if (props.isHovered) rules += ' gE17';
    else rules += ' gF17';
    rules += ' glOVIhfc8qxrJ17';
    rules += ' glOVIhfc8qxrJ17';
    if (props.isDisabled) rules += ' pp17';
    else {
        if (props.isPressed) rules += ' po17';
        else if (props.isFocusVisible) rules += ' po17';
        else if (props.isHovered) rules += ' po17';
        else rules += ' pt17';
    }
    if (props.isDisabled) rules += ' plOVIhfcYMPQu17';
    else rules += ' plOVIhfc6LxY917';
    if (props.isDisabled) rules += ' plOVIhfcYMPQu17';
    else rules += ' plOVIhfc6LxY917';
    rules += ' -_8sjo0b-t5ZbAob17';
    rules += ' __ca17';
    return rules;
};
const onlyPreview = ':not(:has([data-slot=content])):not(:has([data-slot=preview]))';
const container = {
    backgroundColor: {
        default: "[light-dark(rgb(from black r g b / 3%), rgb(from white r g b / 3%))]",
        isInvalid: 'red-700/8',
        forcedColors: 'ButtonFace'
    }
};
const attachmentCard = function anonymous(props) {
    let rules = " ";
    if (props.isInvalid) rules += ' gUr35D17';
    else rules += ' gjTtYy17';
    rules += ' glOVIhfc8qxrJ17';
    rules += ' glOVIhfc8qxrJ17';
    rules += ' sd17';
    rules += ' _tc17';
    rules += ' _Pc17';
    rules += ' o5NLVAe17';
    rules += ' n5NLVAe17';
    rules += ' k5NLVAe17';
    rules += ' j5NLVAe17';
    rules += ' _Lf17';
    rules += ' _Mb17';
    rules += ' _Ka17';
    if (props.isInvalid) {
        rules += ' ONitqwc17';
        rules += ' OlOVIhfcqkp3K17';
        rules += ' OlOVIhfcqkp3K17';
    } else {
        if (props.isLoading) rules += ' Olhzxod17';
        else rules += ' OjTtYy17';
        rules += ' OlOVIhfcCp4usd17';
        rules += ' OlOVIhfcCp4usd17';
    }
    rules += ' _yb17';
    rules += ' ri17';
    rules += ' Yd17';
    rules += ' Xb17';
    rules += ' _2b17';
    rules += ' uk17';
    rules += ' ucJ9TBTb17';
    rules += ' ud3Euai17';
    rules += ' uea17';
    rules += ' ugb17';
    rules += ' uhd17';
    rules += ' uje17';
    rules += ' u2NhKxcl17';
    rules += ' uic17';
    rules += ' _Nb17';
    rules += ' Pb17';
    rules += ' _qc17';
    rules += ' __ca17';
    if (props.size === "XL") rules += ' FF3XZgc17';
    else if (props.size === "L") rules += ' Fw8KVkb17';
    else if (props.size === "M") rules += ' FLy9tge17';
    else if (props.size === "S") rules += ' F35gdtc17';
    else if (props.size === "XS") rules += ' Fekq6H17';
    else rules += ' FLy9tge17';
    rules += ' Za17';
    rules += ' ZimTOed17';
    rules += ' fimTOea17';
    if (props.size === "XL") rules += ' -dAV6Jb-Th17';
    else if (props.size === "L") rules += ' -dAV6Jb-Tg17';
    else if (props.size === "M") rules += ' -dAV6Jb-Tf17';
    else if (props.size === "S") rules += ' -dAV6Jb-Te17';
    else if (props.size === "XS") rules += ' -dAV6Jb-Tt17';
    rules += ' -dAV6Jb-imTOeTd17';
    rules += ' eb17';
    rules += ' -jXLvjd-T5gMYHd17';
    rules += ' -iXLvjd-S5gMYHd17';
    rules += ' TxTaQHd17';
    rules += ' QxTaQHd17';
    rules += ' S0SaQHd17';
    rules += ' R0SaQHd17';
    rules += ' _oa17';
    rules += ' _CimTOea17';
    if (props.size === "XL") rules += ' -W1Fnv-F3JjxG17';
    else if (props.size === "L") rules += ' -W1Fnv-FLhWnQb17';
    else if (props.size === "M") rules += ' -W1Fnv-F4dY0ec17';
    else if (props.size === "S") rules += ' -W1Fnv-FAdaW3b17';
    else if (props.size === "XS") rules += ' -W1Fnv-FCe2o8c17';
    rules += ' -W1Fnv-imTOeFb17';
    rules += ' -mLsVP-okNNfn17';
    rules += ' -mLsVP-imTOeo5NLVAe17';
    return rules;
};
const attachmentTitle = function anonymous(props) {
    let rules = " ";
    rules += ' uk17';
    rules += ' ucJ9TBTb17';
    rules += ' ud3Euai17';
    rules += ' uea17';
    rules += ' ugb17';
    rules += ' uhd17';
    rules += ' uje17';
    rules += ' u2NhKxcl17';
    rules += ' uic17';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e17';
        rules += ' vFHT6Dd17';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d17';
        rules += ' vFHT6Dd17';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-c17';
        rules += ' vFHT6Dd17';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b17';
        rules += ' vFHT6Dd17';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-b17';
        rules += ' vFHT6Dd17';
    }
    rules += ' xd17';
    rules += ' _xa17';
    rules += ' xX0cczbc17';
    rules += ' _xX0cczba17';
    rules += ' xfd17';
    rules += ' _xfa17';
    rules += ' xfX0cczbc17';
    rules += ' _xfX0cczba17';
    rules += ' _Fd17';
    rules += ' _FnuYUweb17';
    rules += ' po17';
    rules += ' __Ea17';
    rules += ' sa17';
    rules += ' __aa17';
    rules += ' __b2mU17';
    rules += ' zn9DOs17';
    rules += ' yn9DOs17';
    rules += ' Bn9DOs17';
    rules += ' An9DOs17';
    return rules;
};
const attachmentDescription = function anonymous(props) {
    let rules = " ";
    rules += ' uk17';
    rules += ' ucJ9TBTb17';
    rules += ' ud3Euai17';
    rules += ' uea17';
    rules += ' ugb17';
    rules += ' uhd17';
    rules += ' uje17';
    rules += ' u2NhKxcl17';
    rules += ' uic17';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-d17';
        rules += ' vFHT6Dd17';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-c17';
        rules += ' vFHT6Dd17';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-b17';
        rules += ' vFHT6Dd17';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-a17';
        rules += ' vFHT6Dd17';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a17';
        rules += ' vFHT6Dd17';
    }
    rules += ' xb17';
    rules += ' _xa17';
    rules += ' _Fb17';
    rules += ' _FnuYUwec17';
    rules += ' pt17';
    rules += ' __Ea17';
    rules += ' sa17';
    rules += ' __aa17';
    rules += ' __b2mU17';
    rules += ' z9u7zPc17';
    rules += ' y9u7zPc17';
    rules += ' B9u7zPc17';
    rules += ' A9u7zPc17';
    return rules;
};
const attachmentContent = " se17 DfQhdHc17 CfLapxc17 qR3ltQc17 _ub17 Na17 ea17 _ch17 S5gMYHd17 Sbd17 R69YG2b17 Rkd17";
const CloseButton = function CloseButton(props) {
    let ref = (0, _react.useRef)(null);
    // oxlint-disable react/react-compiler
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
        ...props,
        ref: ref,
        slot: "remove",
        style: (0, _pressScale.pressScale)(ref, {}),
        className: (renderProps)=>(0, _mergeStyles.mergeStyles)(closeButton({
                ...renderProps,
                size: props.size || 'M'
            }), props.styles),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crossDefault.default), {
            size: "M"
        })
    });
// oxlint-enable react/react-compiler
};
const flexRow = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
};
const tagListStyles = " sd17 _tc17 eb17 _ub17 UH5kTnc17 qH5kTnc17 _Na17 Pb17 -dLGswc-Qlsn9h3TDrc17 __Rd17 Tf17 Qf17 Sf17 Rf17 JuTsfBd17 GuTsfBd17 IuTsfBd17 HuTsfBd17 _oa17 _TB1JKEb17 _TQlsn9q4iaqb17 __OB1JKEb17 __OQlsn9q4iaqb17";
const buttonFade = "LgvjGd";
const carouselNavButtonStyles = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf17';
    else rules += ' _Le17';
    rules += ' Oh17';
    rules += ' OlOVIhfcebS7sd17';
    rules += ' OlOVIhfcebS7sd17';
    rules += ' _Mc17';
    rules += ' _Kd17';
    rules += ' sd17';
    rules += ' eb17';
    rules += ' _Ca17';
    if (props.size === "XL") rules += ' ZBaYFfc17';
    else if (props.size === "L") rules += ' Z3JjxG17';
    else if (props.size === "S") rules += ' ZCe2o8c17';
    else if (props.size === "XS") rules += ' ZifsFYc17';
    else rules += ' Z4dY0ec17';
    if (props.size === "XL") rules += ' FBaYFfc17';
    else if (props.size === "L") rules += ' F3JjxG17';
    else if (props.size === "S") rules += ' FCe2o8c17';
    else if (props.size === "XS") rules += ' FifsFYc17';
    else rules += ' F4dY0ec17';
    rules += ' _va17';
    rules += ' og17';
    rules += ' ng17';
    rules += ' kg17';
    rules += ' jg17';
    rules += ' _je17';
    rules += ' Yd17';
    rules += ' Xb17';
    rules += ' _2b17';
    if (props.isPressed) rules += ' gg17';
    else if (props.isFocusVisible) rules += ' gg17';
    else if (props.isHovered) rules += ' gg17';
    else rules += ' gf17';
    rules += ' glOVIhfc8qxrJ17';
    rules += ' glOVIhfc8qxrJ17';
    if (props.isDisabled) rules += ' pp17';
    else {
        if (props.isPressed) rules += ' po17';
        else if (props.isFocusVisible) rules += ' po17';
        else if (props.isHovered) rules += ' po17';
        else rules += ' pt17';
    }
    if (props.isDisabled) rules += ' plOVIhfcYMPQu17';
    else rules += ' plOVIhfc6LxY917';
    if (props.isDisabled) rules += ' plOVIhfcYMPQu17';
    else rules += ' plOVIhfc6LxY917';
    rules += ' -_8sjo0b-t5ZbAob17';
    if (props.direction === "rtl") {
        rules += ' -Z4Pn4c-a17';
        rules += ' __Ha17';
    }
    if (props.direction === "rtl") {
        rules += ' -_04Pn4c-a17';
        rules += ' __Ha17';
    }
    rules += ' __ca17';
    rules += ' _Pa17';
    rules += ' _9c17';
    if (props.side === "end") rules += ' _zr17';
    if (props.isFocusVisible) rules += ' _Ib17';
    else rules += ' _Ia17';
    if (props.isFocusVisible) rules += ' _6c17';
    else rules += ' _6b17';
    if (props.isFocusVisible) rules += ' _gh3TDrc17';
    else rules += ' _gQlsn9DhTWGd17';
    rules += ' _ewcNfn17';
    rules += ' _hb17';
    rules += ' _fb17';
    if (props.side === "end") rules += ' __dd17';
    else if (props.side === "start") rules += ' __dc17';
    return rules;
};
function CarouselNavButton({ side, ...otherProps }) {
    let ref = (0, _react.useRef)(null);
    let { direction } = (0, _i18Nprovider.useLocale)();
    let stringFormatter = (0, _useLocalizedStringFormatter.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/ai');
    let Icon = side === 'start' ? (0, _chevronLeftDefault.default) : (0, _chevronRightDefault.default);
    // oxlint-disable react/react-compiler
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
        ...otherProps,
        ref: ref,
        "aria-label": stringFormatter.format(side === 'start' ? 'attachmentlist.previousAttachments' : 'attachmentlist.nextAttachments'),
        style: (0, _pressScale.pressScale)(ref, {
            animationTimeline: '--carousel-scroll',
            animationRange: side === 'start' ? '0px 32px' : 'calc(100% - 32px) 100%'
        }),
        className: (renderProps)=>carouselNavButtonStyles({
                ...renderProps,
                direction,
                side
            }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {})
    });
// oxlint-enable react/react-compiler
}
const AttachmentList = (0, _react.forwardRef)(function AttachmentList(props, ref) {
    let { styles, items, children, dependencies, ...otherProps } = props;
    let domRef = (0, _useDOMRef.useDOMRef)(ref);
    let scrollRef = (0, _react.useRef)(null);
    let { direction } = (0, _i18Nprovider.useLocale)();
    let scroll = (dir)=>{
        let el = scrollRef.current;
        if (!el) return;
        // RTL flips the scroll direction convention; flip the sign to match.
        let sign = direction === 'rtl' ? -1 : 1;
        el.scrollTo({
            left: Math.max(0, Math.min(el.scrollWidth - el.clientWidth, el.scrollLeft + sign * dir * (el.clientWidth - 128))),
            behavior: 'smooth'
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.TagGroup), {
        ...otherProps,
        className: (0, _mergeStyles.mergeStyles)(" sd17 _tc17 eb17 UH5kTnc17 qH5kTnc17 _Pc17", styles),
        style: {
            timelineScope: '--carousel-scroll'
        },
        ref: domRef,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(CarouselNavButton, {
                side: "start",
                onPress: ()=>scroll(-1)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.TagList), {
                ref: scrollRef,
                items: items,
                dependencies: dependencies,
                className: tagListStyles + ' ' + "_6nGYGb" + ' ' + "NcghRd",
                style: {
                    scrollTimelineName: '--carousel-scroll',
                    scrollTimelineAxis: 'inline'
                },
                children: children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(CarouselNavButton, {
                side: "end",
                onPress: ()=>scroll(1)
            })
        ]
    });
});
const tagStyles = function anonymous(props) {
    let rules = " ";
    rules += ' _va17';
    rules += ' _ua17';
    rules += ' _Pc17';
    if (props.isFocusVisible) rules += ' _Lf17';
    else rules += ' _Le17';
    rules += ' Oh17';
    rules += ' OlOVIhfcebS7sd17';
    rules += ' OlOVIhfcebS7sd17';
    rules += ' _Mc17';
    rules += ' _Kd17';
    rules += ' o5NLVAe17';
    rules += ' n5NLVAe17';
    rules += ' k5NLVAe17';
    rules += ' j5NLVAe17';
    rules += ' L7iLLKb17';
    rules += ' __Pd17';
    return rules;
};
function AttachmentCard({ size = 'M', isInvalid = false, isLoading = false, children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        "aria-invalid": isInvalid || undefined,
        className: attachmentCard({
            size,
            isInvalid,
            isLoading
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slots.Provider), {
            values: [
                [
                    (0, _image.ImageContext),
                    {
                        slots: {
                            thumbnail: {
                                alt: '',
                                styles: " _Pc17 _dc17 _va17 _Ob17 _4c17 ZSWESAd17 FSWESAd17 oWMskE17 nWMskE17 kWMskE17 jWMskE17 _Hb17 _Lf17 _Mb17 OcDztlc17 _Ka17"
                            }
                        }
                    }
                ],
                [
                    (0, _text.TextContext),
                    {
                        slots: {
                            [(0, _slots.DEFAULT_SLOT)]: {},
                            title: {
                                styles: attachmentTitle({
                                    size
                                })
                            },
                            description: {
                                styles: attachmentDescription({
                                    size
                                })
                            }
                        }
                    }
                ],
                [
                    (0, _content.ContentContext),
                    {
                        styles: attachmentContent,
                        // @ts-ignore
                        'data-slot': 'content'
                    }
                ]
            ],
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageCoordinator.ImageCoordinator), {
                children: children
            })
        })
    });
}
const Attachment = /*#__PURE__*/ (0, _react.forwardRef)(function Attachment(props, ref) {
    let { id, textValue, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby, 'aria-describedby': ariaDescribedby, styles, isInvalid, children, size = 'M' } = props;
    let domRef = (0, _useDOMRef.useDOMRef)(ref);
    let isLoading = props.uploadProgress != null && props.uploadProgress < 100;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.Tag), {
        id: id,
        textValue: textValue,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        "aria-describedby": ariaDescribedby,
        ref: domRef,
        className: (renderProps)=>(0, _mergeStyles.mergeStyles)(tagStyles({
                ...renderProps
            }), styles),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AttachmentCard, {
                size: size,
                isInvalid: isInvalid,
                isLoading: isLoading,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AttachmentPreviewContext.Provider, {
                    value: {
                        isInvalid: !!isInvalid,
                        uploadProgress: props.uploadProgress ?? 100,
                        size
                    },
                    children: typeof children === 'function' ? children({
                        size
                    }) : children
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " _Pa17 Wr17 _zr17 _ZpV7wqc17",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CloseButton, {
                    size: "XS"
                })
            })
        ]
    });
});
const attachmentPreviewWrapper = " Z4dY0ec17 F4dY0ec17 sd17 eb17 _Ca17";
const AttachmentPreviewContext = /*#__PURE__*/ (0, _react.createContext)({
    isInvalid: false,
    uploadProgress: 100,
    size: 'S'
});
function AttachmentPreview(props) {
    let { mimeType, ...otherProps } = props;
    let { isInvalid, uploadProgress, size } = (0, _react.useContext)(AttachmentPreviewContext);
    let stringFormatter = (0, _useLocalizedStringFormatter.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/ai');
    if (isInvalid) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: attachmentPreviewWrapper,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AlertTriangleIcon, {
            size: size
        })
    });
    if (uploadProgress < 100) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: attachmentPreviewWrapper,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
            "aria-label": stringFormatter.format('promptfield.uploading'),
            value: uploadProgress,
            size: "S"
        })
    });
    if (otherProps.src) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _image.Image), {
        ...otherProps,
        slot: "thumbnail"
    });
    if (mimeType.startsWith('audio/')) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: attachmentPreviewWrapper,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _audioWaveDefault.default), {})
    });
    if (mimeType.startsWith('video/')) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: attachmentPreviewWrapper,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _playDefault.default), {})
    });
    if (mimeType.startsWith('image/')) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: attachmentPreviewWrapper,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageDefault.default), {})
    });
    if (mimeType.startsWith('text/')) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: attachmentPreviewWrapper,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fileTextDefault.default), {})
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: attachmentPreviewWrapper,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fileDefault.default), {})
    });
}
function AlertTriangleIcon({ size }) {
    switch(size){
        case 'XS':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertTriangleDefault.default), {
                styles: " -_8sjo0b-tq17 ZokSYvd17 FokSYvd17"
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertTriangleDefault.default), {
                styles: " -_8sjo0b-tq17 ZxhYlec17 FxhYlec17"
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertTriangleDefault.default), {
                styles: " -_8sjo0b-tq17 Zd60gf17 Fd60gf17"
            });
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertTriangleDefault.default), {
                styles: " -_8sjo0b-tq17 ZifsFYc17 FifsFYc17"
            });
        case 'XL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertTriangleDefault.default), {
                styles: " -_8sjo0b-tq17 ZY4FjNb17 FY4FjNb17"
            });
    }
}

},{"0":"aYthk","1":"bg06X","2":"bEwk7","3":"5esbt","4":"9oi1J","5":"jPE22","6":"1NRJE","7":"d5fCr","8":"7D5uQ","9":"9Q1oN","10":"4RV1V","11":"9jBTV","12":"cjQLv","13":"kWYJR","14":"l9l6s","15":"6YtUV","16":"4EsSe","17":"bd5KJ","18":"1OGcF","19":"4V5ID","20":"iXqLq","21":"8zu9M","22":"cHsOY","23":"6D0xy","react/jsx-runtime":"2Is6Z","@react-spectrum/s2/icons/AlertTriangle":"jyuVv","@react-spectrum/s2/icons/AudioWave":"jF3g4","react-aria-components/Button":"9G5XO","@react-spectrum/s2/icons/ChevronLeft":"5jnVm","@react-spectrum/s2/icons/ChevronRight":"kmqkh","@react-spectrum/s2/Content":"10r6w","react":"a1TxN","../ui-icons/Cross":"1Ddt1","react-aria-components/slots":"bA6Cz","@react-spectrum/s2/icons/File":"99rjs","@react-spectrum/s2/icons/FileText":"8dGEU","@react-spectrum/s2/Image":"4LTiE","@react-spectrum/s2/ImageCoordinator":"3PQZz","@react-spectrum/s2/icons/Image":"ld4zI","../intl/*.json":"1VKfy","@react-spectrum/s2/mergeStyles":"8g9no","@react-spectrum/s2/icons/Play":"2qWTs","@react-spectrum/s2/pressScale":"8Ufux","@react-spectrum/s2/ProgressCircle":"dztOy","react-aria-components/TagGroup":"dIN55","@react-spectrum/s2/Text":"10r6w","./useDOMRef":"dTAFx","react-aria/I18nProvider":"l34Wn","react-aria/useLocalizedStringFormatter":"4LM0k","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aYthk":[function() {},{}],"bg06X":[function() {},{}],"bEwk7":[function() {},{}],"5esbt":[function() {},{}],"9oi1J":[function() {},{}],"jPE22":[function() {},{}],"1NRJE":[function() {},{}],"d5fCr":[function() {},{}],"7D5uQ":[function() {},{}],"9Q1oN":[function() {},{}],"4RV1V":[function() {},{}],"9jBTV":[function() {},{}],"cjQLv":[function() {},{}],"kWYJR":[function() {},{}],"l9l6s":[function() {},{}],"6YtUV":[function() {},{}],"4EsSe":[function() {},{}],"bd5KJ":[function() {},{}],"1OGcF":[function() {},{}],"4V5ID":[function() {},{}],"iXqLq":[function() {},{}],"8zu9M":[function() {},{}],"cHsOY":[function() {},{}],"6D0xy":[function() {},{}],"1Ddt1":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Cross);
var _jsxRuntime = require("react/jsx-runtime");
var _s2CrossSize200Svg = require("./S2_CrossSize200.svg");
var _s2CrossSize200SvgDefault = parcelHelpers.interopDefault(_s2CrossSize200Svg);
var _s2CrossSize100Svg = require("./S2_CrossSize100.svg");
var _s2CrossSize100SvgDefault = parcelHelpers.interopDefault(_s2CrossSize100Svg);
var _s2CrossSize75Svg = require("./S2_CrossSize75.svg");
var _s2CrossSize75SvgDefault = parcelHelpers.interopDefault(_s2CrossSize75Svg);
var _s2CrossSize300Svg = require("./S2_CrossSize300.svg");
var _s2CrossSize300SvgDefault = parcelHelpers.interopDefault(_s2CrossSize300Svg);
var _s2CrossSize400Svg = require("./S2_CrossSize400.svg");
var _s2CrossSize400SvgDefault = parcelHelpers.interopDefault(_s2CrossSize400Svg);
var _s2CrossSize500Svg = require("./S2_CrossSize500.svg");
var _s2CrossSize500SvgDefault = parcelHelpers.interopDefault(_s2CrossSize500Svg);
var _s2CrossSize600Svg = require("./S2_CrossSize600.svg");
var _s2CrossSize600SvgDefault = parcelHelpers.interopDefault(_s2CrossSize600Svg);
let styles = function anonymous(props) {
    let rules = " ";
    if (props.size === "S") rules += ' Z7wvBT17';
    else if (props.size === "XXXXL") rules += ' ZxhYlec17';
    else if (props.size === "XXXL") rules += ' ZokSYvd17';
    else if (props.size === "XXL") rules += ' ZAMzobb17';
    else if (props.size === "XL") rules += ' ZAMzobb17';
    else if (props.size === "L") rules += ' ZDldWXb17';
    else if (props.size === "M") rules += ' Z7wvBT17';
    if (props.size === "S") rules += ' F7wvBT17';
    else if (props.size === "XXXXL") rules += ' FxhYlec17';
    else if (props.size === "XXXL") rules += ' FokSYvd17';
    else if (props.size === "XXL") rules += ' FAMzobb17';
    else if (props.size === "XL") rules += ' FAMzobb17';
    else if (props.size === "L") rules += ' FDldWXb17';
    else if (props.size === "M") rules += ' F7wvBT17';
    return rules;
};
function Cross(props) {
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CrossSize100SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CrossSize200SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'XL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CrossSize300SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'XXL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CrossSize400SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'XXXL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CrossSize500SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'XXXXL':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CrossSize600SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2CrossSize75SvgDefault.default), {
                ...otherProps,
                className: (otherProps.className || '') + styles({
                    size
                })
            });
    }
}

},{"0":"LZYwD","react/jsx-runtime":"2Is6Z","./S2_CrossSize200.svg":"99wTn","./S2_CrossSize100.svg":"hM60C","./S2_CrossSize75.svg":"5kNei","./S2_CrossSize300.svg":"jPy5h","./S2_CrossSize400.svg":"RQBad","./S2_CrossSize500.svg":"15zlN","./S2_CrossSize600.svg":"2zXSe","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"LZYwD":[function() {},{}],"99wTn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CrossSize200 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "m6.289 5 2.922-2.923A.912.912 0 0 0 7.922.788L5 3.711 2.078.788a.912.912 0 0 0-1.29 1.29L3.712 5 .789 7.923a.912.912 0 0 0 1.289 1.289L5 6.289l2.922 2.923a.91.91 0 0 0 1.29 0 .91.91 0 0 0 0-1.29z"
        })
    });
exports.default = SvgS2CrossSize200;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hM60C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CrossSize100 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 8,
        viewBox: "0 0 8 8",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "m5.238 4 2.456-2.456A.876.876 0 0 0 6.457.306L4 2.762 1.543.306A.875.875 0 1 0 .306 1.544L2.762 4 .306 6.456a.876.876 0 0 0 1.237 1.238L4 5.238l2.457 2.456a.871.871 0 0 0 1.237 0 .876.876 0 0 0 0-1.238z"
        })
    });
exports.default = SvgS2CrossSize100;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5kNei":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CrossSize75 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 8,
        viewBox: "0 0 8 8",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "m5.188 4 2.14-2.14A.84.84 0 0 0 6.14.671L4 2.812 1.86.672A.84.84 0 0 0 .672 1.859L2.812 4 .672 6.14A.84.84 0 0 0 1.86 7.329L4 5.188l2.14 2.14a.84.84 0 0 0 1.188 0 .84.84 0 0 0 0-1.187z"
        })
    });
exports.default = SvgS2CrossSize75;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jPy5h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CrossSize300 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "m7.342 6 3.396-3.396a.95.95 0 1 0-1.342-1.342L6 4.658 2.604 1.262a.95.95 0 1 0-1.343 1.342L4.659 6 1.262 9.396a.95.95 0 1 0 1.343 1.342L6 7.342l3.396 3.396a.946.946 0 0 0 1.342.001.95.95 0 0 0 0-1.343z"
        })
    });
exports.default = SvgS2CrossSize300;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"RQBad":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CrossSize400 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "m7.398 6 3.932-3.932A.989.989 0 1 0 9.932.67L6 4.602 2.068.67A.988.988 0 1 0 .67 2.068L4.602 6 .67 9.932a.989.989 0 1 0 1.398 1.398L6 7.398l3.932 3.932a.985.985 0 0 0 1.398 0 .99.99 0 0 0 0-1.398z"
        })
    });
exports.default = SvgS2CrossSize400;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"15zlN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CrossSize500 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        viewBox: "0 0 14 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "m8.457 7 4.54-4.54a1.031 1.031 0 0 0-1.457-1.456L7 5.543l-4.54-4.54a1.03 1.03 0 0 0-1.457 1.458L5.543 7l-4.54 4.54a1.031 1.031 0 0 0 1.457 1.456L7 8.457l4.54 4.54a1.027 1.027 0 0 0 1.457 0 1.03 1.03 0 0 0 0-1.458z"
        })
    });
exports.default = SvgS2CrossSize500;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2zXSe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgS2CrossSize600 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, #222)",
            d: "m9.518 8 5.23-5.229a1.073 1.073 0 0 0-1.519-1.517L8 6.483l-5.229-5.23a1.073 1.073 0 0 0-1.518 1.518l5.23 5.23-5.23 5.228a1.073 1.073 0 0 0 1.518 1.518l5.23-5.229 5.228 5.23a1.073 1.073 0 1 0 1.518-1.519z"
        })
    });
exports.default = SvgS2CrossSize600;

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1VKfy":[function(require,module,exports,__globalThis) {
const _temp0 = require("a3e27653f77cde5f");
const _temp1 = require("6a15e31a5146a20a");
const _temp2 = require("e1c74927079dd600");
const _temp3 = require("83be9962b856c4ce");
const _temp4 = require("b27ebc2917e4d1bb");
const _temp5 = require("3710ce46436ba431");
const _temp6 = require("3e45413009941737");
const _temp7 = require("a49cca0ec7ca2bd");
const _temp8 = require("9f96845a35d2b9cd");
const _temp9 = require("f4a4ad667326f416");
const _temp10 = require("96fac3cae74f9ea7");
const _temp11 = require("6db7c9c60e73cbb");
const _temp12 = require("fd59f6f5a56c390c");
const _temp13 = require("41609a955bf1397");
const _temp14 = require("dee1bb2975d7f83d");
const _temp15 = require("4a698b1527c43995");
const _temp16 = require("583c104b2c68e2");
const _temp17 = require("ab94596d22637ab6");
const _temp18 = require("2ca40e722fdcef67");
const _temp19 = require("e9d869bb95524b66");
const _temp20 = require("a89696f417f618d");
const _temp21 = require("db8321b07be4a245");
const _temp22 = require("fdd63903e35453ef");
const _temp23 = require("d12df30b96143b6");
const _temp24 = require("89bc115d22be7b76");
const _temp25 = require("7a6e11a9ea63a9be");
const _temp26 = require("78d4f89c5e13060c");
const _temp27 = require("e9a46c39580e2ed8");
const _temp28 = require("b1c857ba06f6c80b");
const _temp29 = require("fd26449883db6a04");
const _temp30 = require("43137623030f0125");
const _temp31 = require("94eed45d0f4dbfb9");
const _temp32 = require("9d7cc6b536aa3cd6");
const _temp33 = require("4beb7a180338c93b");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"a3e27653f77cde5f":"bD7KO","6a15e31a5146a20a":"68146","e1c74927079dd600":"2bvQi","83be9962b856c4ce":"aF9ok","b27ebc2917e4d1bb":"97eyW","3710ce46436ba431":"kjwn0","3e45413009941737":"cvHJO","a49cca0ec7ca2bd":"gpCiC","9f96845a35d2b9cd":"bKwsP","f4a4ad667326f416":"coHtp","96fac3cae74f9ea7":"f5EHp","6db7c9c60e73cbb":"6fRTN","fd59f6f5a56c390c":"7D8WV","41609a955bf1397":"1AJA5","dee1bb2975d7f83d":"l9XUP","4a698b1527c43995":"5RsVx","583c104b2c68e2":"7rpE2","ab94596d22637ab6":"fCVgw","2ca40e722fdcef67":"4mahk","e9d869bb95524b66":"3jGMD","a89696f417f618d":"8nrUh","db8321b07be4a245":"euAiE","fdd63903e35453ef":"kL0U6","d12df30b96143b6":"6mKOW","89bc115d22be7b76":"hEasl","7a6e11a9ea63a9be":"jCM51","78d4f89c5e13060c":"huPJx","e9a46c39580e2ed8":"cbUCb","b1c857ba06f6c80b":"3xyfS","fd26449883db6a04":"4WAIL","43137623030f0125":"1AfT8","94eed45d0f4dbfb9":"h1OcF","9d7cc6b536aa3cd6":"hcq9C","4beb7a180338c93b":"32stW"}],"bD7KO":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `\u{631}\u{633}\u{627}\u{644}\u{629} \u{62C}\u{62F}\u{64A}\u{62F}\u{629}`,
    "chat.scrollToBottom": `\u{627}\u{644}\u{62A}\u{645}\u{631}\u{64A}\u{631} \u{625}\u{644}\u{649} \u{627}\u{644}\u{623}\u{633}\u{641}\u{644}`,
    "messagefeedback.thumbDown": `\u{627}\u{633}\u{62A}\u{62C}\u{627}\u{628}\u{629}  \u{633}\u{64A}\u{626}\u{629}`,
    "messagefeedback.thumbUp": `\u{627}\u{633}\u{62A}\u{62C}\u{627}\u{628}\u{629} \u{62C}\u{64A}\u{62F}\u{629}`,
    "promptfield.aiDisclaimer": `\u{64A}\u{62A}\u{645} \u{62A}\u{648}\u{644}\u{64A}\u{62F} \u{627}\u{644}\u{631}\u{62F}\u{648}\u{62F} \u{628}\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{627}\u{644}\u{630}\u{643}\u{627}\u{621} \u{627}\u{644}\u{627}\u{635}\u{637}\u{646}\u{627}\u{639}\u{64A}\u{60C} \u{648}\u{642}\u{62F} \u{62A}\u{643}\u{648}\u{646} \u{63A}\u{64A}\u{631} \u{62F}\u{642}\u{64A}\u{642}\u{629}. \u{62A}\u{62D}\u{642}\u{642} \u{642}\u{628}\u{644} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645}.`,
    "promptfield.aiUserGuidlines": `\u{625}\u{631}\u{634}\u{627}\u{62F}\u{627}\u{62A} \u{645}\u{633}\u{62A}\u{62E}\u{62F}\u{645}\u{64A} \u{627}\u{644}\u{630}\u{643}\u{627}\u{621} \u{627}\u{644}\u{627}\u{635}\u{637}\u{646}\u{627}\u{639}\u{64A}`,
    "promptfield.attachments": `\u{627}\u{644}\u{645}\u{644}\u{62D}\u{642}\u{627}\u{62A}`,
    "promptfield.insertButton": `\u{62C}\u{645}\u{639}`,
    "promptfield.label": `\u{627}\u{644}\u{645}\u{648}\u{636}\u{648}\u{639}`,
    "promptfield.placeholder": `\u{647}\u{644} \u{623}\u{646}\u{62A} \u{645}\u{633}\u{62A}\u{639}\u{62F} \u{644}\u{644}\u{628}\u{62F}\u{621}\u{61F} \u{627}\u{637}\u{631}\u{62D} \u{633}\u{624}\u{627}\u{644}\u{64B}\u{627}\u{60C} \u{623}\u{648} \u{634}\u{627}\u{631}\u{643} \u{641}\u{643}\u{631}\u{629}\u{60C} \u{623}\u{648} \u{623}\u{636}\u{641} \u{645}\u{647}\u{645}\u{629}.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `\u{62A}\u{648}\u{642}\u{641}`,
    "promptfield.submitButton": `\u{623}\u{631}\u{633}\u{644}\u{646}\u{64A}`,
    "promptfield.uploading": `\u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}`,
    "responsestatus.loading": `\u{62C}\u{627}\u{631}\u{64D} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `\u{627}\u{628}\u{62F}\u{623} \u{627}\u{644}\u{62A}\u{633}\u{62C}\u{64A}\u{644}`,
    "voicebutton.stopListening": `\u{623}\u{648}\u{642}\u{641} \u{627}\u{644}\u{62A}\u{633}\u{62C}\u{64A}\u{644}`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"68146":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `\u{41D}\u{43E}\u{432}\u{43E} \u{441}\u{44A}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{435}`,
    "chat.scrollToBottom": `\u{41F}\u{440}\u{435}\u{432}\u{44A}\u{440}\u{442}\u{435}\u{442}\u{435} \u{43D}\u{430}\u{434}\u{43E}\u{43B}\u{443}`,
    "messagefeedback.thumbDown": `\u{41B}\u{43E}\u{448} \u{43E}\u{442}\u{433}\u{43E}\u{432}\u{43E}\u{440}`,
    "messagefeedback.thumbUp": `\u{414}\u{43E}\u{431}\u{44A}\u{440} \u{43E}\u{442}\u{433}\u{43E}\u{432}\u{43E}\u{440}`,
    "promptfield.aiDisclaimer": `\u{41E}\u{442}\u{433}\u{43E}\u{432}\u{43E}\u{440}\u{438}\u{442}\u{435} \u{441}\u{435} \u{433}\u{435}\u{43D}\u{435}\u{440}\u{438}\u{440}\u{430}\u{442} \u{441} \u{43F}\u{43E}\u{43C}\u{43E}\u{449}\u{442}\u{430} \u{43D}\u{430} \u{438}\u{437}\u{43A}\u{443}\u{441}\u{442}\u{432}\u{435}\u{43D} \u{438}\u{43D}\u{442}\u{435}\u{43B}\u{435}\u{43A}\u{442} \u{438} \u{43C}\u{43E}\u{436}\u{435} \u{434}\u{430} \u{441}\u{430} \u{43D}\u{435}\u{442}\u{43E}\u{447}\u{43D}\u{438}. \u{41F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{435}\u{442}\u{435} \u{43F}\u{440}\u{435}\u{434}\u{438} \u{443}\u{43F}\u{43E}\u{442}\u{440}\u{435}\u{431}\u{430}.`,
    "promptfield.aiUserGuidlines": `\u{41D}\u{430}\u{441}\u{43E}\u{43A}\u{438} \u{437}\u{430} \u{438}\u{437}\u{43F}\u{43E}\u{43B}\u{437}\u{432}\u{430}\u{43D}\u{435} \u{43D}\u{430} AI`,
    "promptfield.attachments": `\u{41F}\u{440}\u{438}\u{43A}\u{430}\u{447}\u{435}\u{43D}\u{438} \u{43C}\u{430}\u{442}\u{435}\u{440}\u{438}\u{430}\u{43B}\u{438}`,
    "promptfield.insertButton": `\u{414}\u{43E}\u{431}\u{430}\u{432}\u{438}`,
    "promptfield.label": `\u{41F}\u{43E}\u{434}\u{441}\u{43A}\u{430}\u{437}\u{43A}\u{430}`,
    "promptfield.placeholder": `\u{413}\u{43E}\u{442}\u{43E}\u{432}\u{438} \u{43B}\u{438} \u{441}\u{442}\u{435} \u{434}\u{430} \u{437}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{435}\u{442}\u{435}? \u{417}\u{430}\u{434}\u{430}\u{439}\u{442}\u{435} \u{432}\u{44A}\u{43F}\u{440}\u{43E}\u{441}, \u{441}\u{43F}\u{43E}\u{434}\u{435}\u{43B}\u{435}\u{442}\u{435} \u{438}\u{434}\u{435}\u{44F} \u{438}\u{43B}\u{438} \u{434}\u{43E}\u{431}\u{430}\u{432}\u{435}\u{442}\u{435} \u{437}\u{430}\u{434}\u{430}\u{447}\u{430}.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `\u{421}\u{43F}\u{440}\u{438}`,
    "promptfield.submitButton": `\u{418}\u{437}\u{43F}\u{440}\u{430}\u{442}\u{438}`,
    "promptfield.uploading": `\u{41A}\u{430}\u{447}\u{432}\u{430}\u{43D}\u{435}`,
    "responsestatus.loading": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435}`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `\u{417}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{435}\u{442}\u{435} \u{437}\u{430}\u{43F}\u{438}\u{441}`,
    "voicebutton.stopListening": `\u{421}\u{43F}\u{440}\u{438} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{430}`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"2bvQi":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `Nov\xe1 zpr\xe1va`,
    "chat.scrollToBottom": `Posunout dol\u{16F}`,
    "messagefeedback.thumbDown": `\u{160}patn\xe1 odpov\u{11B}\u{10F}`,
    "messagefeedback.thumbUp": `Dobr\xe1 odpov\u{11B}\u{10F}`,
    "promptfield.aiDisclaimer": `Odpov\u{11B}di se generuj\xed pomoc\xed AI a mohou b\xfdt nep\u{159}esn\xe9. P\u{159}ed pou\u{17E}it\xedm zkontrolujte.`,
    "promptfield.aiUserGuidlines": `Pokyny pro u\u{17E}ivatele AI`,
    "promptfield.attachments": `P\u{159}\xedlohy`,
    "promptfield.insertButton": `P\u{159}idat`,
    "promptfield.label": `V\xfdzva`,
    "promptfield.placeholder": `Jste p\u{159}ipraveni za\u{10D}\xedt? Polo\u{17E}te ot\xe1zku, pod\u{11B}lte se o sv\u{16F}j n\xe1pad nebo p\u{159}idejte \xfakol.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `Zastavit`,
    "promptfield.submitButton": `Odeslat`,
    "promptfield.uploading": `Nahr\xe1v\xe1n\xed`,
    "responsestatus.loading": `Na\u{10D}\xedt\xe1n\xed`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `Za\u{10D}\xedt nahr\xe1vat`,
    "voicebutton.stopListening": `Zastavit nahr\xe1v\xe1n\xed`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"aF9ok":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `Ny besked`,
    "chat.scrollToBottom": `Scroll ned til bunden`,
    "messagefeedback.thumbDown": `D\xe5rligt svar`,
    "messagefeedback.thumbUp": `Godt svar`,
    "promptfield.aiDisclaimer": `Svar genereres med AI og kan v\xe6re un\xf8jagtige. Tjek f\xf8r brug.`,
    "promptfield.aiUserGuidlines": `AI-brugerretningslinjer`,
    "promptfield.attachments": `Vedh\xe6ftninger`,
    "promptfield.insertButton": `Tilf\xf8j`,
    "promptfield.label": `Prompt`,
    "promptfield.placeholder": `Er du klar til at komme i gang? Stil et sp\xf8rgsm\xe5l, del en id\xe9, eller tilf\xf8j en opgave.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `Stop`,
    "promptfield.submitButton": `Send`,
    "promptfield.uploading": `Upload`,
    "responsestatus.loading": `Indl\xe6ser`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `Start optagelsen`,
    "voicebutton.stopListening": `Stop optagelsen`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"97eyW":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `Neue Nachricht`,
    "chat.scrollToBottom": `Nach unten scrollen`,
    "messagefeedback.thumbDown": `Fehlerhafte Antwort`,
    "messagefeedback.thumbUp": `Gute Antwort`,
    "promptfield.aiDisclaimer": `Antworten werden mit KI generiert und sind m\xf6glicherweise ungenau. Vor der Verwendung pr\xfcfen.`,
    "promptfield.aiUserGuidlines": `AI-Benutzerrichtlinien`,
    "promptfield.attachments": `Anh\xe4nge`,
    "promptfield.insertButton": `Hinzuf\xfcgen`,
    "promptfield.label": `Aufforderung`,
    "promptfield.placeholder": `Sind Sie bereit? Sie k\xf6nnen Fragen stellen, Ideen teilen oder Aufgaben hinzuf\xfcgen.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `Anhalten`,
    "promptfield.submitButton": `Senden`,
    "promptfield.uploading": `Hochladen`,
    "responsestatus.loading": `Ladevorgang l\xe4uft`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `Aufzeichnung starten`,
    "voicebutton.stopListening": `Aufzeichnung stoppen`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"kjwn0":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `\u{39D}\u{3AD}\u{3BF} \u{3BC}\u{3AE}\u{3BD}\u{3C5}\u{3BC}\u{3B1}`,
    "chat.scrollToBottom": `\u{39A}\u{3CD}\u{3BB}\u{3B9}\u{3C3}\u{3B7} \u{3C0}\u{3C1}\u{3BF}\u{3C2} \u{3C4}\u{3B1} \u{3BA}\u{3AC}\u{3C4}\u{3C9}`,
    "messagefeedback.thumbDown": `\u{39A}\u{3B1}\u{3BA}\u{3AE} \u{3B1}\u{3C0}\u{3AC}\u{3BD}\u{3C4}\u{3B7}\u{3C3}\u{3B7}`,
    "messagefeedback.thumbUp": `\u{39A}\u{3B1}\u{3BB}\u{3AE} \u{3B1}\u{3C0}\u{3AC}\u{3BD}\u{3C4}\u{3B7}\u{3C3}\u{3B7}`,
    "promptfield.aiDisclaimer": `\u{39F}\u{3B9} \u{3B1}\u{3C0}\u{3B1}\u{3BD}\u{3C4}\u{3AE}\u{3C3}\u{3B5}\u{3B9}\u{3C2} \u{3B4}\u{3B7}\u{3BC}\u{3B9}\u{3BF}\u{3C5}\u{3C1}\u{3B3}\u{3BF}\u{3CD}\u{3BD}\u{3C4}\u{3B1}\u{3B9} \u{3BC}\u{3B5} \u{3C7}\u{3C1}\u{3AE}\u{3C3}\u{3B7} \u{3C4}\u{3B5}\u{3C7}\u{3BD}\u{3B7}\u{3C4}\u{3AE}\u{3C2} \u{3BD}\u{3BF}\u{3B7}\u{3BC}\u{3BF}\u{3C3}\u{3CD}\u{3BD}\u{3B7}\u{3C2} \u{3BA}\u{3B1}\u{3B9} \u{3B5}\u{3BD}\u{3B4}\u{3AD}\u{3C7}\u{3B5}\u{3C4}\u{3B1}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3B1}\u{3BD}\u{3B1}\u{3BA}\u{3C1}\u{3B9}\u{3B2}\u{3B5}\u{3AF}\u{3C2}. \u{395}\u{3BB}\u{3AD}\u{3B3}\u{3BE}\u{3C4}\u{3B5} \u{3C0}\u{3C1}\u{3B9}\u{3BD} \u{3B1}\u{3C0}\u{3CC} \u{3C4}\u{3B7} \u{3C7}\u{3C1}\u{3AE}\u{3C3}\u{3B7}.`,
    "promptfield.aiUserGuidlines": `\u{39F}\u{3B4}\u{3B7}\u{3B3}\u{3AF}\u{3B5}\u{3C2} \u{3C7}\u{3C1}\u{3AE}\u{3C3}\u{3B7}\u{3C2} AI`,
    "promptfield.attachments": `\u{3A3}\u{3C5}\u{3BD}\u{3B7}\u{3BC}\u{3BC}\u{3AD}\u{3BD}\u{3B1}`,
    "promptfield.insertButton": `\u{3A0}\u{3C1}\u{3BF}\u{3C3}\u{3B8}\u{3AE}\u{3BA}\u{3B7}`,
    "promptfield.label": `\u{3A0}\u{3C1}\u{3BF}\u{3C4}\u{3C1}\u{3BF}\u{3C0}\u{3AE}`,
    "promptfield.placeholder": `\u{395}\u{3AF}\u{3C3}\u{3C4}\u{3B5} \u{3AD}\u{3C4}\u{3BF}\u{3B9}\u{3BC}\u{3BF}\u{3B9} \u{3BD}\u{3B1} \u{3BE}\u{3B5}\u{3BA}\u{3B9}\u{3BD}\u{3AE}\u{3C3}\u{3B5}\u{3C4}\u{3B5}; \u{3A5}\u{3C0}\u{3BF}\u{3B2}\u{3AC}\u{3BB}\u{3B5}\u{3C4}\u{3B5} \u{3BC}\u{3B9}\u{3B1} \u{3B5}\u{3C1}\u{3CE}\u{3C4}\u{3B7}\u{3C3}\u{3B7}, \u{3BC}\u{3BF}\u{3B9}\u{3C1}\u{3B1}\u{3C3}\u{3C4}\u{3B5}\u{3AF}\u{3C4}\u{3B5} \u{3BC}\u{3B9}\u{3B1} \u{3B9}\u{3B4}\u{3AD}\u{3B1} \u{3AE} \u{3C0}\u{3C1}\u{3BF}\u{3C3}\u{3B8}\u{3AD}\u{3C3}\u{3C4}\u{3B5} \u{3BC}\u{3B9}\u{3B1} \u{3B5}\u{3C1}\u{3B3}\u{3B1}\u{3C3}\u{3AF}\u{3B1}.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `\u{3A3}\u{3C4}\u{3B1}\u{3BC}\u{3AC}\u{3C4}\u{3B1}`,
    "promptfield.submitButton": `\u{391}\u{3C0}\u{3BF}\u{3C3}\u{3C4}\u{3BF}\u{3BB}\u{3AE}`,
    "promptfield.uploading": `\u{39C}\u{3B5}\u{3C4}\u{3B1}\u{3C6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7}`,
    "responsestatus.loading": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7}`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `\u{39E}\u{3B5}\u{3BA}\u{3B9}\u{3BD}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{3C4}\u{3B7}\u{3BD} \u{3B5}\u{3B3}\u{3B3}\u{3C1}\u{3B1}\u{3C6}\u{3AE}`,
    "voicebutton.stopListening": `\u{394}\u{3B9}\u{3B1}\u{3BA}\u{3BF}\u{3C0}\u{3AE} \u{3B5}\u{3B3}\u{3B3}\u{3C1}\u{3B1}\u{3C6}\u{3AE}\u{3C2}`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"cvHJO":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `New message`,
    "chat.scrollToBottom": `Scroll to bottom`,
    "messagefeedback.thumbDown": `Bad response`,
    "messagefeedback.thumbUp": `Good response`,
    "responsestatus.loading": `Loading`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.stopListening": `Stop recording`,
    "voicebutton.startListening": `Start recording`,
    "promptfield.placeholder": `Ready to get started? Ask a question, share an idea, or add a task.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.aiDisclaimer": `Responses are generated using AI, and may be inaccurate. Check before using.`,
    "promptfield.aiUserGuidlines": `AI User Guidelines`,
    "promptfield.attachments": `Attachments`,
    "promptfield.label": `Prompt`,
    "promptfield.stopButton": `Stop`,
    "promptfield.submitButton": `Send`,
    "promptfield.insertButton": `Add`,
    "promptfield.uploading": `Uploading`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"gpCiC":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `Mensaje nuevo`,
    "chat.scrollToBottom": `Desplazar al final`,
    "messagefeedback.thumbDown": `Respuesta incorrecta`,
    "messagefeedback.thumbUp": `Respuesta correcta`,
    "promptfield.aiDisclaimer": `Las respuestas se generan mediante IA y pueden ser imprecisas. Compruebe antes de utilizar.`,
    "promptfield.aiUserGuidlines": `Directrices de usuario de AI`,
    "promptfield.attachments": `Archivos adjuntos`,
    "promptfield.insertButton": `Agregar`,
    "promptfield.label": `Preguntar`,
    "promptfield.placeholder": `\xbfListo para empezar? Formule una pregunta, comparta una idea o a\xf1ada una tarea.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `Detener`,
    "promptfield.submitButton": `Enviar`,
    "promptfield.uploading": `Cargando`,
    "responsestatus.loading": `Cargando`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `Iniciar grabaci\xf3n`,
    "voicebutton.stopListening": `Detener grabaci\xf3n`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"bKwsP":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `Uus s\xf5num`,
    "chat.scrollToBottom": `Kerige alla`,
    "messagefeedback.thumbDown": `Halb vastus`,
    "messagefeedback.thumbUp": `Hea vastus`,
    "promptfield.aiDisclaimer": `Vastused genereeritakse tehisintellekti abil ja v\xf5ivad olla ebat\xe4psed. Kontrolli enne kasutamist.`,
    "promptfield.aiUserGuidlines": `Tehisintellekti kasutajajuhised`,
    "promptfield.attachments": `Lisad`,
    "promptfield.insertButton": `Add`,
    "promptfield.label": `\xdclesanne`,
    "promptfield.placeholder": `Kas te olete valmis alustama? Esitage k\xfcsimus, jagage ideed v\xf5i lisage \xfclesanne.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `Peatu`,
    "promptfield.submitButton": `Saada`,
    "promptfield.uploading": `\xdcleslaadimine`,
    "responsestatus.loading": `Laadimine`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `Alusta salvestamist`,
    "voicebutton.stopListening": `L\xf5peta salvestamine`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"coHtp":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `Uusi viesti`,
    "chat.scrollToBottom": `Selaa alas`,
    "messagefeedback.thumbDown": `Huono vastaus`,
    "messagefeedback.thumbUp": `Hyv\xe4 vastaus`,
    "promptfield.aiDisclaimer": `Vastaukset tuotetaan teko\xe4lyn avulla, ja ne voivat olla ep\xe4tarkkoja. Tarkista ennen k\xe4ytt\xf6\xe4.`,
    "promptfield.aiUserGuidlines": `Teko\xe4lyn k\xe4ytt\xe4j\xe4ohjeet`,
    "promptfield.attachments": `Liitteet`,
    "promptfield.insertButton": `Add`,
    "promptfield.label": `Kehotus`,
    "promptfield.placeholder": `Oletko valmis aloittamaan? Esit\xe4 kysymys, jaa idea tai lis\xe4\xe4 teht\xe4v\xe4.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `Seis`,
    "promptfield.submitButton": `L\xe4het\xe4`,
    "promptfield.uploading": `Lataaminen`,
    "responsestatus.loading": `Ladataan`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `Aloita \xe4\xe4nitys`,
    "voicebutton.stopListening": `Lopeta tallennus`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"f5EHp":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `Nouveau message`,
    "chat.scrollToBottom": `D\xe9filement vers le bas`,
    "messagefeedback.thumbDown": `R\xe9ponse incorrecte`,
    "messagefeedback.thumbUp": `R\xe9ponse correcte`,
    "promptfield.aiDisclaimer": `Les r\xe9ponses sont g\xe9n\xe9r\xe9es \xe0 l\u{2019}aide de l\u{2019}IA et peuvent \xeatre inexactes. V\xe9rifiez avant d\u{2019}utiliser.`,
    "promptfield.aiUserGuidlines": `Instructions d\u{2019}utilisation IA`,
    "promptfield.attachments": `Pi\xe8ces jointes`,
    "promptfield.insertButton": `Ajouter`,
    "promptfield.label": `Demander`,
    "promptfield.placeholder": `Vous souhaitez commencer\xa0? Posez une question, partagez une id\xe9e ou ajoutez une t\xe2che.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `Arr\xeater`,
    "promptfield.submitButton": `Envoyer`,
    "promptfield.uploading": `T\xe9l\xe9chargement`,
    "responsestatus.loading": `Chargement`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `D\xe9marrer l'enregistrement`,
    "voicebutton.stopListening": `Arr\xeater l'enregistrement`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"6fRTN":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `\u{5D4}\u{5D5}\u{5D3}\u{5E2}\u{5D4} \u{5D7}\u{5D3}\u{5E9}\u{5D4}`,
    "chat.scrollToBottom": `\u{5D2}\u{5DC}\u{5D5}\u{5DC} \u{5DC}\u{5DE}\u{5D8}\u{5D4}`,
    "messagefeedback.thumbDown": `\u{5EA}\u{5D2}\u{5D5}\u{5D1}\u{5D4} \u{5D2}\u{5E8}\u{5D5}\u{5E2}\u{5D4}`,
    "messagefeedback.thumbUp": `\u{5EA}\u{5D2}\u{5D5}\u{5D1}\u{5D4} \u{5D8}\u{5D5}\u{5D1}\u{5D4}`,
    "promptfield.aiDisclaimer": `\u{5EA}\u{5D2}\u{5D5}\u{5D1}\u{5D5}\u{5EA} \u{5E0}\u{5D5}\u{5E6}\u{5E8}\u{5D5}\u{5EA} \u{5D1}\u{5D0}\u{5DE}\u{5E6}\u{5E2}\u{5D5}\u{5EA} \u{5D1}\u{5D9}\u{5E0}\u{5D4} \u{5DE}\u{5DC}\u{5D0}\u{5DB}\u{5D5}\u{5EA}\u{5D9}\u{5EA}, \u{5D5}\u{5E2}\u{5DC}\u{5D5}\u{5DC}\u{5D5}\u{5EA} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} \u{5DC}\u{5D0} \u{5DE}\u{5D3}\u{5D5}\u{5D9}\u{5E7}\u{5D5}\u{5EA}. \u{5D1}\u{5D3}\u{5D5}\u{5E7} \u{5DC}\u{5E4}\u{5E0}\u{5D9} \u{5D4}\u{5E9}\u{5D9}\u{5DE}\u{5D5}\u{5E9}.`,
    "promptfield.aiUserGuidlines": `\u{5D4}\u{5E0}\u{5D7}\u{5D9}\u{5D5}\u{5EA} \u{5DC}\u{5DE}\u{5E9}\u{5EA}\u{5DE}\u{5E9}\u{5D9}\u{5DD} \u{5D1}\u{5D1}\u{5D9}\u{5E0}\u{5D4} \u{5DE}\u{5DC}\u{5D0}\u{5DB}\u{5D5}\u{5EA}\u{5D9}\u{5EA}`,
    "promptfield.attachments": `\u{5EA}\u{5D5}\u{5E1}\u{5E4}\u{5D5}\u{5EA}`,
    "promptfield.insertButton": `\u{5D4}\u{5D5}\u{5E1}\u{5E3}`,
    "promptfield.label": `\u{5D4}\u{5E0}\u{5D7}\u{5D9}\u{5D4}`,
    "promptfield.placeholder": `\u{5DE}\u{5D5}\u{5DB}\u{5E0}\u{5D9}\u{5DD} \u{5DC}\u{5D4}\u{5EA}\u{5D7}\u{5D9}\u{5DC}? \u{5E9}\u{5D0}\u{5DC}\u{5D5} \u{5E9}\u{5D0}\u{5DC}\u{5D4}, \u{5E9}\u{5EA}\u{5E4}\u{5D5} \u{5E8}\u{5E2}\u{5D9}\u{5D5}\u{5DF} \u{5D0}\u{5D5} \u{5D4}\u{5D5}\u{5E1}\u{5D9}\u{5E4}\u{5D5} \u{5DE}\u{5E9}\u{5D9}\u{5DE}\u{5D4}.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `\u{5E2}\u{5E6}\u{5D5}\u{5E8}`,
    "promptfield.submitButton": `\u{5E9}\u{5DC}\u{5D7}`,
    "promptfield.uploading": `\u{5D4}\u{5E2}\u{5DC}\u{5D0}\u{5D4}`,
    "responsestatus.loading": `\u{5D1}\u{5D8}\u{5E2}\u{5D9}\u{5E0}\u{5D4}\u{2026}`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `\u{5D4}\u{5EA}\u{5D7}\u{5DC} \u{5DC}\u{5D4}\u{5E7}\u{5DC}\u{5D9}\u{5D8}`,
    "voicebutton.stopListening": `\u{5D4}\u{5E4}\u{5E1}\u{5E7} \u{5DC}\u{5D4}\u{5E7}\u{5DC}\u{5D9}\u{5D8}`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"7D8WV":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `Nova poruka`,
    "chat.scrollToBottom": `Scroll to bottom`,
    "messagefeedback.thumbDown": `Odgovor nije dobar`,
    "messagefeedback.thumbUp": `Dobar odgovor`,
    "promptfield.aiDisclaimer": `Responses are generated using AI, and may be inaccurate. Check before using.`,
    "promptfield.aiUserGuidlines": `AI User Guidelines`,
    "promptfield.attachments": `Attachments`,
    "promptfield.insertButton": `Add`,
    "promptfield.label": `Prompt`,
    "promptfield.placeholder": `Spremni za po\u{10D}etak? Postavite pitanje, podijelite ideju ili dodajte zadatak.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `Stop`,
    "promptfield.submitButton": `Send`,
    "promptfield.uploading": `Uploading`,
    "responsestatus.loading": `U\u{10D}itavanje`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `Start recording`,
    "voicebutton.stopListening": `Stop recording`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"1AJA5":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `\xdaj \xfczenet`,
    "chat.scrollToBottom": `G\xf6rgess le az alulra`,
    "messagefeedback.thumbDown": `Rossz v\xe1lasz`,
    "messagefeedback.thumbUp": `J\xf3 v\xe1lasz`,
    "promptfield.aiDisclaimer": `A v\xe1laszokat mesters\xe9ges intelligencia seg\xedts\xe9g\xe9vel gener\xe1lj\xe1k, \xe9s el\u{151}fordulhat, hogy pontatlanok. Ellen\u{151}rizd a haszn\xe1lat el\u{151}tt.`,
    "promptfield.aiUserGuidlines": `AI felhaszn\xe1l\xf3i ir\xe1nyelvek`,
    "promptfield.attachments": `Mell\xe9kletek`,
    "promptfield.insertButton": `Add`,
    "promptfield.label": `Prompt`,
    "promptfield.placeholder": `K\xe9szen \xe1ll a kezd\xe9sre? Tegyen fel egy k\xe9rd\xe9st, ossza meg az \xf6tlet\xe9t, vagy adjon hozz\xe1 egy feladatot.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `\xc1llj meg`,
    "promptfield.submitButton": `Elk\xfcld\xf6m`,
    "promptfield.uploading": `Felt\xf6lt\xe9s`,
    "responsestatus.loading": `Bet\xf6lt\xe9s folyamatban`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `Kezdj el felv\xe9telt`,
    "voicebutton.stopListening": `Felv\xe9tel abbahagy\xe1sa`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"l9XUP":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `Nuovo messaggio`,
    "chat.scrollToBottom": `Scorri verso il basso`,
    "messagefeedback.thumbDown": `Risposta scadente`,
    "messagefeedback.thumbUp": `Risposta buona`,
    "promptfield.aiDisclaimer": `Le risposte vengono generate utilizzando l\u{2019}intelligenza artificiale e potrebbero essere imprecise. Controllare prima di utilizzare.`,
    "promptfield.aiUserGuidlines": `Linee guida utente IA`,
    "promptfield.attachments": `Allegati`,
    "promptfield.insertButton": `Aggiungi`,
    "promptfield.label": `Richiedi`,
    "promptfield.placeholder": `Iniziamo? Fai una domanda, condividi un\u{2019}idea o aggiungi un\u{2019}attivit\xe0.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `Interrompi`,
    "promptfield.submitButton": `Invia`,
    "promptfield.uploading": `Caricamento`,
    "responsestatus.loading": `Caricamento`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `Avvia registrazione`,
    "voicebutton.stopListening": `Interrompi registrazione`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"5RsVx":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `\u{65B0}\u{898F}\u{30E1}\u{30C3}\u{30BB}\u{30FC}\u{30B8}`,
    "chat.scrollToBottom": `\u{4E0B}\u{306B}\u{30B9}\u{30AF}\u{30ED}\u{30FC}\u{30EB}`,
    "messagefeedback.thumbDown": `\u{7121}\u{52B9}\u{306A}\u{5FDC}\u{7B54}`,
    "messagefeedback.thumbUp": `\u{6709}\u{52B9}\u{306A}\u{5FDC}\u{7B54}`,
    "promptfield.aiDisclaimer": `\u{56DE}\u{7B54}\u{306F} AI \u{3092}\u{4F7F}\u{7528}\u{3057}\u{3066}\u{751F}\u{6210}\u{3055}\u{308C}\u{307E}\u{3059}\u{304C}\u{3001}\u{4E0D}\u{6B63}\u{78BA}\u{306B}\u{306A}\u{308B}\u{5834}\u{5408}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}\u{4F7F}\u{7528}\u{3059}\u{308B}\u{524D}\u{306B}\u{78BA}\u{8A8D}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    "promptfield.aiUserGuidlines": `AI \u{30E6}\u{30FC}\u{30B6}\u{30FC}\u{30AC}\u{30A4}\u{30C9}\u{30E9}\u{30A4}\u{30F3}`,
    "promptfield.attachments": `\u{6DFB}\u{4ED8}`,
    "promptfield.insertButton": `\u{8FFD}\u{52A0}`,
    "promptfield.label": `\u{30D7}\u{30ED}\u{30F3}\u{30D7}\u{30C8}`,
    "promptfield.placeholder": `\u{958B}\u{59CB}\u{3059}\u{308B}\u{6E96}\u{5099}\u{306F}\u{6574}\u{3044}\u{307E}\u{3057}\u{305F}\u{304B}\u{FF1F}\u{8CEA}\u{554F}\u{3092}\u{3057}\u{305F}\u{308A}\u{3001}\u{30A2}\u{30A4}\u{30C7}\u{30A2}\u{3092}\u{5171}\u{6709}\u{3057}\u{305F}\u{308A}\u{3001}\u{30BF}\u{30B9}\u{30AF}\u{3092}\u{8FFD}\u{52A0}\u{3057}\u{305F}\u{308A}\u{3057}\u{307E}\u{3059}\u{3002}`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `\u{505C}\u{6B62}`,
    "promptfield.submitButton": `\u{9001}\u{4FE1}`,
    "promptfield.uploading": `\u{30A2}\u{30C3}\u{30D7}\u{30ED}\u{30FC}\u{30C9}\u{4E2D}`,
    "responsestatus.loading": `\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `\u{8A18}\u{9332}\u{3092}\u{958B}\u{59CB}`,
    "voicebutton.stopListening": `\u{8A18}\u{9332}\u{306E}\u{505C}\u{6B62}`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"7rpE2":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `\u{C0C8} \u{BA54}\u{C2DC}\u{C9C0}`,
    "chat.scrollToBottom": `\u{B9E8} \u{C544}\u{B798}\u{B85C} \u{C2A4}\u{D06C}\u{B864}`,
    "messagefeedback.thumbDown": `\u{C798}\u{BABB}\u{B41C} \u{C751}\u{B2F5}`,
    "messagefeedback.thumbUp": `\u{C591}\u{D638}\u{D55C} \u{C751}\u{B2F5}`,
    "promptfield.aiDisclaimer": `\u{C751}\u{B2F5}\u{C740} AI\u{B97C} \u{C774}\u{C6A9}\u{D558}\u{C5EC} \u{C0DD}\u{C131}\u{B418}\u{BA70}, \u{BD80}\u{C815}\u{D655}\u{D560} \u{C218} \u{C788}\u{C73C}\u{B2C8} \u{C0AC}\u{C6A9}\u{D558}\u{AE30} \u{C804}\u{C5D0} \u{D655}\u{C778}\u{D558}\u{C2ED}\u{C2DC}\u{C624}. `,
    "promptfield.aiUserGuidlines": `AI \u{C0AC}\u{C6A9}\u{C790} \u{AC00}\u{C774}\u{B4DC}\u{B77C}\u{C778}`,
    "promptfield.attachments": `\u{CCA8}\u{BD80} \u{D30C}\u{C77C}`,
    "promptfield.insertButton": `\u{CD94}\u{AC00}`,
    "promptfield.label": `\u{D504}\u{B86C}\u{D504}\u{D2B8}`,
    "promptfield.placeholder": `\u{C2DC}\u{C791}\u{D560} \u{C900}\u{BE44}\u{AC00} \u{B418}\u{C168}\u{C2B5}\u{B2C8}\u{AE4C}? \u{C9C8}\u{BB38}\u{C744} \u{D558}\u{AC70}\u{B098}, \u{C544}\u{C774}\u{B514}\u{C5B4}\u{B97C} \u{ACF5}\u{C720}\u{D558}\u{AC70}\u{B098}, \u{C791}\u{C5C5}\u{C744} \u{CD94}\u{AC00}\u{D558}\u{C138}\u{C694}.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `\u{C911}\u{B2E8}`,
    "promptfield.submitButton": `\u{C804}\u{C1A1}`,
    "promptfield.uploading": `\u{C5C5}\u{B85C}\u{B4DC}`,
    "responsestatus.loading": `\u{B85C}\u{B4DC} \u{C911}`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `\u{AE30}\u{B85D} \u{C2DC}\u{C791}`,
    "voicebutton.stopListening": `\u{AE30}\u{B85D} \u{C911}\u{C9C0}`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"fCVgw":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `Naujas prane\u{161}imas`,
    "chat.scrollToBottom": `Slinkite \u{17E}emyn`,
    "messagefeedback.thumbDown": `Blogas atsakas`,
    "messagefeedback.thumbUp": `Geras atsakas`,
    "promptfield.aiDisclaimer": `Atsakymai generuojami naudojant DI ir gali b\u{16B}ti netiksl\u{16B}s. Patikrinkite prie\u{161} naudojant.`,
    "promptfield.aiUserGuidlines": `DI naudotojo gair\u{117}s`,
    "promptfield.attachments": `Priedai`,
    "promptfield.insertButton": `Prid\u{117}ti`,
    "promptfield.label": `Raginimas`,
    "promptfield.placeholder": `Pasiruo\u{161}\u{119} prad\u{117}ti? U\u{17E}duokite klausim\u{105}, pasidalykite id\u{117}ja arba prid\u{117}kite u\u{17E}duot\u{12F}.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `Sustoti, sustok`,
    "promptfield.submitButton": `Si\u{173}sti`,
    "promptfield.uploading": `\u{12E}k\u{117}limas`,
    "responsestatus.loading": `\u{12E}keliama`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `Prad\u{117}kite \u{12F}ra\u{161}in\u{117}ti`,
    "voicebutton.stopListening": `Sustabdyti \u{12F}ra\u{161}ym\u{105}`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"4mahk":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `Jauns zi\u{146}ojums`,
    "chat.scrollToBottom": `Ritiniet uz leju`,
    "messagefeedback.thumbDown": `Slikta atbilde`,
    "messagefeedback.thumbUp": `Laba atbilde`,
    "promptfield.aiDisclaimer": `Atbildes tiek \u{123}ener\u{113}tas, izmantojot m\u{101}ksl\u{12B}go intelektu, un t\u{101}s var b\u{16B}t neprec\u{12B}zas. P\u{101}rbaudiet pirms lieto\u{161}anas.`,
    "promptfield.aiUserGuidlines": `AI lietot\u{101}ja vadl\u{12B}nijas`,
    "promptfield.attachments": `Pielikumi`,
    "promptfield.insertButton": `Pievienot`,
    "promptfield.label": `Uzvedne`,
    "promptfield.placeholder": `Vai esat gatavs s\u{101}kt? Uzdodiet jaut\u{101}jumu, dalieties p\u{101}rdom\u{101}s vai pievienojiet jaunu uzdevumu.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `Apst\u{101}jies`,
    "promptfield.submitButton": `S\u{16B}t\u{12B}t`,
    "promptfield.uploading": `Aug\u{161}upiel\u{101}de`,
    "responsestatus.loading": `Notiek iel\u{101}de`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `S\u{101}ciet ierakst\u{12B}t`,
    "voicebutton.stopListening": `P\u{101}rtraukt ierakstu`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"3jGMD":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `Ny melding`,
    "chat.scrollToBottom": `Scroll to bottom`,
    "messagefeedback.thumbDown": `D\xe5rlig respons`,
    "messagefeedback.thumbUp": `Bra respons`,
    "promptfield.aiDisclaimer": `Responses are generated using AI, and may be inaccurate. Check before using.`,
    "promptfield.aiUserGuidlines": `AI User Guidelines`,
    "promptfield.attachments": `Attachments`,
    "promptfield.insertButton": `Add`,
    "promptfield.label": `Prompt`,
    "promptfield.placeholder": `Klar til \xe5 komme i gang? Still et sp\xf8rsm\xe5l, del en id\xe9 eller legg til en oppgave.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `Stop`,
    "promptfield.submitButton": `Send`,
    "promptfield.uploading": `Uploading`,
    "responsestatus.loading": `Laster inn`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `Start recording`,
    "voicebutton.stopListening": `Stop recording`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"8nrUh":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `Nieuw bericht`,
    "chat.scrollToBottom": `Naar beneden schuiven`,
    "messagefeedback.thumbDown": `Slecht antwoord`,
    "messagefeedback.thumbUp": `Goed antwoord`,
    "promptfield.aiDisclaimer": `Reacties worden gegenereerd met behulp van AI en zijn mogelijk onjuist. Schakel deze optie in voordat u gaat gebruiken.`,
    "promptfield.aiUserGuidlines": `Richtlijnen voor AI-gebruikers`,
    "promptfield.attachments": `Bijlagen`,
    "promptfield.insertButton": `Toevoegen`,
    "promptfield.label": `Vragen`,
    "promptfield.placeholder": `Klaar om aan de slag te gaan? Stel een vraag, deel een idee of voeg een taak toe.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `Stoppen`,
    "promptfield.submitButton": `Verzenden`,
    "promptfield.uploading": `Uploaden`,
    "responsestatus.loading": `Laden`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `Opname starten`,
    "voicebutton.stopListening": `Opname stoppen`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"euAiE":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `Nowa wiadomo\u{15B}\u{107}`,
    "chat.scrollToBottom": `Przewi\u{144} do do\u{142}u`,
    "messagefeedback.thumbDown": `Z\u{142}a odpowied\u{17A}`,
    "messagefeedback.thumbUp": `Dobra odpowied\u{17A}`,
    "promptfield.aiDisclaimer": `Odpowiedzi s\u{105} generowane przy u\u{17C}yciu sztucznej inteligencji i mog\u{105} by\u{107} niedok\u{142}adne. Sprawd\u{17A} przed u\u{17C}yciem.`,
    "promptfield.aiUserGuidlines": `Wskaz\xf3wki dotycz\u{105}ce korzystania ze sztucznej inteligencji`,
    "promptfield.attachments": `Za\u{142}\u{105}czniki`,
    "promptfield.insertButton": `Dodaj`,
    "promptfield.label": `Monit`,
    "promptfield.placeholder": `Zaczynamy? Zadaj pytanie, podziel si\u{119} pomys\u{142}em lub dodaj zadanie.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `Zatrzymaj`,
    "promptfield.submitButton": `Wy\u{15B}lij`,
    "promptfield.uploading": `Przesy\u{142}anie`,
    "responsestatus.loading": `Wczytywanie`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `Rozpocznij nagrywanie`,
    "voicebutton.stopListening": `Zatrzymaj nagrywanie`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"kL0U6":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `Nova mensagem`,
    "chat.scrollToBottom": `Rolar para o final`,
    "messagefeedback.thumbDown": `Resposta ruim`,
    "messagefeedback.thumbUp": `Resposta boa`,
    "promptfield.aiDisclaimer": `As respostas s\xe3o geradas usando IA e podem ser imprecisas. Verifique antes de usar.`,
    "promptfield.aiUserGuidlines": `Diretrizes de usu\xe1rio de IA`,
    "promptfield.attachments": `Anexos`,
    "promptfield.insertButton": `Adicionar`,
    "promptfield.label": `Solicitar`,
    "promptfield.placeholder": `Pronto para come\xe7ar? Fa\xe7a uma pergunta, compartilhe uma ideia ou adicione uma tarefa.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `Parar`,
    "promptfield.submitButton": `Enviar`,
    "promptfield.uploading": `Carregando`,
    "responsestatus.loading": `Carregando`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `Iniciar grava\xe7\xe3o`,
    "voicebutton.stopListening": `Parar grava\xe7\xe3o`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"6mKOW":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `Nova mensagem`,
    "chat.scrollToBottom": `Scroll to bottom`,
    "messagefeedback.thumbDown": `M\xe1 resposta`,
    "messagefeedback.thumbUp": `Boa resposta`,
    "promptfield.aiDisclaimer": `Responses are generated using AI, and may be inaccurate. Check before using.`,
    "promptfield.aiUserGuidlines": `AI User Guidelines`,
    "promptfield.attachments": `Attachments`,
    "promptfield.insertButton": `Add`,
    "promptfield.label": `Prompt`,
    "promptfield.placeholder": `Pronto para come\xe7ar? Fa\xe7a uma pergunta, partilhe uma ideia ou adicione uma tarefa.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `Stop`,
    "promptfield.submitButton": `Send`,
    "promptfield.uploading": `Uploading`,
    "responsestatus.loading": `A carregar`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `Start recording`,
    "voicebutton.stopListening": `Stop recording`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"hEasl":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `Mesaj nou`,
    "chat.scrollToBottom": `Deruleaz\u{103} p\xe2n\u{103} jos`,
    "messagefeedback.thumbDown": `R\u{103}spuns gre\u{219}it`,
    "messagefeedback.thumbUp": `R\u{103}spuns bun`,
    "promptfield.aiDisclaimer": `R\u{103}spunsurile sunt generate folosind AI \u{219}i pot fi inexacte. Verific\u{103} \xeenainte de utilizare.`,
    "promptfield.aiUserGuidlines": `Ghiduri pentru utilizatori AI`,
    "promptfield.attachments": `Ata\u{219}amentele`,
    "promptfield.insertButton": `Adaug\u{103}`,
    "promptfield.label": `Prompt`,
    "promptfield.placeholder": `Sunte\u{21B}i gata s\u{103} \xeencepe\u{21B}i? Pune\u{21B}i o \xeentrebare, \xeemp\u{103}rt\u{103}\u{219}i\u{21B}i o idee sau adauga\u{21B}i o sarcin\u{103}.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `Stop`,
    "promptfield.submitButton": `Trimite`,
    "promptfield.uploading": `\xcenc\u{103}rcare`,
    "responsestatus.loading": `Se \xeencarc\u{103}`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `\xcencepe \xeenregistrarea`,
    "voicebutton.stopListening": `Opri\u{21B}i \xeenregistrarea`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"jCM51":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `\u{41D}\u{43E}\u{432}\u{43E}\u{435} \u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{435}`,
    "chat.scrollToBottom": `\u{41F}\u{440}\u{43E}\u{43A}\u{440}\u{443}\u{442}\u{43A}\u{430} \u{432}\u{43D}\u{438}\u{437}`,
    "messagefeedback.thumbDown": `\u{41F}\u{43B}\u{43E}\u{445}\u{43E}\u{439} \u{43E}\u{442}\u{432}\u{435}\u{442}`,
    "messagefeedback.thumbUp": `\u{425}\u{43E}\u{440}\u{43E}\u{448}\u{438}\u{439} \u{43E}\u{442}\u{432}\u{435}\u{442}`,
    "promptfield.aiDisclaimer": `\u{41E}\u{442}\u{432}\u{435}\u{442}\u{44B} \u{433}\u{435}\u{43D}\u{435}\u{440}\u{438}\u{440}\u{443}\u{44E}\u{442}\u{441}\u{44F} \u{441} \u{43F}\u{43E}\u{43C}\u{43E}\u{449}\u{44C}\u{44E} \u{418}\u{418} \u{438} \u{43C}\u{43E}\u{433}\u{443}\u{442} \u{431}\u{44B}\u{442}\u{44C} \u{43D}\u{435}\u{442}\u{43E}\u{447}\u{43D}\u{44B}\u{43C}\u{438}. \u{41F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{44C}\u{442}\u{435} \u{43F}\u{435}\u{440}\u{435}\u{434} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{43C}.`,
    "promptfield.aiUserGuidlines": `\u{420}\u{443}\u{43A}\u{43E}\u{432}\u{43E}\u{434}\u{441}\u{442}\u{432}\u{43E} \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F} AI`,
    "promptfield.attachments": `\u{412}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`,
    "promptfield.insertButton": `\u{414}\u{43E}\u{431}\u{430}\u{432}\u{438}\u{442}\u{44C}`,
    "promptfield.label": `\u{417}\u{430}\u{43F}\u{440}\u{43E}\u{441}`,
    "promptfield.placeholder": `\u{413}\u{43E}\u{442}\u{43E}\u{432}\u{44B} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{44C} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{443}? \u{417}\u{430}\u{434}\u{430}\u{439}\u{442}\u{435} \u{432}\u{43E}\u{43F}\u{440}\u{43E}\u{441}, \u{43F}\u{43E}\u{434}\u{435}\u{43B}\u{438}\u{442}\u{435}\u{441}\u{44C} \u{438}\u{434}\u{435}\u{435}\u{439} \u{438}\u{43B}\u{438} \u{434}\u{43E}\u{431}\u{430}\u{432}\u{44C}\u{442}\u{435} \u{437}\u{430}\u{434}\u{430}\u{447}\u{443}.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `\u{41E}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C}`,
    "promptfield.submitButton": `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{442}\u{44C}`,
    "promptfield.uploading": `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{43A}\u{430}`,
    "responsestatus.loading": `\u{417}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `\u{41D}\u{430}\u{447}\u{430}\u{442}\u{44C} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C}`,
    "voicebutton.stopListening": `\u{41E}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C}`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"huPJx":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `Nov\xe1 spr\xe1va`,
    "chat.scrollToBottom": `Prejdite na koniec`,
    "messagefeedback.thumbDown": `Zl\xe1 odozva`,
    "messagefeedback.thumbUp": `Dobr\xe1 odozva`,
    "promptfield.aiDisclaimer": `Odpovede s\xfa generovan\xe9 pomocou AI a m\xf4\u{17E}u by\u{165} nepresn\xe9. Pred pou\u{17E}it\xedm si skontrolujte.`,
    "promptfield.aiUserGuidlines": `Pokyny pre pou\u{17E}\xedvate\u{13E}ov AI`,
    "promptfield.attachments": `Pr\xedlohy`,
    "promptfield.insertButton": `Prida\u{165}`,
    "promptfield.label": `Zadanie`,
    "promptfield.placeholder": `Ste pripraven\xed za\u{10D}a\u{165}? Polo\u{17E}te ot\xe1zku, pode\u{13E}te sa o n\xe1pad alebo pridajte \xfalohu.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `Stop`,
    "promptfield.submitButton": `Odosla\u{165}`,
    "promptfield.uploading": `Nahr\xe1vanie`,
    "responsestatus.loading": `Na\u{10D}\xedtava sa`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `Za\u{10D}ni nahr\xe1va\u{165}`,
    "voicebutton.stopListening": `Zastavte nahr\xe1vanie`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"cbUCb":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `Novo sporo\u{10D}ilo`,
    "chat.scrollToBottom": `Pomakni se na dno`,
    "messagefeedback.thumbDown": `Slab odziv`,
    "messagefeedback.thumbUp": `Dober odziv`,
    "promptfield.aiDisclaimer": `Odgovori so ustvarjeni z uporabo umetne inteligence in so lahko neto\u{10D}ni. Preverite pred uporabo.`,
    "promptfield.aiUserGuidlines": `Smernice za uporabnike umetne inteligence`,
    "promptfield.attachments": `Priloge`,
    "promptfield.insertButton": `Dodaj`,
    "promptfield.label": `Navodilo`,
    "promptfield.placeholder": `Ste pripravljeni za\u{10D}eti? Postavite vpra\u{161}anje, delite idejo ali dodajte nalogo.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `Ustavi se`,
    "promptfield.submitButton": `Po\u{161}lji`,
    "promptfield.uploading": `Nalaganje`,
    "responsestatus.loading": `Nalaganje`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `Za\u{10D}ni snemati`,
    "voicebutton.stopListening": `Prenehajte snemati`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"3xyfS":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `Nova poruka`,
    "chat.scrollToBottom": `Scroll to bottom`,
    "messagefeedback.thumbDown": `Lo\u{161} odgovor`,
    "messagefeedback.thumbUp": `Dobar odgovor`,
    "promptfield.aiDisclaimer": `Responses are generated using AI, and may be inaccurate. Check before using.`,
    "promptfield.aiUserGuidlines": `AI User Guidelines`,
    "promptfield.attachments": `Attachments`,
    "promptfield.insertButton": `Add`,
    "promptfield.label": `Prompt`,
    "promptfield.placeholder": `Spremni za po\u{10D}etak? Postavite pitanje, podelite ideju ili dodajte zadatak.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `Stop`,
    "promptfield.submitButton": `Send`,
    "promptfield.uploading": `Uploading`,
    "responsestatus.loading": `U\u{10D}itavanje`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `Start recording`,
    "voicebutton.stopListening": `Stop recording`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"4WAIL":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `Nytt meddelande`,
    "chat.scrollToBottom": `Bl\xe4ddra l\xe4ngst ned`,
    "messagefeedback.thumbDown": `D\xe5ligt svar`,
    "messagefeedback.thumbUp": `Bra svar`,
    "promptfield.aiDisclaimer": `Svar genereras med AI och kan vara felaktiga. Kontrollera f\xf6re anv\xe4ndning.`,
    "promptfield.aiUserGuidlines": `Riktlinjer f\xf6r AI-anv\xe4ndare`,
    "promptfield.attachments": `Bilagor`,
    "promptfield.insertButton": `L\xe4gg till`,
    "promptfield.label": `Uppmaning`,
    "promptfield.placeholder": `Redo att komma ig\xe5ng? St\xe4ll en fr\xe5ga, dela en id\xe9 eller l\xe4gg till en uppgift.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `Stoppa`,
    "promptfield.submitButton": `Skicka`,
    "promptfield.uploading": `\xd6verf\xf6r`,
    "responsestatus.loading": `L\xe4ser in`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `Starta inspelning`,
    "voicebutton.stopListening": `Stoppa inspelning`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"1AfT8":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `Yeni mesaj`,
    "chat.scrollToBottom": `A\u{15F}a\u{11F}\u{131}ya kayd\u{131}r\u{131}n`,
    "messagefeedback.thumbDown": `Yan\u{131}t k\xf6t\xfcyd\xfc`,
    "messagefeedback.thumbUp": `Yan\u{131}t iyiydi`,
    "promptfield.aiDisclaimer": `Yan\u{131}tlar yapay zeka kullan\u{131}larak \xfcretilir ve yanl\u{131}\u{15F} olabilir. Kullanmadan \xf6nce kontrol edin.`,
    "promptfield.aiUserGuidlines": `Yapay Zeka Kullan\u{131}c\u{131} K\u{131}lavuzlar\u{131}`,
    "promptfield.attachments": `Ekler`,
    "promptfield.insertButton": `Ekle`,
    "promptfield.label": `Prompt`,
    "promptfield.placeholder": `Ba\u{15F}lamaya haz\u{131}r m\u{131}s\u{131}n\u{131}z? Soru sorun, fikir payla\u{15F}\u{131}n veya g\xf6rev ekleyin.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `Dur`,
    "promptfield.submitButton": `G\xf6nder`,
    "promptfield.uploading": `Y\xfckleme`,
    "responsestatus.loading": `Y\xfckleniyor`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `Kay\u{131}tlara ba\u{15F}lay\u{131}n`,
    "voicebutton.stopListening": `Kayd\u{131} durdur`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"h1OcF":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `\u{41D}\u{43E}\u{432}\u{435} \u{43F}\u{43E}\u{432}\u{456}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{43D}\u{44F}`,
    "chat.scrollToBottom": `\u{41F}\u{440}\u{43E}\u{43A}\u{440}\u{443}\u{442}\u{456}\u{442}\u{44C} \u{432}\u{43D}\u{438}\u{437}`,
    "messagefeedback.thumbDown": `\u{41F}\u{43E}\u{433}\u{430}\u{43D}\u{430} \u{432}\u{456}\u{434}\u{43F}\u{43E}\u{432}\u{456}\u{434}\u{44C}`,
    "messagefeedback.thumbUp": `\u{413}\u{430}\u{440}\u{43D}\u{430} \u{432}\u{456}\u{434}\u{43F}\u{43E}\u{432}\u{456}\u{434}\u{44C}`,
    "promptfield.aiDisclaimer": `\u{412}\u{456}\u{434}\u{43F}\u{43E}\u{432}\u{456}\u{434}\u{456} \u{433}\u{435}\u{43D}\u{435}\u{440}\u{443}\u{44E}\u{442}\u{44C}\u{441}\u{44F} \u{437}\u{430} \u{434}\u{43E}\u{43F}\u{43E}\u{43C}\u{43E}\u{433}\u{43E}\u{44E} \u{428}\u{406} \u{456} \u{43C}\u{43E}\u{436}\u{443}\u{442}\u{44C} \u{431}\u{443}\u{442}\u{438} \u{43D}\u{435}\u{442}\u{43E}\u{447}\u{43D}\u{438}\u{43C}\u{438}. \u{41F}\u{435}\u{440}\u{435}\u{432}\u{456}\u{440}\u{442}\u{435} \u{43F}\u{435}\u{440}\u{435}\u{434} \u{432}\u{438}\u{43A}\u{43E}\u{440}\u{438}\u{441}\u{442}\u{430}\u{43D}\u{43D}\u{44F}\u{43C}.`,
    "promptfield.aiUserGuidlines": `\u{41A}\u{435}\u{440}\u{456}\u{432}\u{43D}\u{438}\u{446}\u{442}\u{432}\u{430} \u{43A}\u{43E}\u{440}\u{438}\u{441}\u{442}\u{443}\u{432}\u{430}\u{447}\u{430} \u{428}\u{406}`,
    "promptfield.attachments": `\u{414}\u{43E}\u{434}\u{430}\u{442}\u{43A}\u{438}`,
    "promptfield.insertButton": `\u{414}\u{43E}\u{434}\u{430}\u{442}\u{438}`,
    "promptfield.label": `\u{41F}\u{456}\u{434}\u{43A}\u{430}\u{437}\u{43A}\u{430}`,
    "promptfield.placeholder": `\u{413}\u{43E}\u{442}\u{43E}\u{432}\u{456} \u{440}\u{43E}\u{437}\u{43F}\u{43E}\u{447}\u{430}\u{442}\u{438}? \u{417}\u{430}\u{434}\u{430}\u{439}\u{442}\u{435} \u{437}\u{430}\u{43F}\u{438}\u{442}\u{430}\u{43D}\u{43D}\u{44F}, \u{43F}\u{43E}\u{434}\u{456}\u{43B}\u{456}\u{442}\u{44C}\u{441}\u{44F} \u{456}\u{434}\u{435}\u{454}\u{44E} \u{430}\u{431}\u{43E} \u{434}\u{43E}\u{434}\u{430}\u{439}\u{442}\u{435} \u{437}\u{430}\u{432}\u{434}\u{430}\u{43D}\u{43D}\u{44F}.`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `\u{421}\u{442}\u{43E}\u{43F}`,
    "promptfield.submitButton": `\u{412}\u{456}\u{434}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{442}\u{438}`,
    "promptfield.uploading": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F}`,
    "responsestatus.loading": `\u{417}\u{430}\u{432}\u{430}\u{43D}\u{442}\u{430}\u{436}\u{435}\u{43D}\u{43D}\u{44F}`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `\u{41F}\u{43E}\u{447}\u{438}\u{43D}\u{430}\u{439}\u{442}\u{435} \u{437}\u{430}\u{43F}\u{438}\u{441}`,
    "voicebutton.stopListening": `\u{41F}\u{440}\u{438}\u{43F}\u{438}\u{43D}\u{456}\u{442}\u{44C} \u{437}\u{430}\u{43F}\u{438}\u{441}`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"hcq9C":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `\u{65B0}\u{6D88}\u{606F}`,
    "chat.scrollToBottom": `\u{6EDA}\u{52A8}\u{5230}\u{5E95}\u{90E8}`,
    "messagefeedback.thumbDown": `\u{9519}\u{8BEF}\u{54CD}\u{5E94}`,
    "messagefeedback.thumbUp": `\u{826F}\u{597D}\u{54CD}\u{5E94}`,
    "promptfield.aiDisclaimer": `\u{56DE}\u{7B54}\u{662F} AI \u{751F}\u{6210}\u{7684}\u{FF0C}\u{53EF}\u{80FD}\u{4E0D}\u{51C6}\u{786E}\u{3002}\u{8BF7}\u{68C0}\u{67E5}\u{540E}\u{518D}\u{4F7F}\u{7528}\u{3002}`,
    "promptfield.aiUserGuidlines": `AI \u{7528}\u{6237}\u{6307}\u{5357}`,
    "promptfield.attachments": `\u{9644}\u{4EF6}`,
    "promptfield.insertButton": `\u{6DFB}\u{52A0}`,
    "promptfield.label": `\u{63D0}\u{793A}\u{8BCD}`,
    "promptfield.placeholder": `\u{51C6}\u{5907}\u{597D}\u{5F00}\u{59CB}\u{4E86}\u{5417}\u{FF1F}\u{63D0}\u{51FA}\u{95EE}\u{9898}\u{3001}\u{5206}\u{4EAB}\u{60F3}\u{6CD5}\u{6216}\u{6DFB}\u{52A0}\u{4EFB}\u{52A1}\u{3002}`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `\u{505C}\u{6B62}`,
    "promptfield.submitButton": `\u{53D1}\u{9001}`,
    "promptfield.uploading": `\u{6B63}\u{5728}\u{4E0A}\u{8F7D}`,
    "responsestatus.loading": `\u{52A0}\u{8F7D}`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `\u{5F00}\u{59CB}\u{5F55}\u{5236}`,
    "voicebutton.stopListening": `\u{505C}\u{6B62}\u{5F55}\u{5236}`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"32stW":[function(require,module,exports,__globalThis) {
module.exports = {
    "alert.informative": `Informative`,
    "alert.negative": `Negative`,
    "alert.notice": `Notice`,
    "alert.positive": `Positive`,
    "chat.newMessage": `\u{65B0}\u{8A0A}\u{606F}`,
    "chat.scrollToBottom": `\u{6372}\u{52D5}\u{81F3}\u{5E95}\u{90E8}`,
    "messagefeedback.thumbDown": `\u{4E0D}\u{826F}\u{56DE}\u{7B54}`,
    "messagefeedback.thumbUp": `\u{826F}\u{597D}\u{56DE}\u{7B54}`,
    "promptfield.aiDisclaimer": `\u{56DE}\u{7B54}\u{662F}\u{4F7F}\u{7528} AI \u{7522}\u{751F}\u{FF0C}\u{56E0}\u{6B64}\u{53EF}\u{80FD}\u{4E0D}\u{6E96}\u{78BA}\u{3002}\u{4F7F}\u{7528}\u{524D}\u{8ACB}\u{5148}\u{6AA2}\u{67E5}\u{3002}`,
    "promptfield.aiUserGuidlines": `AI \u{4F7F}\u{7528}\u{8005}\u{6E96}\u{5247}`,
    "promptfield.attachments": `\u{9644}\u{4EF6}`,
    "promptfield.insertButton": `\u{65B0}\u{589E}`,
    "promptfield.label": `\u{63D0}\u{793A}`,
    "promptfield.placeholder": `\u{6E96}\u{5099}\u{597D}\u{958B}\u{59CB}\u{4E86}\u{55CE}? \u{63D0}\u{51FA}\u{554F}\u{984C}\u{3001}\u{5206}\u{4EAB}\u{60F3}\u{6CD5}\u{6216}\u{65B0}\u{589E}\u{4EFB}\u{52D9}\u{3002}`,
    "promptfield.placeholder.small": `Ask anything`,
    "promptfield.stopButton": `\u{505C}\u{6B62}`,
    "promptfield.submitButton": `\u{50B3}\u{9001}`,
    "promptfield.uploading": `\u{4E0A}\u{50B3}\u{4E2D}`,
    "responsestatus.loading": `\u{8F09}\u{5165}\u{4E2D}`,
    "responsestatus.processing": `Processing...`,
    "voicebutton.startListening": `\u{958B}\u{59CB}\u{9304}\u{88FD}`,
    "voicebutton.stopListening": `\u{505C}\u{6B62}\u{9304}\u{88FD}`,
    "attachmentlist.previousAttachments": `Show previous attachments`,
    "attachmentlist.nextAttachments": `Show next attachments`
};

},{}],"dTAFx":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDOMRef", ()=>createDOMRef);
parcelHelpers.export(exports, "createFocusableRef", ()=>createFocusableRef);
parcelHelpers.export(exports, "useDOMRef", ()=>useDOMRef);
parcelHelpers.export(exports, "useFocusableRef", ()=>useFocusableRef);
var _react = require("react");
function createDOMRef(ref) {
    return {
        UNSAFE_getDOMNode () {
            return ref.current;
        }
    };
}
function createFocusableRef(domRef, focusableRef) {
    let resolvedFocusableRef = focusableRef || domRef;
    return {
        ...createDOMRef(domRef),
        focus () {
            if (resolvedFocusableRef.current) resolvedFocusableRef.current.focus();
        }
    };
}
function useDOMRef(ref) {
    let domRef = (0, _react.useRef)(null);
    (0, _react.useImperativeHandle)(ref, ()=>createDOMRef(domRef));
    return domRef;
}
function useFocusableRef(ref, focusableRef) {
    let domRef = (0, _react.useRef)(null);
    (0, _react.useImperativeHandle)(ref, ()=>createFocusableRef(domRef, focusableRef));
    return domRef;
}

},{"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"b3f74":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // React pixel-fall loader. Renders plain HTML divs and lets the browser
// drive the animation natively via generated CSS @keyframes. Multi-icon
// sequences (presets) play one icon per 2.4s cycle and
// advance via a single timer — only the current icon's cells are in the
// DOM. A single-icon loader stays a pure infinite CSS loop with no JS.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PixelLoader", ()=>PixelLoader);
var _jsxRuntime = require("react/jsx-runtime");
var _data = require("./data");
var _react = require("react");
// Easing control points, formatted into `cubic-bezier(...)` in the
// generated keyframes. `fade` is intentionally near-linear — its control
// points lie on y=x. `scaleIn`/`scaleOut` drive the per-cell pop.
const EASE = {
    drop: [
        0.333,
        0,
        0.667,
        1
    ],
    recover: [
        0.333,
        0,
        0.833,
        1
    ],
    exit: [
        0.563,
        0,
        0.906,
        0.757
    ],
    fade: [
        0.167,
        0.167,
        0.833,
        0.833
    ],
    scaleIn: [
        0.505,
        0.015,
        0.42,
        0.938
    ],
    scaleOut: [
        0.538,
        0.017,
        0.851,
        0.357
    ]
};
const FPS = 30;
const ms2f = (ms)=>ms * FPS / 1000;
// Timing model: every cell exits a constant `hold` after it settles, and the
// loop grows to fit. A cell settles DROP_SETTLE frames after its stagger, holds
// for HOLD_FRAMES, then takes EXIT_FALL frames to fall out of frame.
const DROP_SETTLE = 13; // frames from a cell's launch to its settled rest
const EXIT_FALL = 12; // frames for a cell to fall out of frame
const HOLD_FRAMES = ms2f(1400); // constant per-cell assembled hold (42 frames)
// Per-cell scale pop: entrance 10% → 100%, exit 100% → 30%. The entrance pop
// *completes* ENT_LEAD frames before the cell settles (so it finishes on-screen
// rather than while still clipped above the frame), and the exit shrink starts
// as the cell begins to fall away.
const ENT_DUR = ms2f(150);
const ENT_LEAD = ms2f(150);
const ENT_FLOOR = 0.1;
const EXIT_DUR = ms2f(230);
const EXIT_FLOOR = 0.3;
// Group opacity envelope, applied once to the cell-grid container (one
// compositing group, so overlapping cells never stack their alpha): fades
// 0 → peak → 0 across the loop.
const OP_FADE_IN = ms2f(400);
const OP_FADE_OUT = ms2f(400);
// Per-cell vertical offsets in the 24-unit space: start off
// the top, overshoot just past the settled position, exit off the bottom.
const Y_START = -26;
const Y_OVERSHOOT = 1;
const Y_EXIT = 26;
// A cell begins its exit fall a constant hold after it settles.
const exitStartOf = (c)=>c.stagger + DROP_SETTLE + HOLD_FRAMES;
// Loop length grows with the icon's stagger spread so every cell gets the
// same settle → hold → exit cadence.
function loopFramesFor(cells) {
    let maxStagger = 1;
    for (const c of cells)maxStagger = Math.max(maxStagger, c.stagger);
    return maxStagger + DROP_SETTLE + HOLD_FRAMES + EXIT_FALL;
}
// The animation lives in a fixed VIEWBOX-sized coordinate space that is scaled down to the
// rendered `size`. Cells are absolutely positioned in this space, so all
// the translateY offsets below are in these units — identical to the old
// SVG viewBox math, just on HTML elements the compositor can accelerate.
const VIEWBOX = 480;
const CELL = VIEWBOX / 12;
// ─────────────────────────────────────────────────────────────
// CSS @keyframes generation. Each piecewise segment of the motion
// becomes one keyframe stop whose `animation-timing-function` is the
// matching cubic-bezier (from EASE), so the browser interpolates the
// drop/recover/exit/fade curves natively.
// ─────────────────────────────────────────────────────────────
function pct(frame, total) {
    // Frame → keyframe offset percentage, trimmed of noise.
    return `${+(frame / total * 100).toFixed(4)}%`;
}
function cb(coeffs) {
    return `cubic-bezier(${coeffs.join(',')})`;
}
function emitKeyframes(name, stops, total) {
    let body = '';
    let lastPct = null;
    for (const s of stops){
        const p = pct(s.f, total);
        if (p === lastPct) continue;
        lastPct = p;
        const ease = s.ease ? `animation-timing-function:${cb(s.ease)};` : '';
        body += `${p}{${s.decl}${ease}}`;
    }
    return `@keyframes ${name}{${body}}`;
}
// Use the individual `translate`/`scale` transform properties so the drop and
// the pop can animate on the same element without clobbering one another.
const ty = (v)=>`translate:0 ${v}px;`;
const sc = (v)=>`scale:${v};`;
const op = (v)=>`opacity:${v};`;
function cellYKeyframes(name, c, total) {
    const s = c.stagger;
    const e = exitStartOf(c);
    const stops = [
        {
            f: 0,
            decl: ty(Y_START),
            ease: s > 0 ? null : EASE.drop
        }
    ];
    if (s > 0) stops.push({
        f: s,
        decl: ty(Y_START),
        ease: EASE.drop
    });
    stops.push({
        f: s + 10,
        decl: ty(Y_OVERSHOOT),
        ease: EASE.recover
    });
    stops.push({
        f: s + DROP_SETTLE,
        decl: ty(0)
    }); // settled — hold until exit
    stops.push({
        f: e,
        decl: ty(0),
        ease: EASE.exit
    });
    stops.push({
        f: e + EXIT_FALL,
        decl: ty(Y_EXIT)
    });
    stops.push({
        f: total,
        decl: ty(Y_EXIT)
    }); // hold offscreen until wrap
    return emitKeyframes(name, stops, total);
}
// Per-cell scale pop, applied to the inner cell element (transform-origin
// center, so no layout shift). The entrance completes ENT_LEAD frames before
// the cell settles; the exit starts as the cell begins to fall away.
function cellScaleKeyframes(name, c, total) {
    const inEnd = c.stagger + DROP_SETTLE - ENT_LEAD;
    const inStart = inEnd - ENT_DUR;
    const outStart = exitStartOf(c);
    const outEnd = outStart + EXIT_DUR;
    return emitKeyframes(name, [
        {
            f: 0,
            decl: sc(0)
        },
        {
            f: inStart,
            decl: sc(ENT_FLOOR),
            ease: EASE.scaleIn
        },
        {
            f: inEnd,
            decl: sc(1)
        },
        {
            f: outStart,
            decl: sc(1),
            ease: EASE.scaleOut
        },
        {
            f: outEnd,
            decl: sc(EXIT_FLOOR)
        },
        {
            f: outStart + EXIT_FALL,
            decl: sc(0)
        },
        {
            f: total,
            decl: sc(0)
        }
    ], total);
}
// Group opacity envelope for the whole loader, applied once to the cell-grid
// container so overlapping cells never stack their alpha.
function groupOpacityKeyframes(name, total) {
    return emitKeyframes(name, [
        {
            f: 0,
            decl: op(0),
            ease: EASE.fade
        },
        {
            f: OP_FADE_IN,
            decl: op('var(--loader-opacity, 1)')
        },
        {
            f: total - OP_FADE_OUT,
            decl: op('var(--loader-opacity, 1)'),
            ease: EASE.fade
        },
        {
            f: total,
            decl: op(0)
        }
    ], total);
}
// Stable per-icon id, keyed by the cell-array reference (icons are
// module-level consts, so the reference is stable). Used to namespace
// each icon's @keyframes and to cache its generated CSS.
let nextIconId = 0;
const iconIds = new WeakMap();
function iconId(cells) {
    let id = iconIds.get(cells);
    if (id === undefined) {
        id = `pl${nextIconId++}`;
        iconIds.set(cells, id);
    }
    return id;
}
const cssCache = new WeakMap();
function keyframesFor(cells) {
    let css = cssCache.get(cells);
    if (css === undefined) {
        const id = iconId(cells);
        const total = loopFramesFor(cells);
        css = cells.map((c, i)=>cellYKeyframes(`${id}-${i}-y`, c, total) + cellScaleKeyframes(`${id}-${i}-s`, c, total)).join('') + groupOpacityKeyframes(`${id}-group-o`, total);
        cssCache.set(cells, css);
    }
    return css;
}
function PixelLoader(props) {
    const { size = 21, isPlaying: isPlayingProp = true, icon = (0, _data.aiLogo), color = 'currentColor', className, ...rest } = props;
    let isReducedMotion = useReducedMotion();
    let isPlaying = isReducedMotion ? false : isPlayingProp;
    // Normalize to a sequence.
    const sequence = _react.useMemo(()=>Array.isArray(icon[0]) ? icon : [
            icon
        ], [
        icon
    ]);
    const isSequence = sequence.length > 1;
    // `tick` increments once per cycle; the current icon is `tick % len`.
    const [tick, setTick] = _react.useState(0);
    // Restart from the first icon whenever the sequence changes.
    let [lastSequence, setLastSequence] = _react.useState(sequence);
    if (lastSequence !== sequence) {
        setLastSequence(sequence);
        setTick(0);
    }
    const cells = sequence[isSequence ? tick % sequence.length : 0];
    // The loop length — and therefore the cycle duration — is dynamic: it grows
    // with the current icon's stagger spread so every cell shares one cadence.
    const duration = _react.useMemo(()=>loopFramesFor(cells) / FPS * 1000, [
        cells
    ]);
    // Advance the sequence one icon per cycle while playing. Single-icon
    // loaders never start a timer — they're a pure infinite CSS loop.
    _react.useEffect(()=>{
        if (!isPlaying || !isSequence) return undefined;
        const id = setInterval(()=>setTick((t)=>t + 1), duration);
        return ()=>clearInterval(id);
    }, [
        isPlaying,
        isSequence,
        duration,
        sequence
    ]);
    const animId = iconId(cells);
    const css = keyframesFor(cells);
    // Sequences play each icon once and hold its faded-out final frame
    // (`forwards`) until the next remount; a single icon loops forever.
    const iteration = isSequence ? '1 forwards' : 'infinite';
    const cellSize = size / 7;
    const offset = (size - cellSize * 7) / 2;
    const matrix = _react.useMemo(()=>{
        let matrix = Array.from({
            length: 7
        }, ()=>Array.from({
                length: 7
            }, ()=>false));
        for (let c of cells){
            let x = (c.cx - 120) / CELL;
            let y = (c.cy - 120) / CELL;
            matrix[y][x] = true;
        }
        return matrix;
    }, [
        cells
    ]);
    const isHighDPI = (typeof document !== 'undefined' && window.devicePixelRatio >= 2) ?? false;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        "aria-hidden": "true",
        className: className,
        style: {
            display: 'inline-block',
            width: size,
            height: size,
            lineHeight: 0,
            position: 'relative',
            // @ts-ignore
            forcedColorAdjust: 'none',
            willChange: 'opacity',
            ...isPlaying && {
                animation: `${animId}-group-o ${duration}ms linear ${iteration}`
            }
        },
        ...rest,
        children: [
            isPlaying ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("style", {
                children: css
            }) : null,
            cells.map((c, i)=>{
                let x = (c.cx - 120) / CELL;
                let y = (c.cy - 120) / CELL;
                // Convex-corner rounding: round a corner only when both orthogonal neighbors toward it,
                // and the diagonal neighbor toward it, are all absent.
                let left = matrix[y][x - 1];
                let right = matrix[y][x + 1];
                let top = matrix[y - 1]?.[x];
                let bottom = matrix[y + 1]?.[x];
                let topLeft = matrix[y - 1]?.[x - 1];
                let topRight = matrix[y - 1]?.[x + 1];
                let bottomLeft = matrix[y + 1]?.[x - 1];
                let bottomRight = matrix[y + 1]?.[x + 1];
                let corner = (a, b, diag)=>!a && !b && !diag ? '1px' : '0px';
                // Adjust position for outer cells on high DPI displays.
                let xPx = x * cellSize + offset + (isHighDPI ? c.adjustX ?? 0 : 0);
                let yPx = y * cellSize + offset + (isHighDPI ? c.adjustY ?? 0 : 0);
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        position: 'absolute',
                        left: xPx,
                        top: yPx,
                        width: cellSize,
                        height: cellSize,
                        transformOrigin: 'center',
                        borderRadius: `${corner(left, top, topLeft)} ${corner(right, top, topRight)} ${corner(right, bottom, bottomRight)} ${corner(left, bottom, bottomLeft)}`,
                        backgroundColor: color,
                        ...isPlaying && {
                            animation: `${animId}-${i}-y ${duration}ms linear ${iteration}, ` + `${animId}-${i}-s ${duration}ms linear ${iteration}`,
                            willChange: 'transform'
                        }
                    }
                }, i);
            })
        ]
    });
}
function useReducedMotion() {
    const [isReducedMotion, setReducedMotion] = _react.useState(false);
    _react.useEffect(()=>{
        if (typeof window === 'undefined') return;
        let mq = window.matchMedia('(prefers-reduced-motion: reduce)');
        let update = ()=>{
            setReducedMotion(mq.matches);
        };
        update();
        mq.addEventListener('change', update);
        return ()=>mq.removeEventListener('change', update);
    }, []);
    return isReducedMotion;
}

},{"react/jsx-runtime":"2Is6Z","./data":"fRQs3","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fRQs3":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "aiLogo", ()=>aiLogo);
// ─────────────────────────────────────────────────────────────
// buildCells — turn a positions list ([col, row] coords on a 7×7 grid,
// bottom-up/left-to-right within a row → stagger order) into a cells
// array with a per-cell entrance stagger. All other timing (settle, hold,
// exit, group opacity) is derived from stagger at render time.
//
// stagger modes:
//   'individual' — brush style. Each cell gets i * interval.
//   'grouped' (default) — eye style. Cells stagger within a row,
//     with 1-cell overlap between consecutive rows (cleaner reads).
//   'by-row' — all cells in a row share one stagger value.
// ─────────────────────────────────────────────────────────────
parcelHelpers.export(exports, "buildCells", ()=>buildCells);
parcelHelpers.export(exports, "brush", ()=>brush);
parcelHelpers.export(exports, "eye", ()=>eye);
parcelHelpers.export(exports, "hourglass", ()=>hourglass);
parcelHelpers.export(exports, "mag", ()=>mag);
parcelHelpers.export(exports, "crop", ()=>crop);
parcelHelpers.export(exports, "flower", ()=>flower);
parcelHelpers.export(exports, "image", ()=>image);
parcelHelpers.export(exports, "lasso", ()=>lasso);
parcelHelpers.export(exports, "page", ()=>page);
parcelHelpers.export(exports, "wand", ()=>wand);
parcelHelpers.export(exports, "bargraph", ()=>bargraph);
parcelHelpers.export(exports, "trefoil", ()=>trefoil);
parcelHelpers.export(exports, "dial", ()=>dial);
parcelHelpers.export(exports, "folder", ()=>folder);
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "cloud", ()=>cloud);
parcelHelpers.export(exports, "comment", ()=>comment);
parcelHelpers.export(exports, "filter", ()=>filter);
parcelHelpers.export(exports, "microphone", ()=>microphone);
parcelHelpers.export(exports, "pencil", ()=>pencil);
parcelHelpers.export(exports, "potion", ()=>potion);
parcelHelpers.export(exports, "slider", ()=>slider);
parcelHelpers.export(exports, "timeline", ()=>timeline);
parcelHelpers.export(exports, "eyedrop", ()=>eyedrop);
parcelHelpers.export(exports, "adobeA", ()=>adobeA);
parcelHelpers.export(exports, "adobeD", ()=>adobeD);
parcelHelpers.export(exports, "adobeO", ()=>adobeO);
parcelHelpers.export(exports, "adobeB", ()=>adobeB);
parcelHelpers.export(exports, "adobeE", ()=>adobeE);
parcelHelpers.export(exports, "document", ()=>document);
parcelHelpers.export(exports, "graph", ()=>graph);
parcelHelpers.export(exports, "cart", ()=>cart);
parcelHelpers.export(exports, "shop", ()=>shop);
parcelHelpers.export(exports, "journey", ()=>journey);
parcelHelpers.export(exports, "floppy", ()=>floppy);
parcelHelpers.export(exports, "cc", ()=>cc);
parcelHelpers.export(exports, "dc", ()=>dc);
parcelHelpers.export(exports, "exp", ()=>exp);
parcelHelpers.export(exports, "analyze", ()=>analyze);
parcelHelpers.export(exports, "cxo", ()=>cxo);
parcelHelpers.export(exports, "mega", ()=>mega);
const aiLogo = [
    {
        cx: 240,
        cy: 360,
        adjustY: -0.5,
        stagger: 0
    },
    {
        cx: 160,
        cy: 320,
        stagger: 2
    },
    {
        cx: 320,
        cy: 320,
        stagger: 4
    },
    {
        cx: 200,
        cy: 280,
        stagger: 6
    },
    {
        cx: 280,
        cy: 280,
        stagger: 8
    },
    {
        cx: 120,
        cy: 240,
        adjustX: 0.5,
        stagger: 10
    },
    {
        cx: 360,
        cy: 240,
        adjustX: -0.5,
        stagger: 14
    },
    {
        cx: 200,
        cy: 200,
        stagger: 16
    },
    {
        cx: 280,
        cy: 200,
        stagger: 18
    },
    {
        cx: 160,
        cy: 160,
        stagger: 20
    },
    {
        cx: 320,
        cy: 160,
        stagger: 22
    },
    {
        cx: 240,
        cy: 120,
        adjustY: 0.5,
        stagger: 24
    }
];
// ─────────────────────────────────────────────────────────────
// POSITIONS — [col, row] grid coords per icon, exported individually.
// ─────────────────────────────────────────────────────────────
const brushPositions = [
    [
        0,
        6
    ],
    [
        1,
        6
    ],
    [
        2,
        6
    ],
    [
        1,
        5
    ],
    [
        3,
        5
    ],
    [
        2,
        4
    ],
    [
        3,
        4
    ],
    [
        3,
        3
    ],
    [
        4,
        3
    ],
    [
        4,
        2
    ],
    [
        5,
        2
    ],
    [
        5,
        1
    ],
    [
        6,
        1
    ],
    [
        6,
        0
    ]
];
const eyePositions = [
    [
        2,
        4
    ],
    [
        3,
        4
    ],
    [
        4,
        4
    ],
    [
        1,
        3
    ],
    [
        3,
        3
    ],
    [
        5,
        3
    ],
    [
        0,
        2
    ],
    [
        2,
        2
    ],
    [
        3,
        2
    ],
    [
        4,
        2
    ],
    [
        6,
        2
    ],
    [
        1,
        1
    ],
    [
        2,
        1
    ],
    [
        3,
        1
    ],
    [
        5,
        1
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ],
    [
        4,
        0
    ]
];
const hourglassPositions = [
    [
        0,
        6
    ],
    [
        1,
        6
    ],
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        4,
        6
    ],
    [
        5,
        6
    ],
    [
        6,
        6
    ],
    [
        1,
        5
    ],
    [
        2,
        5
    ],
    [
        3,
        5
    ],
    [
        4,
        5
    ],
    [
        5,
        5
    ],
    [
        1,
        4
    ],
    [
        2,
        4
    ],
    [
        4,
        4
    ],
    [
        5,
        4
    ],
    [
        2,
        3
    ],
    [
        3,
        3
    ],
    [
        4,
        3
    ],
    [
        1,
        2
    ],
    [
        2,
        2
    ],
    [
        3,
        2
    ],
    [
        4,
        2
    ],
    [
        5,
        2
    ],
    [
        1,
        1
    ],
    [
        5,
        1
    ],
    [
        0,
        0
    ],
    [
        1,
        0
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ],
    [
        4,
        0
    ],
    [
        5,
        0
    ],
    [
        6,
        0
    ]
];
const magPositions = [
    [
        6,
        6
    ],
    [
        5,
        5
    ],
    [
        1,
        4
    ],
    [
        2,
        4
    ],
    [
        3,
        4
    ],
    [
        0,
        3
    ],
    [
        4,
        3
    ],
    [
        0,
        2
    ],
    [
        4,
        2
    ],
    [
        0,
        1
    ],
    [
        4,
        1
    ],
    [
        1,
        0
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ]
];
const cropPositions = [
    [
        5,
        6
    ],
    [
        1,
        5
    ],
    [
        2,
        5
    ],
    [
        3,
        5
    ],
    [
        4,
        5
    ],
    [
        5,
        5
    ],
    [
        6,
        5
    ],
    [
        1,
        4
    ],
    [
        1,
        3
    ],
    [
        5,
        3
    ],
    [
        1,
        2
    ],
    [
        5,
        2
    ],
    [
        0,
        1
    ],
    [
        1,
        1
    ],
    [
        3,
        1
    ],
    [
        4,
        1
    ],
    [
        5,
        1
    ],
    [
        1,
        0
    ]
];
const flowerPositions = [
    [
        3,
        6
    ],
    [
        3,
        5
    ],
    [
        2,
        4
    ],
    [
        4,
        4
    ],
    [
        2,
        3
    ],
    [
        5,
        3
    ],
    [
        1,
        2
    ],
    [
        4,
        2
    ],
    [
        6,
        2
    ],
    [
        0,
        1
    ],
    [
        2,
        1
    ],
    [
        5,
        1
    ],
    [
        1,
        0
    ]
];
const imagePositions = [
    [
        0,
        6
    ],
    [
        1,
        6
    ],
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        4,
        6
    ],
    [
        5,
        6
    ],
    [
        6,
        6
    ],
    [
        0,
        5
    ],
    [
        1,
        5
    ],
    [
        2,
        5
    ],
    [
        3,
        5
    ],
    [
        4,
        5
    ],
    [
        5,
        5
    ],
    [
        6,
        5
    ],
    [
        0,
        4
    ],
    [
        1,
        4
    ],
    [
        2,
        4
    ],
    [
        3,
        4
    ],
    [
        5,
        4
    ],
    [
        6,
        4
    ],
    [
        0,
        3
    ],
    [
        2,
        3
    ],
    [
        6,
        3
    ],
    [
        0,
        2
    ],
    [
        4,
        2
    ],
    [
        6,
        2
    ],
    [
        0,
        1
    ],
    [
        6,
        1
    ],
    [
        0,
        0
    ],
    [
        1,
        0
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ],
    [
        4,
        0
    ],
    [
        5,
        0
    ],
    [
        6,
        0
    ]
];
const lassoPositions = [
    [
        1,
        6
    ],
    [
        2,
        5
    ],
    [
        1,
        4
    ],
    [
        2,
        4
    ],
    [
        0,
        3
    ],
    [
        3,
        3
    ],
    [
        4,
        3
    ],
    [
        5,
        3
    ],
    [
        0,
        2
    ],
    [
        6,
        2
    ],
    [
        1,
        1
    ],
    [
        6,
        1
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ],
    [
        4,
        0
    ],
    [
        5,
        0
    ]
];
const pagePositions = [
    [
        0,
        6
    ],
    [
        1,
        6
    ],
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        4,
        6
    ],
    [
        5,
        6
    ],
    [
        6,
        6
    ],
    [
        0,
        5
    ],
    [
        6,
        5
    ],
    [
        0,
        4
    ],
    [
        6,
        4
    ],
    [
        0,
        3
    ],
    [
        3,
        3
    ],
    [
        4,
        3
    ],
    [
        5,
        3
    ],
    [
        6,
        3
    ],
    [
        0,
        2
    ],
    [
        3,
        2
    ],
    [
        6,
        2
    ],
    [
        0,
        1
    ],
    [
        3,
        1
    ],
    [
        5,
        1
    ],
    [
        0,
        0
    ],
    [
        1,
        0
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ],
    [
        4,
        0
    ]
];
const wandPositions = [
    [
        6,
        6
    ],
    [
        5,
        5
    ],
    [
        0,
        4
    ],
    [
        4,
        4
    ],
    [
        2,
        3
    ],
    [
        1,
        2
    ],
    [
        3,
        2
    ],
    [
        2,
        1
    ],
    [
        0,
        0
    ],
    [
        4,
        0
    ]
];
const bargraphPositions = [
    [
        0,
        6
    ],
    [
        2,
        6
    ],
    [
        4,
        6
    ],
    [
        6,
        6
    ],
    [
        2,
        5
    ],
    [
        4,
        5
    ],
    [
        6,
        5
    ],
    [
        0,
        4
    ],
    [
        2,
        4
    ],
    [
        4,
        4
    ],
    [
        6,
        4
    ],
    [
        1,
        3
    ],
    [
        6,
        3
    ],
    [
        2,
        2
    ],
    [
        4,
        2
    ],
    [
        6,
        2
    ],
    [
        3,
        1
    ],
    [
        5,
        1
    ],
    [
        6,
        0
    ]
];
const trefoilPositions = [
    [
        0,
        6
    ],
    [
        1,
        6
    ],
    [
        1,
        5
    ],
    [
        2,
        4
    ],
    [
        3,
        4
    ],
    [
        5,
        4
    ],
    [
        6,
        4
    ],
    [
        2,
        3
    ],
    [
        4,
        3
    ],
    [
        3,
        2
    ],
    [
        3,
        1
    ],
    [
        3,
        0
    ]
];
const dialPositions = [
    [
        0,
        4
    ],
    [
        6,
        4
    ],
    [
        0,
        3
    ],
    [
        3,
        3
    ],
    [
        6,
        3
    ],
    [
        0,
        2
    ],
    [
        4,
        2
    ],
    [
        6,
        2
    ],
    [
        1,
        1
    ],
    [
        5,
        1
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ]
];
const folderPositions = [
    [
        0,
        5
    ],
    [
        1,
        5
    ],
    [
        2,
        5
    ],
    [
        3,
        5
    ],
    [
        4,
        5
    ],
    [
        5,
        5
    ],
    [
        6,
        5
    ],
    [
        0,
        4
    ],
    [
        6,
        4
    ],
    [
        0,
        3
    ],
    [
        6,
        3
    ],
    [
        0,
        2
    ],
    [
        6,
        2
    ],
    [
        0,
        1
    ],
    [
        3,
        1
    ],
    [
        4,
        1
    ],
    [
        5,
        1
    ],
    [
        6,
        1
    ],
    [
        1,
        0
    ],
    [
        2,
        0
    ]
];
const arrowPositions = [
    [
        0,
        4
    ],
    [
        1,
        3
    ],
    [
        3,
        3
    ],
    [
        2,
        2
    ],
    [
        4,
        2
    ],
    [
        6,
        2
    ],
    [
        5,
        1
    ],
    [
        6,
        1
    ],
    [
        4,
        0
    ],
    [
        5,
        0
    ],
    [
        6,
        0
    ]
];
const cloudPositions = [
    [
        0,
        4
    ],
    [
        1,
        4
    ],
    [
        2,
        4
    ],
    [
        3,
        4
    ],
    [
        4,
        4
    ],
    [
        5,
        4
    ],
    [
        6,
        4
    ],
    [
        0,
        3
    ],
    [
        6,
        3
    ],
    [
        1,
        2
    ],
    [
        5,
        2
    ],
    [
        1,
        1
    ],
    [
        2,
        1
    ],
    [
        5,
        1
    ],
    [
        3,
        0
    ],
    [
        4,
        0
    ]
];
const commentPositions = [
    [
        1,
        6
    ],
    [
        1,
        5
    ],
    [
        2,
        5
    ],
    [
        1,
        4
    ],
    [
        3,
        4
    ],
    [
        4,
        4
    ],
    [
        5,
        4
    ],
    [
        0,
        3
    ],
    [
        6,
        3
    ],
    [
        0,
        2
    ],
    [
        6,
        2
    ],
    [
        0,
        1
    ],
    [
        6,
        1
    ],
    [
        1,
        0
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ],
    [
        4,
        0
    ],
    [
        5,
        0
    ]
];
const filterPositions = [
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        2,
        5
    ],
    [
        4,
        5
    ],
    [
        2,
        4
    ],
    [
        4,
        4
    ],
    [
        2,
        3
    ],
    [
        4,
        3
    ],
    [
        1,
        2
    ],
    [
        5,
        2
    ],
    [
        0,
        1
    ],
    [
        6,
        1
    ],
    [
        0,
        0
    ],
    [
        1,
        0
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ],
    [
        4,
        0
    ],
    [
        5,
        0
    ],
    [
        6,
        0
    ]
];
const microphonePositions = [
    [
        1,
        6
    ],
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        4,
        6
    ],
    [
        2,
        5
    ],
    [
        3,
        5
    ],
    [
        1,
        4
    ],
    [
        4,
        4
    ],
    [
        0,
        3
    ],
    [
        1,
        3
    ],
    [
        4,
        3
    ],
    [
        5,
        3
    ],
    [
        1,
        2
    ],
    [
        4,
        2
    ],
    [
        1,
        1
    ],
    [
        4,
        1
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ]
];
const pencilPositions = [
    [
        0,
        6
    ],
    [
        1,
        6
    ],
    [
        2,
        6
    ],
    [
        0,
        5
    ],
    [
        1,
        5
    ],
    [
        3,
        5
    ],
    [
        0,
        4
    ],
    [
        4,
        4
    ],
    [
        1,
        3
    ],
    [
        5,
        3
    ],
    [
        2,
        2
    ],
    [
        4,
        2
    ],
    [
        6,
        2
    ],
    [
        3,
        1
    ],
    [
        6,
        1
    ],
    [
        4,
        0
    ],
    [
        5,
        0
    ]
];
const potionPositions = [
    [
        1,
        6
    ],
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        4,
        6
    ],
    [
        5,
        6
    ],
    [
        0,
        5
    ],
    [
        6,
        5
    ],
    [
        0,
        4
    ],
    [
        2,
        4
    ],
    [
        6,
        4
    ],
    [
        1,
        3
    ],
    [
        3,
        3
    ],
    [
        5,
        3
    ],
    [
        2,
        2
    ],
    [
        4,
        2
    ],
    [
        2,
        1
    ],
    [
        4,
        1
    ],
    [
        1,
        0
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ],
    [
        4,
        0
    ],
    [
        5,
        0
    ]
];
const sliderPositions = [
    [
        4,
        5
    ],
    [
        0,
        4
    ],
    [
        1,
        4
    ],
    [
        2,
        4
    ],
    [
        3,
        4
    ],
    [
        5,
        4
    ],
    [
        6,
        4
    ],
    [
        4,
        3
    ],
    [
        2,
        2
    ],
    [
        0,
        1
    ],
    [
        1,
        1
    ],
    [
        3,
        1
    ],
    [
        4,
        1
    ],
    [
        5,
        1
    ],
    [
        6,
        1
    ],
    [
        2,
        0
    ]
];
const timelinePositions = [
    [
        3,
        6
    ],
    [
        0,
        5
    ],
    [
        1,
        5
    ],
    [
        3,
        5
    ],
    [
        4,
        5
    ],
    [
        5,
        5
    ],
    [
        6,
        5
    ],
    [
        0,
        4
    ],
    [
        1,
        4
    ],
    [
        3,
        4
    ],
    [
        4,
        4
    ],
    [
        5,
        4
    ],
    [
        6,
        4
    ],
    [
        3,
        3
    ],
    [
        2,
        2
    ],
    [
        4,
        2
    ],
    [
        1,
        1
    ],
    [
        5,
        1
    ],
    [
        1,
        0
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ],
    [
        4,
        0
    ],
    [
        5,
        0
    ]
];
const eyedropPositions = [
    [
        0,
        6
    ],
    [
        1,
        6
    ],
    [
        0,
        5
    ],
    [
        2,
        5
    ],
    [
        1,
        4
    ],
    [
        3,
        4
    ],
    [
        2,
        3
    ],
    [
        4,
        3
    ],
    [
        6,
        3
    ],
    [
        3,
        2
    ],
    [
        4,
        2
    ],
    [
        5,
        2
    ],
    [
        4,
        1
    ],
    [
        5,
        1
    ],
    [
        6,
        1
    ],
    [
        3,
        0
    ],
    [
        5,
        0
    ],
    [
        6,
        0
    ]
];
const adobeAPositions = [
    [
        0,
        6
    ],
    [
        1,
        6
    ],
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        5,
        6
    ],
    [
        6,
        6
    ],
    [
        1,
        5
    ],
    [
        2,
        5
    ],
    [
        5,
        5
    ],
    [
        1,
        4
    ],
    [
        2,
        4
    ],
    [
        4,
        4
    ],
    [
        5,
        4
    ],
    [
        1,
        3
    ],
    [
        2,
        3
    ],
    [
        4,
        3
    ],
    [
        5,
        3
    ],
    [
        2,
        2
    ],
    [
        3,
        2
    ],
    [
        4,
        2
    ],
    [
        2,
        1
    ],
    [
        3,
        1
    ],
    [
        4,
        1
    ]
];
const adobeDPositions = [
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        4,
        6
    ],
    [
        5,
        6
    ],
    [
        1,
        5
    ],
    [
        2,
        5
    ],
    [
        4,
        5
    ],
    [
        5,
        5
    ],
    [
        1,
        4
    ],
    [
        2,
        4
    ],
    [
        4,
        4
    ],
    [
        5,
        4
    ],
    [
        1,
        3
    ],
    [
        2,
        3
    ],
    [
        4,
        3
    ],
    [
        5,
        3
    ],
    [
        2,
        2
    ],
    [
        3,
        2
    ],
    [
        4,
        2
    ],
    [
        5,
        2
    ],
    [
        4,
        1
    ],
    [
        5,
        1
    ]
];
const adobeOPositions = [
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        4,
        6
    ],
    [
        1,
        5
    ],
    [
        2,
        5
    ],
    [
        4,
        5
    ],
    [
        5,
        5
    ],
    [
        1,
        4
    ],
    [
        2,
        4
    ],
    [
        4,
        4
    ],
    [
        5,
        4
    ],
    [
        1,
        3
    ],
    [
        2,
        3
    ],
    [
        4,
        3
    ],
    [
        5,
        3
    ],
    [
        2,
        2
    ],
    [
        3,
        2
    ],
    [
        4,
        2
    ]
];
const adobeBPositions = [
    [
        1,
        6
    ],
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        4,
        6
    ],
    [
        1,
        5
    ],
    [
        2,
        5
    ],
    [
        4,
        5
    ],
    [
        5,
        5
    ],
    [
        1,
        4
    ],
    [
        2,
        4
    ],
    [
        4,
        4
    ],
    [
        5,
        4
    ],
    [
        1,
        3
    ],
    [
        2,
        3
    ],
    [
        4,
        3
    ],
    [
        5,
        3
    ],
    [
        1,
        2
    ],
    [
        2,
        2
    ],
    [
        3,
        2
    ],
    [
        4,
        2
    ],
    [
        1,
        1
    ],
    [
        2,
        1
    ]
];
const adobeEPositions = [
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        4,
        6
    ],
    [
        1,
        5
    ],
    [
        2,
        5
    ],
    [
        1,
        4
    ],
    [
        2,
        4
    ],
    [
        3,
        4
    ],
    [
        4,
        4
    ],
    [
        5,
        4
    ],
    [
        1,
        3
    ],
    [
        2,
        3
    ],
    [
        4,
        3
    ],
    [
        5,
        3
    ],
    [
        2,
        2
    ],
    [
        3,
        2
    ],
    [
        4,
        2
    ]
];
const documentPositions = [
    [
        0,
        6
    ],
    [
        1,
        6
    ],
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        4,
        6
    ],
    [
        5,
        6
    ],
    [
        6,
        6
    ],
    [
        0,
        5
    ],
    [
        6,
        5
    ],
    [
        0,
        4
    ],
    [
        6,
        4
    ],
    [
        0,
        3
    ],
    [
        6,
        3
    ],
    [
        0,
        2
    ],
    [
        4,
        2
    ],
    [
        5,
        2
    ],
    [
        6,
        2
    ],
    [
        0,
        1
    ],
    [
        4,
        1
    ],
    [
        5,
        1
    ],
    [
        0,
        0
    ],
    [
        1,
        0
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ],
    [
        4,
        0
    ]
];
const graphPositions = [
    [
        0,
        6
    ],
    [
        2,
        6
    ],
    [
        4,
        6
    ],
    [
        6,
        6
    ],
    [
        0,
        5
    ],
    [
        2,
        5
    ],
    [
        4,
        5
    ],
    [
        6,
        5
    ],
    [
        2,
        4
    ],
    [
        4,
        4
    ],
    [
        6,
        4
    ],
    [
        2,
        3
    ],
    [
        6,
        3
    ],
    [
        0,
        2
    ],
    [
        4,
        2
    ],
    [
        6,
        2
    ],
    [
        1,
        1
    ],
    [
        3,
        1
    ],
    [
        5,
        1
    ],
    [
        2,
        0
    ],
    [
        6,
        0
    ]
];
const cartPositions = [
    [
        1,
        6
    ],
    [
        4,
        6
    ],
    [
        1,
        4
    ],
    [
        2,
        4
    ],
    [
        3,
        4
    ],
    [
        4,
        4
    ],
    [
        5,
        4
    ],
    [
        1,
        3
    ],
    [
        5,
        3
    ],
    [
        1,
        2
    ],
    [
        6,
        2
    ],
    [
        1,
        1
    ],
    [
        2,
        1
    ],
    [
        3,
        1
    ],
    [
        4,
        1
    ],
    [
        5,
        1
    ],
    [
        6,
        1
    ],
    [
        0,
        0
    ],
    [
        1,
        0
    ]
];
const shopPositions = [
    [
        1,
        6
    ],
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        4,
        6
    ],
    [
        5,
        6
    ],
    [
        1,
        5
    ],
    [
        2,
        5
    ],
    [
        5,
        5
    ],
    [
        1,
        3
    ],
    [
        3,
        3
    ],
    [
        5,
        3
    ],
    [
        0,
        2
    ],
    [
        2,
        2
    ],
    [
        4,
        2
    ],
    [
        6,
        2
    ],
    [
        0,
        1
    ],
    [
        2,
        1
    ],
    [
        4,
        1
    ],
    [
        6,
        1
    ],
    [
        1,
        0
    ],
    [
        2,
        0
    ],
    [
        3,
        0
    ],
    [
        4,
        0
    ],
    [
        5,
        0
    ]
];
const journeyPositions = [
    [
        5,
        6
    ],
    [
        4,
        5
    ],
    [
        6,
        5
    ],
    [
        3,
        4
    ],
    [
        5,
        4
    ],
    [
        1,
        3
    ],
    [
        3,
        3
    ],
    [
        0,
        2
    ],
    [
        2,
        2
    ],
    [
        3,
        2
    ],
    [
        5,
        2
    ],
    [
        1,
        1
    ],
    [
        4,
        1
    ],
    [
        6,
        1
    ],
    [
        5,
        0
    ]
];
const floppyPositions = [
    [
        0,
        6
    ],
    [
        1,
        6
    ],
    [
        2,
        6
    ],
    [
        3,
        6
    ],
    [
        4,
        6
    ],
    [
        5,
        6
    ],
    [
        6,
        6
    ],
    [
        0,
        5
    ],
    [
        6,
        5
    ],
    [
        0,
        4
    ],
    [
        6,
        4
    ],
    [
        0,
        3
    ],
    [
        6,
        3
    ],
    [
        0,
        2
    ],
    [
        1,
        2
    ],
    [
        2,
        2
    ],
    [
        3,
        2
    ],
    [
        4,
        2
    ],
    [
        5,
        2
    ],
    [
        6,
        2
    ],
    [
        0,
        1
    ],
    [
        1,
        1
    ],
    [
        5,
        1
    ],
    [
        6,
        1
    ],
    [
        0,
        0
    ],
    [
        1,
        0
    ],
    [
        3,
        0
    ],
    [
        5,
        0
    ]
];
function buildCells(positions, options = {}) {
    const { staggerInterval = 2, rowOffset = 0, stagger: staggerMode = 'grouped' } = options;
    let staggers;
    if (staggerMode === 'by-row') {
        const rowsBottomUp = [
            ...new Set(positions.map((p)=>p[1]))
        ].sort((a, b)=>b - a);
        const rowStagger = new Map();
        rowsBottomUp.forEach((r, i)=>rowStagger.set(r, i * staggerInterval));
        staggers = positions.map(([, row])=>rowStagger.get(row));
    } else if (staggerMode === 'grouped') {
        const rowGroups = new Map();
        positions.forEach(([, row], i)=>{
            if (!rowGroups.has(row)) rowGroups.set(row, []);
            rowGroups.get(row).push(i);
        });
        const rowsBottomUp = [
            ...rowGroups.keys()
        ].sort((a, b)=>b - a);
        staggers = new Array(positions.length);
        let rowStart = 0;
        for (const row of rowsBottomUp){
            const indices = rowGroups.get(row);
            indices.forEach((idx, j)=>{
                staggers[idx] = rowStart + j * staggerInterval;
            });
            rowStart += Math.max(0, indices.length - 1) * staggerInterval;
        }
    } else if (staggerMode === 'individual') staggers = positions.map((_, i)=>i * staggerInterval);
    else throw new Error(`Unknown stagger mode: ${staggerMode}. Use 'individual', 'grouped', or 'by-row'.`);
    return positions.map(([col, row], i)=>({
            cx: 120 + col * 40,
            cy: 120 + (row + rowOffset) * 40,
            outer: false,
            stagger: staggers[i]
        }));
}
const brush = /* @__PURE__ */ buildCells(brushPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const eye = /* @__PURE__ */ buildCells(eyePositions, {
    staggerInterval: 2,
    stagger: 'grouped',
    rowOffset: 1
});
const hourglass = /* @__PURE__ */ buildCells(hourglassPositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const mag = /* @__PURE__ */ buildCells(magPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const crop = /* @__PURE__ */ buildCells(cropPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const flower = /* @__PURE__ */ buildCells(flowerPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const image = /* @__PURE__ */ buildCells(imagePositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const lasso = /* @__PURE__ */ buildCells(lassoPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const page = /* @__PURE__ */ buildCells(pagePositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const wand = /* @__PURE__ */ buildCells(wandPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const bargraph = /* @__PURE__ */ buildCells(bargraphPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const trefoil = /* @__PURE__ */ buildCells(trefoilPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const dial = /* @__PURE__ */ buildCells(dialPositions, {
    staggerInterval: 2,
    stagger: 'grouped',
    rowOffset: 1
});
const folder = /* @__PURE__ */ buildCells(folderPositions, {
    staggerInterval: 1,
    stagger: 'grouped',
    rowOffset: 1
});
const arrow = /* @__PURE__ */ buildCells(arrowPositions, {
    staggerInterval: 2,
    stagger: 'grouped',
    rowOffset: 2
});
const cloud = /* @__PURE__ */ buildCells(cloudPositions, {
    staggerInterval: 1,
    stagger: 'grouped',
    rowOffset: 1
});
const comment = /* @__PURE__ */ buildCells(commentPositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const filter = /* @__PURE__ */ buildCells(filterPositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const microphone = /* @__PURE__ */ buildCells(microphonePositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const pencil = /* @__PURE__ */ buildCells(pencilPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const potion = /* @__PURE__ */ buildCells(potionPositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const slider = /* @__PURE__ */ buildCells(sliderPositions, {
    staggerInterval: 1,
    stagger: 'grouped',
    rowOffset: 1
});
const timeline = /* @__PURE__ */ buildCells(timelinePositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const eyedrop = /* @__PURE__ */ buildCells(eyedropPositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const adobeA = /* @__PURE__ */ buildCells(adobeAPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const adobeD = /* @__PURE__ */ buildCells(adobeDPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const adobeO = /* @__PURE__ */ buildCells(adobeOPositions, {
    staggerInterval: 2,
    stagger: 'grouped',
    rowOffset: -1
});
const adobeB = /* @__PURE__ */ buildCells(adobeBPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const adobeE = /* @__PURE__ */ buildCells(adobeEPositions, {
    staggerInterval: 2,
    stagger: 'grouped',
    rowOffset: -1
});
const document = /* @__PURE__ */ buildCells(documentPositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const graph = /* @__PURE__ */ buildCells(graphPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const cart = /* @__PURE__ */ buildCells(cartPositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const shop = /* @__PURE__ */ buildCells(shopPositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const journey = /* @__PURE__ */ buildCells(journeyPositions, {
    staggerInterval: 2,
    stagger: 'grouped'
});
const floppy = /* @__PURE__ */ buildCells(floppyPositions, {
    staggerInterval: 1,
    stagger: 'grouped'
});
const cc = [
    aiLogo,
    brush,
    wand,
    crop,
    eye,
    hourglass,
    adobeA,
    adobeD,
    adobeO,
    adobeB,
    adobeE,
    eyedrop
];
const dc = [
    aiLogo,
    page,
    trefoil,
    image,
    cloud,
    mag,
    adobeA,
    adobeD,
    adobeO,
    adobeB,
    adobeE,
    pencil
];
const exp = [
    aiLogo,
    bargraph,
    dial,
    filter,
    slider,
    folder,
    adobeA,
    adobeD,
    adobeO,
    adobeB,
    adobeE,
    arrow
];
const analyze = [
    flower,
    image,
    brush,
    eye,
    eyedrop,
    wand,
    lasso,
    crop
];
const cxo = [
    aiLogo,
    document,
    graph,
    cart,
    shop,
    dial,
    image,
    journey,
    folder,
    timeline,
    comment,
    floppy,
    adobeA,
    adobeD,
    adobeO,
    adobeB,
    adobeE
];
const mega = [
    aiLogo,
    brush,
    wand,
    crop,
    eye,
    hourglass,
    page,
    trefoil,
    image,
    eyedrop,
    mag,
    bargraph,
    dial,
    folder,
    flower,
    lasso,
    adobeA,
    adobeD,
    adobeO,
    adobeB,
    adobeE,
    arrow,
    cloud,
    comment,
    filter,
    microphone,
    pencil,
    potion,
    slider,
    timeline
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bUglb":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Represents a text selection in a TokenField. */ parcelHelpers.export(exports, "SelectedRange", ()=>SelectedRange);
/**
 * A list of segments containing editable text and non-editable tokens.
 */ parcelHelpers.export(exports, "TokenFieldValue", ()=>TokenFieldValue);
class SelectedRange {
    /**
   * Creates a new selection range. If only a single position is provided, the selection is
   * collapsed.
   */ constructor(anchor, current = anchor){
        this.anchor = anchor;
        this.current = current;
    }
    /** Whether the selection is collapsed to a single caret position. */ get isCollapsed() {
        return this.anchor.index === this.current.index && this.anchor.offset === this.current.offset;
    }
    /** The side of the selection closest to the start of the value. */ get start() {
        return compare(this.anchor, this.current) < 0 ? this.anchor : this.current;
    }
    /** The side of the selection closest to the end of the value. */ get end() {
        return compare(this.anchor, this.current) < 0 ? this.current : this.anchor;
    }
    /** Returns whether this selection is equal to another. */ isEqual(other) {
        if (this === other) return true;
        return this.anchor.index === other.anchor.index && this.anchor.offset === other.anchor.offset && this.current.index === other.current.index && this.current.offset === other.current.offset;
    }
}
function compare(a, b) {
    if (a.index === b.index) return a.offset - b.offset;
    return a.index - b.index;
}
var Direction = /*#__PURE__*/ function(Direction) {
    Direction[Direction["Forward"] = 1] = "Forward";
    Direction[Direction["Backward"] = -1] = "Backward";
    return Direction;
}(Direction || {});
class TokenFieldValue {
    static{
        this.Direction = Direction;
    }
    static{
        this.SelectedRange = SelectedRange;
    }
    /** Create a new list with the given segments. */ constructor(tokens, options){
        // Linked list representing the undo/redo history.
        this.previous = null;
        this.next = null;
        this.isCoalescing = true;
        this.segments = tokens;
        this.selectedRange = options?.selectedRange ?? new SelectedRange({
            index: 0,
            offset: 0
        });
    }
    createFieldValue(segments) {
        const Constructor = this.constructor;
        return new Constructor(segments);
    }
    get caretPosition() {
        return this.selectedRange.current;
    }
    /** Create a new list with the caret position set to the given position. */ withSelectedRange(selectedRange) {
        if (this.selectedRange.isEqual(selectedRange)) return this;
        let result = this.createFieldValue(this.segments);
        result.selectedRange = selectedRange;
        result.previous = this.previous;
        result.next = this.next;
        result.isCoalescing = this.isCoalescing;
        return result;
    }
    withCaretPosition(position) {
        return this.withSelectedRange(new SelectedRange(position));
    }
    splitSegment(segment, offset) {
        if (!segment) {
            let empty = this.createTextSegment('');
            return [
                offset > 0 ? empty : null,
                offset > 0 ? null : empty
            ];
        }
        if (segment.type === 'token') return [
            offset > 0 ? {
                ...segment
            } : null,
            offset > 0 ? null : {
                ...segment
            }
        ];
        return [
            offset > 0 ? {
                type: 'text',
                text: segment.text.slice(0, offset)
            } : null,
            offset < segment.text.length ? this.createTextSegment(segment.text.slice(offset)) : null
        ];
    }
    createTextSegment(text) {
        return {
            type: 'text',
            text
        };
    }
    tokenize(text) {
        return [
            this.createTextSegment(text)
        ];
    }
    clampPosition(position) {
        if (this.segments.length > 0 && position.index >= this.segments.length) return {
            index: this.segments.length - 1,
            offset: this.segments[this.segments.length - 1].text.length
        };
        if (position.index < 0) return {
            index: 0,
            offset: 0
        };
        return position;
    }
    /** Replace the text between two positions with new text. */ replaceRange(start, end, text, coalesce = true) {
        return this.replaceRangeWithSegments(start, end, text.length > 0 ? [
            this.createTextSegment(text)
        ] : [], coalesce);
    }
    /** Replace the text between two positions with new segments. */ replaceRangeWithSegments(start, end, insert, coalesce = true) {
        start = this.clampPosition(start);
        end = this.clampPosition(end);
        let startSegment = this.segments[start.index];
        let endSegment = this.segments[end.index];
        let [startSplit] = this.splitSegment(startSegment, start.offset);
        let [, endSplit] = this.splitSegment(endSegment, end.offset);
        let newSegments = this.segments.slice(0, start.index);
        if (startSplit) appendSegments(newSegments, [
            startSplit
        ]);
        if (insert.length) appendSegments(newSegments, insert, (text)=>this.tokenize(text));
        let lastSegment = newSegments[newSegments.length - 1];
        let lastIsText = lastSegment && lastSegment.type === 'text';
        let caret = {
            index: lastIsText ? newSegments.length - 1 : newSegments.length,
            offset: lastIsText ? lastSegment.text.length : 0
        };
        if (endSplit) appendSegments(newSegments, [
            endSplit
        ]);
        appendSegments(newSegments, this.segments.slice(end.index + 1));
        let segments = this.createFieldValue(newSegments);
        segments.selectedRange = new SelectedRange(caret);
        segments.isCoalescing = coalesce;
        if (this.isCoalescing && coalesce && this.previous) {
            segments.previous = this.previous;
            segments.previous.next = segments;
        } else {
            segments.previous = this;
            this.selectedRange = new SelectedRange(start, end);
            this.next = segments;
        }
        return segments;
    }
    /** Find the boundary before or after a position using an Intl.Segmenter. */ findBoundaryWithSegmenter(position, segmenter, direction) {
        position = this.clampPosition(position);
        for(let i = position.index; i >= 0 && i < this.segments.length; i += direction){
            let segment = this.segments[i];
            switch(segment.type){
                case 'token':
                    if (i !== position.index || (direction === -1 ? position.offset > 0 : position.offset === 0)) {
                        let index = i + direction;
                        return {
                            index: index >= 0 ? index : 0,
                            offset: direction === -1 && index >= 0 ? this.segments[index].text.length : 0
                        };
                    }
                    continue;
                case 'text':
                    {
                        let offset = direction === -1 ? segment.text.length : 0;
                        if (i === position.index) offset = position.offset;
                        if (direction === -1) offset--;
                        if (offset < 0 || offset >= segment.text.length) continue;
                        let part = segmenter.segment(segment.text).containing(offset);
                        while(part && part.isWordLike === false){
                            offset += direction;
                            part = segmenter.segment(segment.text).containing(offset);
                        }
                        if (part) return {
                            index: i,
                            offset: direction === -1 ? part.index : part.index + part.segment.length
                        };
                        continue;
                    }
            }
        }
        return null;
    }
    /** Find a line boundary before or after a position. */ findLineBoundary(position, direction) {
        let res = this.findText(position, direction, '\n');
        if (res) return res;
        return direction === -1 ? {
            index: 0,
            offset: 0
        } : {
            index: this.segments.length - 1,
            offset: this.segments[this.segments.length - 1].text.length
        };
    }
    /** Find a string or regular expression match before or after a position. */ findText(position, direction, search) {
        if (this.segments.length === 0) return null;
        for(let i = position.index; i >= 0 && i < this.segments.length; i += direction){
            let segment = this.segments[i];
            if (segment.type !== 'text') continue;
            let offset = findInText(segment.text, search, direction, i === position.index ? position.offset : undefined);
            if (offset >= 0) return {
                index: i,
                offset: offset
            };
        }
        return null;
    }
    /** Delete text at a position using a segmenter. */ delete(position, segmenter, direction, coalesce = true) {
        let boundary = this.findBoundaryWithSegmenter(position, segmenter, direction);
        if (boundary) return this.replaceRange(direction === -1 ? boundary : position, direction === -1 ? position : boundary, '', coalesce);
        return this.withSelectedRange(new SelectedRange(position));
    }
    /** Delete text to the next or previous line break. */ deleteLine(position, direction, coalesce = true) {
        if (this.segments.length === 0) return this;
        let boundary = this.findLineBoundary(position, direction);
        if (boundary) return this.replaceRange(direction === -1 ? boundary : position, direction === -1 ? position : boundary, '', coalesce);
        return this.withSelectedRange(new SelectedRange(position));
    }
    /** Create a new list containing a subset of the segments. */ slice(start, end) {
        start = this.clampPosition(start);
        end = this.clampPosition(end);
        if (start.index === end.index && start.offset === end.offset) return this.createFieldValue([]);
        if (start.index === end.index) {
            let segment = this.segments[start.index];
            if (segment.type === 'text') return this.createFieldValue([
                {
                    type: 'text',
                    text: segment.text.slice(start.offset, end.offset)
                }
            ]);
            return this.createFieldValue([
                segment
            ]);
        }
        let startSegment = this.segments[start.index];
        let endSegment = this.segments[end.index];
        let [, startSplit] = this.splitSegment(startSegment, start.offset);
        let [endSplit] = this.splitSegment(endSegment, end.offset);
        let result = [];
        if (startSplit) result.push(startSplit);
        result.push(...this.segments.slice(start.index + 1, end.index));
        if (endSplit) result.push(endSplit);
        return this.createFieldValue(result);
    }
    /** Convert the list to a string. */ toString() {
        return this.segments.map((seg)=>seg.text).join('');
    }
    /** Returns the previous list in the undo history. */ undo() {
        return this.previous ?? this;
    }
    /** Returns the next list in the redo history. */ redo() {
        return this.next ?? this;
    }
    /** End coalescing undo/redo history. */ endCoalescing() {
        this.isCoalescing = false;
    }
}
function findInText(text, search, direction, fromOffset) {
    if (typeof search === 'string') {
        if (direction === -1) return text.lastIndexOf(search, fromOffset !== undefined ? fromOffset - 1 : text.length - 1);
        return text.indexOf(search, fromOffset ?? 0);
    }
    if (direction === 1) {
        let start = fromOffset ?? 0;
        let index = text.slice(start).search(search);
        return index >= 0 ? start + index : -1;
    }
    let limit = fromOffset !== undefined ? fromOffset : text.length;
    if (limit < 0) return -1;
    let re = search.flags.includes('g') ? search : new RegExp(search.source, search.flags + 'g');
    let matches = Array.from(text.slice(0, limit).matchAll(re));
    return matches.at(-1)?.index ?? -1;
}
function appendSegments(segments, insert, tokenize) {
    for (let segment of insert){
        if (segment.type === 'text' && segment.text.length === 0) continue;
        let last = segments[segments.length - 1];
        if (last && last.type === 'text' && segment.type === 'text') {
            if (tokenize) {
                let tokenized = tokenize(last.text + segment.text);
                segments.splice(segments.length - 1, 1, ...tokenized);
            } else segments[segments.length - 1] = {
                type: 'text',
                text: last.text + segment.text
            };
        } else if (tokenize && segment.type === 'text') {
            let tokenized = tokenize(segment.text);
            segments.push(...tokenized);
        } else segments.push(segment);
    }
    return segments;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6FR4V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PromptFieldContainer", ()=>PromptFieldContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _domfunctions = require("react-aria/private/utils/shadowdom/DOMFunctions");
var _group = require("react-aria-components/Group");
var _isFocusable = require("react-aria/private/utils/isFocusable");
var _mergeStyles = require("@react-spectrum/s2/mergeStyles");
var _react = require("react");
const STATE_TRANSITION = '700ms cubic-bezier(0.32, 0.72, 0, 1)';
/* The brand color drives the hue of the entire component. Override --brand on
   the PromptField (or any ancestor) to retheme it — all gradients, shadows, and
   borders are derived from this hue via OKLCH relative colors in tokens.macro.
   The default is the fuchsia primary, rgb(236, 105, 255). */ undefined;
const containerBackground = "_2Xpxie";
const insetShadow = "H4mXPc";
const containerHue = "t5SQM";
const overlay = "_26il4c";
/* The rotation and translation animations use the computed variables above, which adjust depending
   on the container width (when division with units is supported - everywhere except Firefox).
   The rotation is calculated based on the desired "lift" amount, which is (width / 2) * sin(angle).
   The translation is based on a ratio with the full size reference width (800px). Both translation
   and rotation increase at smaller widths to make the motion more visible in that space. */ const rotation = "ZnuRDe";
const translation = "Kecb1b";
const scale = "_1WNpGb";
const outerBorder = "ubFvMb";
function PromptFieldContainer(props) {
    let { variant, isGenerating, isDropTarget, styles, inputRef, brandColor, size = 'M', ...otherProps } = props;
    let [isFocused, setFocused] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group.Group), {
        ...otherProps,
        role: "group",
        "data-variant": variant,
        "data-state": isGenerating ? 'generating' : 'idle',
        "data-focused": isFocused || undefined,
        className: (size === 'M' ? outerBorder : '') + " -_4DHzJc-0u6p5b17",
        style: {
            ...props.style,
            // @ts-ignore
            '--brand': brandColor
        },
        onFocus: (e)=>{
            if (e.isTrusted && (0, _domfunctions.nodeContains)(inputRef.current, (0, _domfunctions.getEventTarget)(e))) setFocused(true);
        },
        onBlur: (e)=>{
            if (e.isTrusted) setFocused(false);
        },
        onPointerDown: (e)=>{
            // If not clicking on something focusable within the prompt field, focus the input.
            let target = (0, _domfunctions.getEventTarget)(e);
            while(target && target !== e.currentTarget && !(0, _isFocusable.isFocusable)(target))target = target.parentElement;
            if (target === e.currentTarget) {
                e.preventDefault();
                inputRef.current?.focus();
            }
        },
        children: ({ isHovered })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                "data-hovered": isHovered || undefined,
                "data-focused": isFocused || undefined,
                "data-variant": variant,
                "data-state": isGenerating ? 'generating' : 'idle',
                "data-size": size,
                className: ' ' + containerBackground + (0, _mergeStyles.mergeStyles)(function anonymous(props) {
                    let rules = " ";
                    if (props.size === "S") rules += ' oB1JKEb17';
                    else if (props.size === "M") rules += ' oBqAurc17';
                    if (props.size === "S") rules += ' nB1JKEb17';
                    else if (props.size === "M") rules += ' nBqAurc17';
                    if (props.size === "S") rules += ' kB1JKEb17';
                    else if (props.size === "M") rules += ' kBqAurc17';
                    if (props.size === "S") rules += ' jB1JKEb17';
                    else if (props.size === "M") rules += ' jBqAurc17';
                    rules += ' _Pc17';
                    rules += ' _Nb17';
                    rules += ' Pb17';
                    rules += ' _Lf17';
                    rules += ' Oj17';
                    rules += ' OXJG7icj17';
                    rules += ' OXJG7icNh9XXcjQquMe17';
                    rules += ' OXJG7iclOVIhfcebS7sd17';
                    rules += ' OXJG7iclOVIhfcebS7sd17';
                    rules += ' _Mb17';
                    rules += ' _MXJG7icc17';
                    return rules;
                }({
                    size
                }), styles),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: containerHue + function anonymous(props) {
                            let rules = " ";
                            rules += ' _Ob17';
                            rules += ' _Pa17';
                            rules += ' Wj17';
                            rules += ' _lj17';
                            rules += ' _Aj17';
                            rules += ' _zj17';
                            if (props.isGenerating) rules += ' _g7esgMd17';
                            else rules += ' _gh3TDrc17';
                            rules += ' _gdklsgch3TDrc17';
                            rules += ' _efvxpp17';
                            rules += ' _hd17';
                            rules += ' __ea17';
                            rules += ' _qg17';
                            if (props.isGenerating) rules += ' _8d17';
                            return rules;
                        }({
                            isGenerating
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: overlay + " _Ob17 _Pa17 Wr17 _lr17 _Ar17 _zr17"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        "data-state": isGenerating ? 'generating' : 'idle',
                        className: insetShadow
                    }),
                    isDropTarget && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: function anonymous(props) {
                            let rules = " ";
                            rules += ' _Ob17';
                            rules += ' _Pa17';
                            rules += ' Wr17';
                            rules += ' _Er17';
                            rules += ' Za17';
                            rules += ' Fb17';
                            rules += ' _oa17';
                            rules += ' oi17';
                            rules += ' ni17';
                            rules += ' ki17';
                            rules += ' ji17';
                            if (props.variant === "subtle") rules += ' gT3eVJc17';
                            rules += ' _jf17';
                            rules += ' _kc17';
                            rules += ' hc17';
                            rules += ' mc17';
                            rules += ' lc17';
                            rules += ' i7APczd17';
                            return rules;
                        }({
                            variant
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " _Pc17 sd17 _ta17 UB1JKEb17 qB1JKEb17 Tf17 Qf17 Sf17 Rf17 rD17" + (props.className || ''),
                        children: props.children
                    })
                ]
            })
    });
}

},{"0":"7rRha","1":"fZwyk","2":"wjxGE","3":"4KqOu","4":"3xruE","5":"cfwuN","6":"gvx0z","7":"fAvq0","8":"7qhbx","9":"kpvuF","10":"hRMfN","11":"hBisX","12":"hF9wh","13":"k5tw7","14":"5E4B5","react/jsx-runtime":"2Is6Z","react-aria/private/utils/shadowdom/DOMFunctions":"93ERU","react-aria-components/Group":"6UspO","react-aria/private/utils/isFocusable":"bUlmx","@react-spectrum/s2/mergeStyles":"8g9no","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7rRha":[function() {},{}],"fZwyk":[function() {},{}],"wjxGE":[function() {},{}],"4KqOu":[function() {},{}],"3xruE":[function() {},{}],"cfwuN":[function() {},{}],"gvx0z":[function() {},{}],"fAvq0":[function() {},{}],"7qhbx":[function() {},{}],"kpvuF":[function() {},{}],"hRMfN":[function() {},{}],"hBisX":[function() {},{}],"hF9wh":[function() {},{}],"k5tw7":[function() {},{}],"5E4B5":[function() {},{}],"dQLun":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PromptFocusContext", ()=>PromptFocusContext);
parcelHelpers.export(exports, "Chat", ()=>Chat);
/**
 * A Thread shows a conversation within a Chat.
 */ parcelHelpers.export(exports, "Thread", ()=>Thread);
// TODO: wrapper so we can do the "if isNearBottom then hide" logic, could do this via inline styles perhaps
// and ditch the wrapper?
/**
 * A ThreadScrollButton displays a button to scroll to the bottom of a Chat thread.
 */ parcelHelpers.export(exports, "ThreadScrollButton", ()=>ThreadScrollButton);
/**
 * A ThreadItem displays an individual chat message.
 */ parcelHelpers.export(exports, "ThreadItem", ()=>ThreadItem);
parcelHelpers.export(exports, "ThreadLoadMoreItem", ()=>ThreadLoadMoreItem);
var _jsxRuntime = require("react/jsx-runtime");
var _liveAnnouncer = require("react-aria/private/live-announcer/LiveAnnouncer");
var _button = require("react-aria-components/Button");
var _collectionBuilder = require("react-aria-components/CollectionBuilder");
var _react = require("react");
var _slots = require("react-aria-components/slots");
var _filterDOMProps = require("react-aria/filterDOMProps");
var _gridList = require("react-aria-components/GridList");
var _inertValue = require("react-aria/private/utils/inertValue");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _listLayout = require("./ListLayout");
var _listBox = require("react-aria-components/ListBox");
var _baseCollection = require("react-aria/private/collections/BaseCollection");
var _mergeStyles = require("@react-spectrum/s2/mergeStyles");
var _useDOMRef = require("./useDOMRef");
var _animation = require("react-aria/private/utils/animation");
var _useFocusWithin = require("react-aria/useFocusWithin");
var _useLayoutEffect = require("react-aria/private/utils/useLayoutEffect");
var _useLoadMoreSentinel = require("react-aria/private/utils/useLoadMoreSentinel");
var _useLocalizedStringFormatter = require("react-aria/useLocalizedStringFormatter");
var _useRenderProps = require("react-aria-components/useRenderProps");
var _virtualizer = require("react-aria-components/Virtualizer");
const scrollButtonWrapper = function anonymous(props) {
    let rules = " ";
    if (props.isExiting) rules += ' _Ia17';
    else if (props.isEntering) rules += ' _Ia17';
    if (props.isExiting) {
        rules += ' -_8PloMd-F17';
        rules += ' __Ya17';
    } else if (props.isEntering) {
        rules += ' -_8PloMd-F17';
        rules += ' __Ya17';
    }
    rules += ' YmenWad17';
    rules += ' Xc17';
    if (props.isExiting) rules += ' _2c17';
    if (props.isExiting) rules += ' _Ob17';
    return rules;
};
const PromptFocusContext = /*#__PURE__*/ (0, _react.createContext)({
    onFocusChange: ()=>{}
});
const InternalChatContext = /*#__PURE__*/ (0, _react.createContext)({
    announceItem: (text)=>(0, _liveAnnouncer.announce)(text, 'polite'),
    setIsNearBottom: ()=>{},
    setScrollElement: ()=>{}
});
const ThreadScrollButtonContext = /*#__PURE__*/ (0, _react.createContext)({
    isNearBottom: true,
    scrollToBottom: ()=>{},
    'aria-label': ''
});
const Chat = /*#__PURE__*/ (0, _react.forwardRef)(function Chat(props, ref) {
    let { children, styles } = props;
    let domRef = (0, _useDOMRef.useDOMRef)(ref);
    let isFieldFocusedRef = (0, _react.useRef)(false);
    let isChatFocusWithinRef = (0, _react.useRef)(false);
    let hasNewMessagesRef = (0, _react.useRef)(false);
    let timeout = (0, _react.useRef)(null);
    let stringFormatter = (0, _useLocalizedStringFormatter.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/ai');
    let scrollRef = (0, _react.useRef)(null);
    let scrollToBottom = (0, _react.useCallback)(()=>{
        let el = scrollRef.current;
        if (!el) return;
        // TODO: will need some kind of api to programatically set the focused item to
        // the newest item in the gridlist in the virtualizer case. this works for
        // non-virtualized for now though
        // 'scrollend' does not compose across shadow DOM boundaries, but this listener is intentionally
        // scoped to this specific scroll container element (not a global target), so shadow root
        // propagation does not apply here.
        // oxlint-disable-next-line rsp-rules/no-non-composing-event-listener
        el.addEventListener('scrollend', ()=>{
            let firstRow = el.querySelector('[role="row"]');
            (firstRow ?? el).focus();
        }, {
            once: true
        });
        el.scrollTo({
            top: el.scrollHeight - el.clientHeight,
            behavior: 'smooth'
        });
    }, []);
    let [isNearBottom, setIsNearBottom] = (0, _react.useState)(true);
    // only announce new items if user is in the prompt field, otherwise if they
    // are outside the field, only announce there are new responses. If not in chat at all, don't announce
    let announceItem = (0, _react.useCallback)((text)=>{
        if (isFieldFocusedRef.current) {
            (0, _liveAnnouncer.announce)(text, 'polite');
            return;
        }
        if (isChatFocusWithinRef.current) // TODO: ideally announce number of new messages, but only count system messages? maybe threaditem needs
        // to have a "type" prop
        {
            if (!hasNewMessagesRef.current) {
                hasNewMessagesRef.current = true;
                (0, _liveAnnouncer.announce)(stringFormatter.format('chat.newMessage'), 'polite');
                // TODO: arbirary amount of time to wait before announcing new message, maybe we don't clear until
                // we detect they scroll down? Or maybe when we do the message count we do it after a certain number of messages?
                // or maybe this is fine
                timeout.current = setTimeout(()=>{
                    hasNewMessagesRef.current = false;
                    timeout.current = null;
                }, 5000);
            }
        }
    }, [
        stringFormatter
    ]);
    let setScrollElement = (0, _react.useCallback)((el)=>{
        scrollRef.current = el;
    }, []);
    let { focusWithinProps } = (0, _useFocusWithin.useFocusWithin)({
        onFocusWithinChange: (isFocused)=>{
            isChatFocusWithinRef.current = isFocused;
        }
    });
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (timeout.current !== null) clearTimeout(timeout.current);
        };
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slots.Provider), {
        values: [
            [
                InternalChatContext,
                {
                    announceItem,
                    setIsNearBottom,
                    setScrollElement
                }
            ],
            [
                ThreadScrollButtonContext,
                {
                    isNearBottom,
                    scrollToBottom,
                    'aria-label': stringFormatter.format('chat.scrollToBottom')
                }
            ],
            [
                PromptFocusContext,
                {
                    onFocusChange: (focused)=>{
                        isFieldFocusedRef.current = focused;
                    }
                }
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            ref: domRef,
            className: styles,
            ...focusWithinProps,
            children: children
        })
    });
});
function Thread(props) {
    let { items, children, styles, scrollEndThreshold = 100, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby } = props;
    let { setIsNearBottom, setScrollElement } = (0, _react.useContext)(InternalChatContext);
    let isNearBottomRef = (0, _react.useRef)(true);
    let gridListRef = (0, _react.useRef)(null);
    let callbackRef = (0, _react.useCallback)((el)=>{
        gridListRef.current = el;
        setScrollElement(el);
    }, [
        setScrollElement
    ]);
    let handleScroll = (0, _react.useCallback)(()=>{
        let el = gridListRef.current;
        if (!el) return;
        let nearBottom = el.scrollTop >= el.scrollHeight - el.clientHeight - scrollEndThreshold;
        isNearBottomRef.current = nearBottom;
        setIsNearBottom(nearBottom);
    }, [
        setIsNearBottom,
        scrollEndThreshold
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _virtualizer.Virtualizer), {
        layout: (0, _listLayout.ListLayout),
        layoutOptions: {
            estimatedRowHeight: 100,
            padding: 4,
            gap: 8,
            anchorTo: 'end',
            loaderSize: 48,
            scrollEndThreshold
        },
        shouldObserveItemSize: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridList.GridList), {
            ref: callbackRef,
            disallowTypeAhead: true,
            onScroll: handleScroll,
            keyboardNavigationBehavior: "tab",
            UNSTABLE_focusOnEntry: "last",
            items: items,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            // TODO: for now we enforce this, but to be configurable?
            style: {
                display: 'flex',
                boxSizing: 'border-box',
                minWidth: 0,
                scrollbarGutter: 'stable'
            },
            className: styles,
            children: children
        })
    });
}
function ThreadScrollButton({ children }) {
    let { isNearBottom, scrollToBottom, ...buttonProps } = (0, _react.useContext)(ThreadScrollButtonContext);
    let ref = (0, _react.useRef)(null);
    let isVisible = !isNearBottom;
    let isExiting = (0, _animation.useExitAnimation)(ref, isVisible);
    if (!isVisible && !isExiting) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.ButtonContext).Provider, {
        value: {
            slots: {
                [(0, _slots.DEFAULT_SLOT)]: {},
                scroll: {
                    onPress: scrollToBottom,
                    ...buttonProps
                }
            }
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ThreadScrollButtonInner, {
            domRef: ref,
            isExiting: isExiting,
            children: children
        })
    });
}
function ThreadScrollButtonInner({ domRef, isExiting, children }) {
    let isEntering = (0, _animation.useEnterAnimation)(domRef);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: domRef,
        className: scrollButtonWrapper({
            isEntering,
            isExiting
        }),
        children: children
    });
}
const threadItemBase = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf17';
    else rules += ' _Le17';
    rules += ' Oh17';
    rules += ' OlOVIhfcebS7sd17';
    rules += ' OlOVIhfcebS7sd17';
    rules += ' _Mc17';
    rules += ' _Kd17';
    rules += ' oH5kTnc17';
    rules += ' nH5kTnc17';
    rules += ' kH5kTnc17';
    rules += ' jH5kTnc17';
    return rules;
};
function ThreadItem(props) {
    let { styles, children, textValue = ' ', isStreaming, shouldAnnounceOnMount, focusMode, allowsArrowNavigation } = props;
    let { announceItem } = (0, _react.useContext)(InternalChatContext);
    // TODO: using aria-live on the gridlist item was pretty chatty and the streaming causes the text announcement
    // to constantly reset. If we used a live region and updated its contents when streaming finished that worked decently
    // but still feels quite verbose. Stick with this and get feedback
    (0, _useLayoutEffect.useLayoutEffect)(()=>{
        if ((isStreaming === undefined || shouldAnnounceOnMount) && textValue && textValue !== ' ') announceItem(textValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let isStreamingNow = isStreaming ?? false;
    let prevStreamingRef = (0, _react.useRef)(isStreamingNow);
    (0, _useLayoutEffect.useLayoutEffect)(()=>{
        if (isStreaming === undefined) return;
        let wasStreaming = prevStreamingRef.current;
        prevStreamingRef.current = isStreamingNow;
        if (wasStreaming && !isStreamingNow && textValue && textValue !== ' ') announceItem(textValue);
    }, [
        isStreaming,
        isStreamingNow,
        textValue,
        announceItem
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridList.GridListItem), {
        textValue: textValue,
        focusMode: focusMode,
        allowsArrowNavigation: allowsArrowNavigation,
        className: (renderProps)=>(0, _mergeStyles.mergeStyles)(threadItemBase({
                ...renderProps
            }), styles),
        children: children
    });
}
const ThreadLoadMoreItem = (0, _collectionBuilder.createLeafComponent)((0, _baseCollection.LoaderNode), function GridListLoadingIndicator(props, ref, item) {
    let state = (0, _react.useContext)((0, _listBox.ListStateContext));
    let direction = 'start';
    let { isVirtualized } = (0, _react.useContext)((0, _collectionBuilder.CollectionRendererContext));
    let { isLoading, onLoadMore, scrollOffset, ...otherProps } = props;
    let sentinelRef = (0, _react.useRef)(null);
    let memoedLoadMoreProps = (0, _react.useMemo)(()=>({
            onLoadMore,
            collection: state?.collection,
            scrollOffset,
            direction
        }), [
        onLoadMore,
        scrollOffset,
        state?.collection,
        direction
    ]);
    (0, _useLoadMoreSentinel.useLoadMoreSentinel)(memoedLoadMoreProps, sentinelRef);
    let renderProps = (0, _useRenderProps.useRenderProps)({
        ...otherProps,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-GridListLoadingIndicator',
        values: undefined
    });
    // For now don't include aria-posinset and aria-setsize on loader since they aren't keyboard focusable
    // Arguably shouldn't include them ever since it might be confusing to the user to include the loaders as part of the
    // item count
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    position: 'relative',
                    width: 0,
                    height: 0
                },
                inert: (0, _inertValue.inertValue)(true),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    "data-testid": "loadMoreSentinel",
                    ref: sentinelRef,
                    style: {
                        position: 'absolute',
                        height: 1,
                        width: 1
                    }
                })
            }),
            isLoading && renderProps.children && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                ...renderProps,
                ...(0, _filterDOMProps.filterDOMProps)(props, {
                    global: true
                }),
                role: "row",
                ref: ref,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    "aria-colindex": isVirtualized ? 1 : undefined,
                    role: "gridcell",
                    children: renderProps.children
                })
            })
        ]
    });
});

},{"0":"5zZvl","1":"jTl7o","react/jsx-runtime":"2Is6Z","react-aria/private/live-announcer/LiveAnnouncer":"1Ww5F","react-aria-components/Button":"9G5XO","react-aria-components/CollectionBuilder":[["CollectionRendererContext","7QyMy"],["createLeafComponent","3m036"]],"react":"a1TxN","react-aria-components/slots":"bA6Cz","react-aria/filterDOMProps":"c0Owd","react-aria-components/GridList":"8bLgh","react-aria/private/utils/inertValue":"8at61","../intl/*.json":"1VKfy","./ListLayout":"7Z5FP","react-aria-components/ListBox":"dNdIK","react-aria/private/collections/BaseCollection":"gZqwD","@react-spectrum/s2/mergeStyles":"8g9no","./useDOMRef":"dTAFx","react-aria/private/utils/animation":"gg2FW","react-aria/useFocusWithin":"lT0uI","react-aria/private/utils/useLayoutEffect":"k6VV7","react-aria/private/utils/useLoadMoreSentinel":"2SbBS","react-aria/useLocalizedStringFormatter":"4LM0k","react-aria-components/useRenderProps":"bA6Cz","react-aria-components/Virtualizer":"2WSF6","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5zZvl":[function() {},{}],"jTl7o":[function() {},{}],"7Z5FP":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * ListLayout is a virtualizer Layout implementation
 * that arranges its items in a stack along its applied orientation.
 * It supports both fixed and variable size items.
 */ parcelHelpers.export(exports, "ListLayout", ()=>ListLayout);
var _getChildNodes = require("react-stately/private/collections/getChildNodes");
var _useVirtualizerState = require("react-stately/useVirtualizerState");
const isLoaderAnchorable = (layoutInfo)=>layoutInfo.type !== 'loader';
const DEFAULT_HEIGHT = 48;
class ListLayout extends (0, _useVirtualizerState.Layout) {
    /**
   * Creates a new ListLayout with options. See the list of properties below for a description
   * of the options that can be provided.
   */ constructor(options = {}){
        super();
        this.anchorTo = options.anchorTo;
        this.scrollEndThreshold = options.scrollEndThreshold ?? 0;
        this.rowSize = options?.rowSize ?? options?.rowHeight ?? null;
        this.orientation = options.orientation ?? 'vertical';
        this.estimatedRowSize = options?.estimatedRowSize ?? options?.estimatedRowHeight ?? null;
        this.headingSize = options?.headingSize ?? options?.headingHeight ?? null;
        this.estimatedHeadingSize = options?.estimatedHeadingSize ?? options?.estimatedHeadingHeight ?? null;
        this.loaderSize = options?.loaderSize ?? options?.loaderHeight ?? null;
        this.dropIndicatorThickness = options.dropIndicatorThickness || 2;
        this.gap = options.gap || 0;
        this.padding = options.padding || 0;
        this.layoutNodes = new Map();
        this.rootNodes = [];
        this.lastCollection = null;
        this.invalidateEverything = false;
        this.validRect = new (0, _useVirtualizerState.Rect)();
        this.requestedRect = new (0, _useVirtualizerState.Rect)();
        this.contentSize = new (0, _useVirtualizerState.Size)();
        this.warnIfReversedHorizontal();
    }
    warnIfReversedHorizontal() {
        this.anchorTo === 'end' && this.orientation;
    }
    UNSTABLE_getScrollAnchorInfo(layoutOptions) {
        let anchorTo = layoutOptions?.anchorTo ?? this.anchorTo;
        let orientation = layoutOptions?.orientation ?? this.orientation;
        // TODO: Reversed (anchorTo: 'end') layouts are only supported in vertical orientations (for now).
        if (anchorTo !== 'end' || orientation === 'horizontal') return null;
        let threshold = layoutOptions?.scrollEndThreshold ?? this.scrollEndThreshold;
        return {
            edge: 'end',
            axis: 'y',
            threshold,
            isAnchorable: isLoaderAnchorable
        };
    }
    // Backward compatibility for subclassing.
    get collection() {
        return this.virtualizer.collection;
    }
    /** @deprecated Use `rowSize` instead. */ get rowHeight() {
        return this.rowSize;
    }
    /** @deprecated Use `estimatedRowSize` instead. */ get estimatedRowHeight() {
        return this.estimatedRowSize;
    }
    /** @deprecated Use `headingSize` instead. */ get headingHeight() {
        return this.headingSize;
    }
    /** @deprecated Use `estimatedHeadingSize` instead. */ get estimatedHeadingHeight() {
        return this.estimatedHeadingSize;
    }
    /** @deprecated Use `loaderSize` instead. */ get loaderHeight() {
        return this.loaderSize;
    }
    getLayoutInfo(key) {
        this.ensureLayoutInfo(key);
        return this.layoutNodes.get(key)?.layoutInfo || null;
    }
    getVisibleLayoutInfos(rect) {
        let offsetProperty = this.orientation === 'horizontal' ? 'x' : 'y';
        let heightProperty = this.orientation === 'horizontal' ? 'width' : 'height';
        // Adjust rect to keep number of visible rows consistent.
        // (only if height > 1 or width > 1 for getDropTargetFromPoint)
        if (rect[heightProperty] > 1) {
            let rowHeight = (this.rowSize ?? this.estimatedRowSize ?? DEFAULT_HEIGHT) + this.gap;
            // Clone only before mutating
            rect = rect.copy();
            let offset = Math.floor(rect[offsetProperty] / rowHeight) * rowHeight;
            let height = rect[heightProperty] + rect[offsetProperty] - offset;
            rect[offsetProperty] = offset;
            rect[heightProperty] = Math.ceil(height / rowHeight) * rowHeight;
        }
        // If layout hasn't yet been done for the requested rect, union the
        // new rect with the existing valid rect, and recompute.
        this.layoutIfNeeded(rect);
        let res = [];
        let addNodes = (nodes)=>{
            for (let node of nodes)if (this.isVisible(node, rect)) {
                res.push(node.layoutInfo);
                if (node.children) addNodes(node.children);
            }
        };
        addNodes(this.rootNodes);
        return res;
    }
    layoutIfNeeded(rect) {
        if (!this.lastCollection) return;
        if (!this.requestedRect.containsRect(rect)) {
            this.requestedRect = this.requestedRect.union(rect);
            this.rootNodes = this.buildCollection();
        }
        // Ensure all of the persisted keys are available.
        for (let key of this.virtualizer.persistedKeys){
            if (this.ensureLayoutInfo(key)) return;
        }
    }
    ensureLayoutInfo(key) {
        // If the layout info wasn't found, it might be outside the bounds of the area that we've
        // computed layout for so far. This can happen when accessing a random key, e.g pressing Home/End.
        // Compute the full layout and try again.
        if (!this.layoutNodes.has(key) && this.requestedRect.area < this.contentSize.area && this.lastCollection) {
            this.requestedRect = new (0, _useVirtualizerState.Rect)(0, 0, Infinity, Infinity);
            this.rootNodes = this.buildCollection();
            this.requestedRect = new (0, _useVirtualizerState.Rect)(0, 0, this.contentSize.width, this.contentSize.height);
            return true;
        }
        return false;
    }
    isVisible(node, rect) {
        return node.layoutInfo.rect.intersects(rect) || node.layoutInfo.isSticky || node.layoutInfo.type === 'header' || node.layoutInfo.type === 'loader' || this.virtualizer.isPersistedKey(node.layoutInfo.key);
    }
    shouldInvalidateEverything(invalidationContext) {
        // Invalidate cache if the cross-axis size of the collection changed (e.g. width, for a
        // vertical list): that can change how items wrap, so cached row heights are no longer
        // trustworthy. A change to only the main-axis size (e.g. height, for a vertical list) just
        // means more or less of the list is visible, and doesn't affect any row's real height, so it
        // shouldn't throw away the cache.
        // Also invalidate if fixed sizes/gaps change.
        let options = invalidationContext.layoutOptions;
        let orientation = options?.orientation ?? this.orientation;
        let crossAxisSizeChanged = orientation === 'horizontal' ? invalidationContext.heightChanged : invalidationContext.widthChanged;
        return crossAxisSizeChanged || this.rowSize !== (options?.rowSize ?? options?.rowHeight ?? this.rowSize) || this.orientation !== (options?.orientation ?? this.orientation) || this.anchorTo !== (options?.anchorTo ?? this.anchorTo) || this.headingSize !== (options?.headingSize ?? options?.headingHeight ?? this.headingSize) || this.loaderSize !== (options?.loaderSize ?? options?.loaderHeight ?? this.loaderSize) || this.gap !== (options?.gap ?? this.gap) || this.padding !== (options?.padding ?? this.padding);
    }
    shouldInvalidateLayoutOptions(newOptions, oldOptions) {
        return (newOptions?.rowSize ?? newOptions?.rowHeight) !== (oldOptions?.rowSize ?? oldOptions?.rowHeight) || newOptions.orientation !== oldOptions.orientation || newOptions.anchorTo !== oldOptions.anchorTo || (newOptions?.estimatedRowSize ?? newOptions?.estimatedRowHeight) !== (oldOptions?.estimatedRowSize ?? oldOptions?.estimatedRowHeight) || (newOptions?.headingSize ?? newOptions?.headingHeight) !== (oldOptions?.headingSize ?? oldOptions?.headingHeight) || (newOptions?.estimatedHeadingSize ?? newOptions?.estimatedHeadingHeight) !== (oldOptions?.estimatedHeadingSize ?? oldOptions?.estimatedHeadingHeight) || (newOptions?.loaderSize ?? newOptions?.loaderHeight) !== (oldOptions?.loaderSize ?? oldOptions?.loaderHeight) || newOptions.dropIndicatorThickness !== oldOptions.dropIndicatorThickness || newOptions.gap !== oldOptions.gap || newOptions.padding !== oldOptions.padding || newOptions.scrollEndThreshold !== oldOptions.scrollEndThreshold;
    }
    update(invalidationContext) {
        let collection = this.virtualizer.collection;
        // Reset valid rect if we will have to invalidate everything.
        // Otherwise we can reuse cached layout infos outside the current visible rect.
        this.invalidateEverything = this.shouldInvalidateEverything(invalidationContext);
        if (this.invalidateEverything) {
            this.requestedRect = this.virtualizer.visibleRect.copy();
            this.layoutNodes.clear();
        }
        let options = invalidationContext.layoutOptions;
        this.rowSize = options?.rowSize ?? options?.rowHeight ?? this.rowSize;
        this.orientation = options?.orientation ?? this.orientation;
        this.anchorTo = options?.anchorTo ?? this.anchorTo;
        this.scrollEndThreshold = options?.scrollEndThreshold ?? this.scrollEndThreshold;
        this.estimatedRowSize = options?.estimatedRowSize ?? options?.estimatedRowHeight ?? this.estimatedRowSize;
        this.headingSize = options?.headingSize ?? options?.headingHeight ?? this.headingSize;
        this.estimatedHeadingSize = options?.estimatedHeadingSize ?? options?.estimatedHeadingHeight ?? this.estimatedHeadingSize;
        this.loaderSize = options?.loaderSize ?? options?.loaderHeight ?? this.loaderSize;
        this.dropIndicatorThickness = options?.dropIndicatorThickness ?? this.dropIndicatorThickness;
        this.gap = options?.gap ?? this.gap;
        this.padding = options?.padding ?? this.padding;
        this.warnIfReversedHorizontal();
        this.rootNodes = this.buildCollection();
        // Remove deleted layout nodes
        if (this.lastCollection && collection !== this.lastCollection) {
            for (let key of this.lastCollection.getKeys())if (!collection.getItem(key)) {
                let layoutNode = this.layoutNodes.get(key);
                if (layoutNode) this.layoutNodes.delete(key);
            }
        }
        this.lastCollection = collection;
        this.invalidateEverything = false;
        this.validRect = this.requestedRect.copy();
    }
    buildCollection(offset = this.padding) {
        if (this.anchorTo === 'end' && this.orientation === 'vertical') return this.buildReversedCollection();
        let collection = this.virtualizer.collection;
        let offsetProperty = this.orientation === 'horizontal' ? 'x' : 'y';
        let maxOffsetProperty = this.orientation === 'horizontal' ? 'maxX' : 'maxY';
        // filter out content nodes since we don't want them to affect the height
        // Tree specific for now, if we add content nodes to other collection items, we might need to reconsider this
        let collectionNodes = toArray(collection, (node)=>node.type !== 'content');
        let loaderNodes = collectionNodes.filter((node)=>node.type === 'loader');
        let nodes = [];
        let isEmptyOrLoading = collection?.size === 0;
        if (isEmptyOrLoading) offset = 0;
        for (let node of collectionNodes){
            let rowHeight = (this.rowSize ?? this.estimatedRowSize ?? DEFAULT_HEIGHT) + this.gap;
            // Skip rows before the valid rectangle unless they are already cached.
            if (node.type === 'item' && offset + rowHeight < this.requestedRect[offsetProperty] && !this.isValid(node, offset)) {
                offset += rowHeight;
                continue;
            }
            let layoutNode = this.orientation === 'horizontal' ? this.buildChild(node, offset, this.padding, null) : this.buildChild(node, this.padding, offset, null);
            offset = layoutNode.layoutInfo.rect[maxOffsetProperty] + this.gap;
            nodes.push(layoutNode);
            if (node.type === 'loader') {
                let index = loaderNodes.indexOf(node);
                loaderNodes.splice(index, 1);
            }
            // Build each loader that exists in the collection that is outside the visible rect so that they are persisted
            // at the proper estimated location. If the node.type is "section" then we don't do this shortcut since we have to
            // build the sections to see how tall they are.
            if ((node.type === 'item' || node.type === 'loader') && offset > this.requestedRect[maxOffsetProperty]) {
                let lastProcessedIndex = collectionNodes.indexOf(node);
                for (let loaderNode of loaderNodes){
                    let loaderNodeIndex = collectionNodes.indexOf(loaderNode);
                    // Subtract by an additional 1 since we've already added the current item's height to y
                    offset += (loaderNodeIndex - lastProcessedIndex - 1) * rowHeight;
                    let loader = this.orientation === 'horizontal' ? this.buildChild(loaderNode, offset, this.padding, null) : this.buildChild(loaderNode, this.padding, offset, null);
                    nodes.push(loader);
                    offset = loader.layoutInfo.rect[maxOffsetProperty];
                    lastProcessedIndex = loaderNodeIndex;
                }
                // Account for the rest of the items after the last loader spinner, subtract by 1 since we've processed the current node's height already
                offset += (collectionNodes.length - lastProcessedIndex - 1) * rowHeight;
                break;
            }
        }
        offset = Math.max(offset - this.gap, 0);
        offset += isEmptyOrLoading ? 0 : this.padding;
        let contentLength = offset;
        this.contentSize = this.orientation === 'horizontal' ? new (0, _useVirtualizerState.Size)(offset, this.virtualizer.size.height) : new (0, _useVirtualizerState.Size)(this.virtualizer.size.width, contentLength);
        return nodes;
    }
    // TODO: promote to protected once the reversed layout API is more stable and tested
    buildReversedCollection() {
        let collectionNodes = toArray(this.virtualizer.collection, (node)=>node.type !== 'content');
        this.assertReversedCollectionSupported(collectionNodes);
        // Height-only pass: walk collectionNodes once, in collection order, to determine every
        // node's height (items and loaders alike)
        let heights = new Map();
        let loaderHeightIsEstimated = new Map();
        let visibleCount = 0;
        let sumHeights = 0;
        let anyLoader = false;
        for (let node of collectionNodes)if (node.type === 'loader') {
            anyLoader = true;
            let height = 0;
            let estimated = false;
            if (node.props.isLoading) {
                let cached = this.layoutNodes.get(node.key);
                if (cached && !cached.layoutInfo.estimatedSize && cached.layoutInfo.rect.height > 0) height = cached.layoutInfo.rect.height;
                else {
                    height = this.loaderSize ?? this.rowSize ?? this.estimatedRowSize ?? DEFAULT_HEIGHT;
                    estimated = this.loaderSize == null && this.rowSize == null;
                }
            }
            // Not loading: the sentinel is 0px tall and doesn't occupy space.
            heights.set(node, height);
            loaderHeightIsEstimated.set(node, estimated);
            if (height > 0) {
                visibleCount++;
                sumHeights += height;
            }
        } else {
            let cached = this.layoutNodes.get(node.key);
            let height = cached && !cached.layoutInfo.estimatedSize ? cached.layoutInfo.rect.height : this.rowSize ?? this.estimatedRowSize ?? DEFAULT_HEIGHT;
            heights.set(node, height);
            visibleCount++;
            sumHeights += height;
        }
        // Gap count only depends on the total number of visible slots (items + loaders with height >
        // 0), not their arrangement, so this holds regardless of how items/loaders interleave.
        let contentLength = sumHeights + Math.max(visibleCount - 1, 0) * this.gap;
        if (visibleCount > 0 || anyLoader) contentLength += this.padding * 2;
        let contentHeight = Math.max(contentLength, this.virtualizer.size.height);
        this.contentSize = new (0, _useVirtualizerState.Size)(this.virtualizer.size.width, contentHeight);
        // Iterate last → first so the last item in the collection (newest) is placed at the visual
        // bottom and written to nodes[0] (first in DOM) for screen-reader accessibility.
        let width = this.virtualizer.size.width - this.padding * 2;
        let nodes = [];
        let currentBottom = contentLength - this.padding;
        for(let i = collectionNodes.length - 1; i >= 0; i--){
            let node = collectionNodes[i];
            let height = heights.get(node);
            let layoutNode;
            if (node.type === 'loader') {
                const sentinelYOffset = i === 0 && height === 0 && visibleCount > 0 ? this.gap : 0;
                let loaderY = currentBottom - height + sentinelYOffset;
                let loaderNode = this.buildNode(node, this.padding, loaderY);
                loaderNode.layoutInfo.rect.height = height;
                loaderNode.layoutInfo.parentKey = null;
                loaderNode.layoutInfo.allowOverflow = true;
                if (node.props.isLoading) loaderNode.layoutInfo.estimatedSize = loaderHeightIsEstimated.get(node);
                loaderNode.validRect = loaderNode.layoutInfo.rect.intersection(this.requestedRect);
                this.layoutNodes.set(loaderNode.layoutInfo.key, loaderNode);
                layoutNode = loaderNode;
                currentBottom = loaderY - this.gap;
            } else {
                let y = currentBottom - height;
                let cached = this.layoutNodes.get(node.key);
                if (cached && !cached.layoutInfo.estimatedSize) {
                    let newLayoutInfo = cached.layoutInfo.copy();
                    newLayoutInfo.rect.y = y;
                    layoutNode = {
                        layoutInfo: newLayoutInfo,
                        validRect: new (0, _useVirtualizerState.Rect)(0, 0, 0, 0),
                        children: []
                    };
                } else {
                    let itemRect = new (0, _useVirtualizerState.Rect)(this.padding, y, width, height);
                    if (itemRect.intersects(this.requestedRect)) layoutNode = this.buildNode(node, this.padding, y);
                    else {
                        let layoutInfo = new (0, _useVirtualizerState.LayoutInfo)(node.type, node.key, itemRect);
                        layoutInfo.estimatedSize = true;
                        layoutNode = {
                            layoutInfo,
                            validRect: new (0, _useVirtualizerState.Rect)(0, 0, 0, 0),
                            children: [],
                            node
                        };
                    }
                }
                layoutNode.layoutInfo.parentKey = null;
                layoutNode.layoutInfo.allowOverflow = true;
                layoutNode.validRect = layoutNode.layoutInfo.rect.intersection(this.requestedRect);
                this.layoutNodes.set(layoutNode.layoutInfo.key, layoutNode);
                currentBottom = y - this.gap;
            }
            nodes.push(layoutNode);
        }
        return nodes;
    }
    isValid(node, offset) {
        let cached = this.layoutNodes.get(node.key);
        let offsetProperty = this.orientation === 'horizontal' ? 'x' : 'y';
        return !this.invalidateEverything && !!cached && cached.node === node && offset === cached.layoutInfo.rect[offsetProperty] && cached.layoutInfo.rect.intersects(this.validRect) && cached.validRect.containsRect(cached.layoutInfo.rect.intersection(this.requestedRect));
    }
    buildChild(node, x, y, parentKey) {
        if (this.isValid(node, this.orientation === 'horizontal' ? x : y)) return this.layoutNodes.get(node.key);
        let layoutNode = this.buildNode(node, x, y);
        layoutNode.layoutInfo.parentKey = parentKey ?? null;
        layoutNode.layoutInfo.allowOverflow = true;
        this.layoutNodes.set(node.key, layoutNode);
        return layoutNode;
    }
    buildNode(node, x, y) {
        switch(node.type){
            case 'section':
                return this.buildSection(node, x, y);
            case 'item':
                return this.buildItem(node, x, y);
            case 'header':
                return this.buildSectionHeader(node, x, y);
            case 'loader':
                return this.buildLoader(node, x, y);
            case 'separator':
                return this.buildItem(node, x, y);
            default:
                throw new Error('Unsupported node type: ' + node.type);
        }
    }
    buildLoader(node, x, y) {
        let rect = new (0, _useVirtualizerState.Rect)(x, y, this.padding, 0);
        let layoutInfo = new (0, _useVirtualizerState.LayoutInfo)(node.type, node.key, rect);
        // Note that if the user provides isLoading to their sentinel during a case where they only want to render the emptyState, this will reserve
        // room for the loader alongside rendering the emptyState
        if (this.orientation === 'horizontal') {
            rect.height = this.virtualizer.contentSize.height - this.padding - y;
            rect.width = node.props.isLoading ? this.loaderSize ?? this.rowSize ?? this.estimatedRowSize ?? DEFAULT_HEIGHT : 0;
        } else {
            rect.width = this.virtualizer.contentSize.width - this.padding - x;
            rect.height = node.props.isLoading ? this.loaderSize ?? this.rowSize ?? this.estimatedRowSize ?? DEFAULT_HEIGHT : 0;
        }
        return {
            layoutInfo,
            validRect: rect.intersection(this.requestedRect)
        };
    }
    buildSection(node, x, y) {
        if (this.anchorTo === 'end' && this.orientation === 'vertical') throw new Error('ListLayout with anchorTo="end" only supports flat root-level items and an optional root loader.');
        let collection = this.virtualizer.collection;
        let width = this.virtualizer.size.width - this.padding - x;
        let height = this.virtualizer.size.height - this.padding - y;
        let rect = this.orientation === 'horizontal' ? new (0, _useVirtualizerState.Rect)(x, y, 0, height) : new (0, _useVirtualizerState.Rect)(x, y, width, 0);
        let layoutInfo = new (0, _useVirtualizerState.LayoutInfo)(node.type, node.key, rect);
        let offset = this.orientation === 'horizontal' ? x : y;
        let offsetProperty = this.orientation === 'horizontal' ? 'x' : 'y';
        let maxOffsetProperty = this.orientation === 'horizontal' ? 'maxX' : 'maxY';
        let heightProperty = this.orientation === 'horizontal' ? 'width' : 'height';
        let skipped = 0;
        let children = [];
        for (let child of (0, _getChildNodes.getChildNodes)(node, collection)){
            // skip if it is a content node, Tree specific for now, if we add content nodes to other collection items, we might need to reconsider this
            if (child.type === 'content') continue;
            let rowHeight = (this.rowSize ?? this.estimatedRowSize ?? DEFAULT_HEIGHT) + this.gap;
            // Skip rows before the valid rectangle unless they are already cached.
            if (offset + rowHeight < this.requestedRect[offsetProperty] && !this.isValid(node, offset)) {
                offset += rowHeight;
                skipped++;
                continue;
            }
            let layoutNode = this.orientation === 'horizontal' ? this.buildChild(child, offset, y, layoutInfo.key) : this.buildChild(child, x, offset, layoutInfo.key);
            offset = layoutNode.layoutInfo.rect[maxOffsetProperty] + this.gap;
            children.push(layoutNode);
            if (offset > this.requestedRect[maxOffsetProperty]) {
                // Estimate the remaining height for rows that we don't need to layout right now.
                offset += ([
                    ...(0, _getChildNodes.getChildNodes)(node, collection)
                ].length - (children.length + skipped)) * rowHeight;
                break;
            }
        }
        offset -= this.gap;
        rect[heightProperty] = offset - (this.orientation === 'horizontal' ? x : y);
        return {
            layoutInfo,
            children,
            validRect: layoutInfo.rect.intersection(this.requestedRect),
            node
        };
    }
    buildSectionHeader(node, x, y) {
        if (this.anchorTo === 'end' && this.orientation === 'vertical') throw new Error('ListLayout with anchorTo="end" only supports flat root-level items and an optional root loader.');
        let widthProperty = this.orientation === 'horizontal' ? 'height' : 'width';
        let heightProperty = this.orientation === 'horizontal' ? 'width' : 'height';
        let width = this.virtualizer.size[widthProperty] - this.padding - (this.orientation === 'horizontal' ? y : x);
        let rectHeight = this.headingSize;
        let isEstimated = false;
        // If no explicit height is available, use an estimated height.
        if (rectHeight == null) {
            // If a previous version of this layout info exists, reuse its height.
            // Mark as estimated if the size of the overall virtualizer changed,
            // or the content of the item changed.
            let previousLayoutNode = this.layoutNodes.get(node.key);
            let previousLayoutInfo = previousLayoutNode?.layoutInfo;
            if (previousLayoutInfo) {
                let curNode = this.virtualizer.collection.getItem(node.key);
                let lastNode = this.lastCollection ? this.lastCollection.getItem(node.key) : null;
                rectHeight = previousLayoutNode.layoutInfo.rect[heightProperty];
                isEstimated = width !== previousLayoutInfo.rect[widthProperty] || curNode !== lastNode || previousLayoutInfo.estimatedSize;
            } else {
                rectHeight = node.rendered ? this.estimatedHeadingSize : 0;
                isEstimated = true;
            }
        }
        if (rectHeight == null) rectHeight = DEFAULT_HEIGHT;
        let headerRect = this.orientation === 'horizontal' ? new (0, _useVirtualizerState.Rect)(x, y, rectHeight, width - y) : new (0, _useVirtualizerState.Rect)(x, y, width - x, rectHeight);
        let header = new (0, _useVirtualizerState.LayoutInfo)('header', node.key, headerRect);
        header.estimatedSize = isEstimated;
        return {
            layoutInfo: header,
            children: [],
            validRect: header.rect.intersection(this.requestedRect),
            node
        };
    }
    buildItem(node, x, y) {
        let widthProperty = this.orientation === 'horizontal' ? 'height' : 'width';
        let heightProperty = this.orientation === 'horizontal' ? 'width' : 'height';
        let width = this.virtualizer.size[widthProperty] - this.padding - (this.orientation === 'horizontal' ? y : x);
        let rectHeight = this.rowSize;
        let isEstimated = false;
        // If no explicit height is available, use an estimated height.
        if (rectHeight == null) {
            // If a previous version of this layout info exists, reuse its height.
            // Mark as estimated if the size of the overall virtualizer changed,
            // or the content of the item changed.
            let previousLayoutNode = this.layoutNodes.get(node.key);
            if (previousLayoutNode) {
                rectHeight = previousLayoutNode.layoutInfo.rect[heightProperty];
                isEstimated = width !== previousLayoutNode.layoutInfo.rect[widthProperty] || node !== previousLayoutNode.node || previousLayoutNode.layoutInfo.estimatedSize;
            } else {
                rectHeight = this.estimatedRowSize;
                isEstimated = true;
            }
        }
        if (rectHeight == null) rectHeight = DEFAULT_HEIGHT;
        let rect = this.orientation === 'horizontal' ? new (0, _useVirtualizerState.Rect)(x, y, rectHeight, width) : new (0, _useVirtualizerState.Rect)(x, y, width, rectHeight);
        let layoutInfo = new (0, _useVirtualizerState.LayoutInfo)(node.type, node.key, rect);
        layoutInfo.estimatedSize = isEstimated;
        return {
            layoutInfo,
            children: [],
            validRect: layoutInfo.rect.intersection(this.requestedRect),
            node
        };
    }
    updateItemSize(key, size) {
        let layoutNode = this.layoutNodes.get(key);
        // If no layoutInfo, item has been deleted/removed.
        if (!layoutNode) return false;
        let collection = this.virtualizer.collection;
        let layoutInfo = layoutNode.layoutInfo;
        let offsetProperty = this.orientation === 'horizontal' ? 'x' : 'y';
        let heightProperty = this.orientation === 'horizontal' ? 'width' : 'height';
        layoutInfo.estimatedSize = false;
        // Store the real measured height and signal a relayout. Unlike the normal path, we don't
        // adjust validRect/requestedRect here. In a bottom-up layout, each item's absolute y
        // depends on contentLength, which requires summing all item heights first.
        if (this.anchorTo === 'end' && this.orientation === 'vertical') {
            if (layoutInfo.rect[heightProperty] !== size[heightProperty]) {
                let newLayoutInfo = layoutInfo.copy();
                newLayoutInfo.rect[heightProperty] = size[heightProperty];
                newLayoutInfo.estimatedSize = false;
                layoutNode.layoutInfo = newLayoutInfo;
                this.layoutNodes.set(key, layoutNode);
                return true;
            }
            return false;
        }
        if (layoutInfo.rect[heightProperty] !== size[heightProperty]) {
            // Copy layout info rather than mutating so that later caches are invalidated.
            let newLayoutInfo = layoutInfo.copy();
            newLayoutInfo.rect[heightProperty] = size[heightProperty];
            layoutNode.layoutInfo = newLayoutInfo;
            // Items after this layoutInfo will need to be repositioned to account for the new height.
            // Adjust the validRect so that only items above remain valid.
            this.validRect[heightProperty] = Math.min(this.validRect[heightProperty], layoutInfo.rect[offsetProperty] - this.validRect[offsetProperty]);
            // The requestedRect also needs to be adjusted to account for the height difference.
            if (layoutNode.node?.type === 'item') this.requestedRect[heightProperty] += newLayoutInfo.rect[heightProperty] - layoutInfo.rect[heightProperty];
            // Invalidate layout for this layout node and all parents
            this.updateLayoutNode(key, layoutInfo, newLayoutInfo);
            let node = layoutInfo.parentKey != null ? collection.getItem(layoutInfo.parentKey) : null;
            while(node){
                this.updateLayoutNode(node.key, layoutInfo, newLayoutInfo);
                node = node.parentKey != null ? collection.getItem(node.parentKey) : null;
            }
            return true;
        }
        return false;
    }
    updateLayoutNode(key, oldLayoutInfo, newLayoutInfo) {
        let n = this.layoutNodes.get(key);
        if (n) {
            // Invalidate by intersecting the validRect of this node with the overall validRect.
            n.validRect = n.validRect.intersection(this.validRect);
            // Replace layout info in LayoutNode
            if (n.layoutInfo === oldLayoutInfo) n.layoutInfo = newLayoutInfo;
        }
    }
    getContentSize() {
        return this.contentSize;
    }
    getDropTargetFromPoint(x, y, isValidDropTarget) {
        if (this.anchorTo === 'end' && this.orientation === 'vertical') throw new Error('Drag and drop is not supported for ListLayout with anchorTo="end".');
        x += this.virtualizer.visibleRect.x;
        y += this.virtualizer.visibleRect.y;
        // Find the closest item within on either side of the point using the gap width.
        let searchRect = new (0, _useVirtualizerState.Rect)(x, Math.max(0, y - this.gap), 1, Math.max(1, this.gap * 2));
        let candidates = this.getVisibleLayoutInfos(searchRect);
        let key = null;
        let minDistance = Infinity;
        for (let candidate of candidates){
            // Ignore items outside the search rect, e.g. persisted keys.
            if (!candidate.rect.intersects(searchRect)) continue;
            let yDist = Math.abs(candidate.rect.y - y);
            let maxYDist = Math.abs(candidate.rect.maxY - y);
            let dist = Math.min(yDist, maxYDist);
            if (dist < minDistance) {
                minDistance = dist;
                key = candidate.key;
            }
        }
        if (key == null || this.virtualizer.collection.size === 0) return {
            type: 'root'
        };
        let layoutInfo = this.getLayoutInfo(key);
        if (!layoutInfo) return null;
        let rect = layoutInfo.rect;
        let target = {
            type: 'item',
            key: layoutInfo.key,
            dropPosition: 'on'
        };
        // If dropping on the item isn't accepted, try the target before or after depending on the y position.
        // Otherwise, if dropping on the item is accepted, still try the before/after positions if within 10px
        // of the top or bottom of the item.
        if (!isValidDropTarget(target)) {
            if (y <= rect.y + rect.height / 2 && isValidDropTarget({
                ...target,
                dropPosition: 'before'
            })) target.dropPosition = 'before';
            else if (isValidDropTarget({
                ...target,
                dropPosition: 'after'
            })) target.dropPosition = 'after';
        } else if (y <= rect.y + 10 && isValidDropTarget({
            ...target,
            dropPosition: 'before'
        })) target.dropPosition = 'before';
        else if (y >= rect.maxY - 10 && isValidDropTarget({
            ...target,
            dropPosition: 'after'
        })) target.dropPosition = 'after';
        return target;
    }
    getDropTargetLayoutInfo(target) {
        if (this.anchorTo === 'end' && this.orientation === 'vertical') throw new Error('Drag and drop is not supported for ListLayout with anchorTo="end".');
        let layoutInfo = this.getLayoutInfo(target.key);
        let rect;
        if (target.dropPosition === 'before') rect = this.orientation === 'horizontal' ? new (0, _useVirtualizerState.Rect)(Math.max(0, layoutInfo.rect.x - this.dropIndicatorThickness / 2), layoutInfo.rect.y, this.dropIndicatorThickness, layoutInfo.rect.height) : new (0, _useVirtualizerState.Rect)(layoutInfo.rect.x, Math.max(0, layoutInfo.rect.y - this.dropIndicatorThickness / 2), layoutInfo.rect.width, this.dropIndicatorThickness);
        else if (target.dropPosition === 'after') {
            // Render after last visible descendant of the drop target.
            let targetNode = this.collection.getItem(target.key);
            if (targetNode) {
                let targetLevel = targetNode.level ?? 0;
                let currentKey = this.collection.getKeyAfter(target.key);
                while(currentKey != null){
                    let node = this.collection.getItem(currentKey);
                    if (!node || node.level <= targetLevel) break;
                    layoutInfo = this.getLayoutInfo(currentKey) || layoutInfo;
                    currentKey = this.collection.getKeyAfter(currentKey);
                }
            }
            rect = this.orientation === 'horizontal' ? new (0, _useVirtualizerState.Rect)(layoutInfo.rect.maxX - this.dropIndicatorThickness / 2, layoutInfo.rect.y, this.dropIndicatorThickness, layoutInfo.rect.height) : new (0, _useVirtualizerState.Rect)(layoutInfo.rect.x, layoutInfo.rect.maxY - this.dropIndicatorThickness / 2, layoutInfo.rect.width, this.dropIndicatorThickness);
        } else rect = layoutInfo.rect;
        return new (0, _useVirtualizerState.LayoutInfo)('dropIndicator', target.key + ':' + target.dropPosition, rect);
    }
    assertReversedCollectionSupported(nodes) {
        for (let node of nodes){
            if (node.type !== 'item' && node.type !== 'loader' && node.type !== 'separator') throw new Error('ListLayout with anchorTo="end" only supports flat root-level items and an optional root loader.');
            if (node.parentKey != null || node.level > 0 || node.hasChildNodes) throw new Error('ListLayout with anchorTo="end" only supports flat root-level items and an optional root loader.');
        }
    }
}
function toArray(collection, predicate) {
    const result = [];
    for (const node of collection)if (predicate(node)) result.push(node);
    return result;
}

},{"react-stately/private/collections/getChildNodes":"4tUiJ","react-stately/useVirtualizerState":[["Layout","4EHQh"],["LayoutInfo","4F7TD"],["Rect","fPqfL"],["Size","46Qnl"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"YD96B":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a token field.
 * A token field allows users to enter text with inline tokens.
 *
 * @param props - Props for the token field.
 * @param state - State for the token field, as returned by `useTokenFieldState`.
 */ parcelHelpers.export(exports, "useTokenField", ()=>useTokenField);
parcelHelpers.export(exports, "getSelection", ()=>getSelection);
parcelHelpers.export(exports, "getSelectedRange", ()=>getSelectedRange);
parcelHelpers.export(exports, "setTokenFieldSelection", ()=>setTokenFieldSelection);
parcelHelpers.export(exports, "tokenFieldPositionToDOMRange", ()=>tokenFieldPositionToDOMRange);
var _liveAnnouncer = require("../live-announcer/LiveAnnouncer");
var _react = require("react");
var _domfunctions = require("../utils/shadowdom/DOMFunctions");
var _domHelpers = require("../utils/domHelpers");
var _platform = require("../utils/platform");
var _mergeProps = require("../utils/mergeProps");
var _useTokenFieldState = require("react-stately/useTokenFieldState");
var _useFocusVisible = require("../interactions/useFocusVisible");
var _useEvent = require("../utils/useEvent");
var _useField = require("../label/useField");
var _useFocusable = require("../interactions/useFocusable");
var _useKeyboard = require("../interactions/useKeyboard");
var _useLayoutEffect = require("../utils/useLayoutEffect");
var _i18Nprovider = require("../i18n/I18nProvider");
const CLIPBOARD_MIME_TYPE = 'application/vnd.react-aria.tokens+json';
function useTokenField(props, state, ref) {
    let { role = 'textbox', allowsNewlines: multiline = false, isReadOnly = false, isDisabled = false, 'aria-details': ariaDetails } = props;
    let { value } = state;
    let { locale } = (0, _i18Nprovider.useLocale)();
    let graphemeSegmenter = (0, _react.useMemo)(()=>new Intl.Segmenter(locale, {
            granularity: 'grapheme'
        }), [
        locale
    ]);
    let wordSegmenter = (0, _react.useMemo)(()=>new Intl.Segmenter(locale, {
            granularity: 'word'
        }), [
        locale
    ]);
    let dropPosition = (0, _react.useRef)(null);
    let transferredData = (0, _react.useRef)(null);
    let nextValue = (0, _react.useRef)(null);
    let apply = (fn)=>{
        state.setValue((value)=>{
            let newValue = fn(value);
            nextValue.current = newValue;
            return newValue;
        });
    };
    // Composition events are not cancelable. The browser will mutate the DOM, making it out of sync with React.
    // To account for this, we prevent React from re-rendering during composition, and track DOM mutations performed
    // by the browser. When composition ends, we revert the DOM to its original state, and re-render with React.
    // Mutating the DOM in any way during composition breaks the IME, causing composition to end unexpectedly.
    // During composition, we still emit updates via onChange to ensure that things like autocomplete work,
    // but we don't actually re-render to the DOM unless the value changes from what we expect (e.g. inserting a completion).
    let mutationTracker = useMutationTracker(ref);
    let startComposition = (0, _react.useCallback)(()=>{
        mutationTracker.start();
        state.setComposing(true);
    }, [
        state,
        mutationTracker
    ]);
    let stopComposition = (0, _react.useCallback)(()=>{
        mutationTracker.stop();
        state.setComposing(false);
    }, [
        state,
        mutationTracker
    ]);
    (0, _useEvent.useEvent)(ref, 'compositionstart', ()=>{
        startComposition();
        let range = window.getSelection()?.getRangeAt(0);
        if (range) {
            let [start, end] = rangeToPositions(ref.current, range);
            // Normalize the range to ensure it is not inside a token, otherwise the browser
            // will attempt to insert the composed text into the token instead of replacing it.
            let r = createDOMRange(ref.current, start, end);
            if (r.startContainer !== range.startContainer || r.startOffset !== range.startOffset) range.setStart(r.startContainer, r.startOffset);
            if (r.endContainer !== range.endContainer || r.endOffset !== range.endOffset) range.setEnd(r.endContainer, r.endOffset);
        }
    });
    (0, _useEvent.useEvent)(ref, 'compositionend', stopComposition);
    // If a prop update occurs during composition that doesn't match the expected value,
    // end composition and re-render the controlled value.
    (0, _useLayoutEffect.useLayoutEffect)(()=>{
        if (state.isComposing && value !== nextValue.current) stopComposition();
        nextValue.current = value;
    });
    let selectedRange = (0, _react.useRef)(null);
    (0, _useLayoutEffect.useLayoutEffect)(()=>{
        if (ref.current && !state.isComposing && value.selectedRange !== selectedRange.current) {
            // Only move the caret when the field is already focused.
            if (ref.current === (0, _domfunctions.getActiveElement)((0, _domHelpers.getOwnerDocument)(ref.current))) {
                setTokenFieldSelection(ref.current, value.selectedRange);
                announceToken(value);
            }
            selectedRange.current = value.selectedRange;
        }
    });
    // Handle text editing commands and prevent browser default behavior.
    (0, _useEvent.useEvent)(ref, 'beforeinput', (e)=>{
        // Android sometimes doesn't fire a compositionend event before a regular input event.
        if (state.isComposing && !e.isComposing) stopComposition();
        let range = e.getTargetRanges()[0];
        if (!range) {
            let selection = window.getSelection();
            if (!selection || selection.rangeCount === 0) return;
            range = selection.getRangeAt(0);
        }
        let [start, end] = rangeToPositions(ref.current, range);
        // https://www.w3.org/TR/input-events-2/#interface-InputEvent-Attributes
        switch(e.inputType){
            case 'insertText':
            case 'insertReplacementText':
            case 'insertCompositionText':
            case 'insertFromComposition':
            case 'insertFromPaste':
            case 'insertFromYank':
            case 'insertFromDrop':
                {
                    let data = [
                        {
                            type: 'text',
                            text: e.data ?? ''
                        }
                    ];
                    if (transferredData.current) {
                        data = transferredData.current;
                        transferredData.current = null;
                    } else if (e.dataTransfer) {
                        let parsed = e.dataTransfer.types.includes(CLIPBOARD_MIME_TYPE) ? parseSegments(e.dataTransfer.getData(CLIPBOARD_MIME_TYPE)) : null;
                        if (parsed) data = parsed;
                        else if (e.dataTransfer.types.includes('text/plain')) data[0].text = e.dataTransfer.getData('text/plain');
                    }
                    if (e.inputType === 'insertFromDrop' && dropPosition.current) {
                        start = end = dropPosition.current;
                        dropPosition.current = null;
                    }
                    if (!multiline) for (let segment of data)segment.text = segment.text.replace(/[\r\n]+/g, ' ');
                    apply((tokens)=>tokens.replaceRangeWithSegments(start, end, data, // Don't coalesce paste/drop events with other edits.
                        e.inputType === 'insertText' || e.inputType === 'insertCompositionText' || e.inputType === 'insertFromComposition'));
                    break;
                }
            case 'insertParagraph':
                if (props.onSubmit) {
                    props.onSubmit();
                    break;
                }
            case 'insertLineBreak':
                if (multiline) apply((tokens)=>tokens.replaceRange(start, end, '\n'));
                break;
            case 'deleteContentBackward':
            case 'deleteContentForward':
            case 'deleteWordBackward':
            case 'deleteWordForward':
            case 'deleteHardLineForward':
            case 'deleteHardLineBackward':
            case 'deleteSoftLineForward':
            case 'deleteSoftLineBackward':
            case 'deleteContent':
            case 'deleteByCut':
            case 'deleteCompositionText':
                if (!range.collapsed && !isSamePosition(start, end)) {
                    apply((tokens)=>tokens.replaceRange(start, end, ''));
                    break;
                }
                switch(e.inputType){
                    case 'deleteContentBackward':
                        apply((tokens)=>tokens.delete(start, graphemeSegmenter, (0, _useTokenFieldState.TokenFieldValue).Direction.Backward));
                        break;
                    case 'deleteContentForward':
                        apply((tokens)=>tokens.delete(start, graphemeSegmenter, (0, _useTokenFieldState.TokenFieldValue).Direction.Forward));
                        break;
                    case 'deleteWordBackward':
                        apply((tokens)=>tokens.delete(start, wordSegmenter, (0, _useTokenFieldState.TokenFieldValue).Direction.Backward));
                        break;
                    case 'deleteWordForward':
                        apply((tokens)=>tokens.delete(start, wordSegmenter, (0, _useTokenFieldState.TokenFieldValue).Direction.Forward));
                        break;
                    case 'deleteHardLineForward':
                    case 'deleteSoftLineForward':
                        apply((tokens)=>tokens.deleteLine(start, (0, _useTokenFieldState.TokenFieldValue).Direction.Forward));
                        break;
                    case 'deleteHardLineBackward':
                    case 'deleteSoftLineBackward':
                        apply((tokens)=>tokens.deleteLine(start, (0, _useTokenFieldState.TokenFieldValue).Direction.Backward));
                        break;
                }
                break;
            case 'deleteByDrag':
                apply((tokens)=>{
                    let endOffset = start.index === end.index ? end.offset : tokens.segments[start.index].text.length;
                    let change = tokens.replaceRange(start, end, '');
                    if (dropPosition.current && dropPosition.current.index === start.index && dropPosition.current.offset >= start.offset) dropPosition.current.offset -= endOffset - start.offset;
                    return change;
                });
                break;
        }
        e.preventDefault();
    });
    let writeClipboardData = (e)=>{
        if ('clipboardData' in e) e.preventDefault();
        let selection = getSelection(ref.current);
        if (!selection) return;
        let [start, end] = selection;
        let slice = value.slice(start, end);
        let dataTransfer = 'clipboardData' in e ? e.clipboardData : e.dataTransfer;
        dataTransfer?.setData(CLIPBOARD_MIME_TYPE, JSON.stringify(slice.segments));
        dataTransfer?.setData('text/plain', slice.toString());
        if (e.type === 'cut') apply((tokens)=>tokens.replaceRange(start, end, '', false));
    };
    (0, _useEvent.useEvent)(ref, 'copy', writeClipboardData);
    (0, _useEvent.useEvent)(ref, 'cut', writeClipboardData);
    (0, _useEvent.useEvent)(ref, 'dragstart', writeClipboardData);
    (0, _useEvent.useEvent)(ref, 'paste', (e)=>{
        // Safari doesn't pass the custom clipboard data type to beforeinput dataTransfer so we handle it here.
        if (e.clipboardData && e.clipboardData.types.includes(CLIPBOARD_MIME_TYPE)) transferredData.current = parseSegments(e.clipboardData.getData(CLIPBOARD_MIME_TYPE));
    });
    // Store the cursor position on drop so we know where to insert when the insertFromDrop event occurs.
    (0, _useEvent.useEvent)(ref, 'drop', (e)=>{
        if (typeof document.caretPositionFromPoint === 'function') {
            let pos = document.caretPositionFromPoint(e.clientX, e.clientY);
            if (pos) dropPosition.current = getPosition(ref.current, pos.offsetNode, pos.offset);
        } else if (typeof document.caretRangeFromPoint === 'function') {
            let range = document.caretRangeFromPoint(e.clientX, e.clientY);
            if (range) dropPosition.current = getPosition(ref.current, range.startContainer, range.startOffset);
        }
        if (e.dataTransfer && e.dataTransfer.types.includes(CLIPBOARD_MIME_TYPE)) transferredData.current = parseSegments(e.dataTransfer.getData(CLIPBOARD_MIME_TYPE));
    });
    useSelectionChange(ref, ()=>{
        if (state.isComposing) return;
        value.endCoalescing();
        // When the cursor moves next to a token, announce it.
        // Otherwise the screen reader will only announce the first/last character.
        let range = getSelectedRange(ref.current);
        if (!range) return;
        announceToken(value, range);
        // Update the selected range in the value.
        state.setValue((value)=>value.withSelectedRange(range));
    });
    // Clear selection on blur.
    (0, _useEvent.useEvent)(ref, 'blur', (e)=>{
        if (!e.isTrusted) return;
        let selection = window.getSelection();
        if (ref.current && selection && selection.containsNode(ref.current, true)) {
            selection.removeAllRanges();
            state.setValue((value)=>value.withSelectedRange(new (0, _useTokenFieldState.TokenFieldValue).SelectedRange(value.caretPosition)));
        }
    });
    // Override the default triple click behavior to ensure that tokens get selected.
    // Some browsers only select the text between tokens instead of the entire line.
    (0, _useEvent.useEvent)(ref, 'mousedown', (e)=>{
        if (e.detail === 3) {
            let selection = getSelection(ref.current);
            if (!selection) return;
            let start = value.findLineBoundary(selection[0], (0, _useTokenFieldState.TokenFieldValue).Direction.Backward);
            let end = value.findLineBoundary(selection[1], (0, _useTokenFieldState.TokenFieldValue).Direction.Forward);
            if (start && end) {
                e.preventDefault();
                setTokenFieldSelection(ref.current, new (0, _useTokenFieldState.TokenFieldValue).SelectedRange(start, end), true);
            }
        }
    });
    let moveSelection = (direction, granularity, extend = false)=>{
        let selection = window.getSelection();
        if (!selection || selection.rangeCount === 0 || !selection.focusNode || !selection.anchorNode) return false;
        // Pressing an arrow with a non-empty selection collapses it to the corresponding edge.
        // The browser handles this natively.
        if (!extend && !selection.isCollapsed) return false;
        // Move the caret using the browser's native caret movement (Selection.modify) so that
        // bidirectional text is handled correctly. Repeat until the position actually changes
        // to account for the zero width spaces around tokens.
        let pos = getPosition(ref.current, selection.focusNode, selection.focusOffset);
        while(true){
            let { focusNode, focusOffset } = selection;
            selection.modify(extend ? 'extend' : 'move', direction, granularity);
            if (selection.focusNode === focusNode && selection.focusOffset === focusOffset) return false;
            let newPos = getPosition(ref.current, selection.focusNode, selection.focusOffset);
            if (!isSamePosition(pos, newPos)) return true;
        }
    };
    // macOS supports additional keyboard shortcuts for text editing.
    // We need to handle these manually so they behave consistently with tokens.
    // https://support.apple.com/en-us/102650#text
    let macShortcuts = (0, _platform.isMac)() ? {
        'Control+a': ()=>{
            return shortcuts.Home();
        },
        'Control+e': ()=>{
            return shortcuts.End();
        },
        'Control+f': ()=>{
            return shortcuts.ArrowRight();
        },
        'Control+b': ()=>{
            return shortcuts.ArrowLeft();
        }
    } : {};
    let mod = (0, _platform.isMac)() ? 'Meta' : 'Control';
    let wordModKey = (0, _platform.isMac)() ? 'Alt' : 'Control';
    let shortcuts = {
        ...macShortcuts,
        [`${mod}+z`]: ()=>{
            // If composing, the browser handles undo natively.
            if (state.isComposing) return false;
            apply((state)=>state.undo());
        },
        [(0, _platform.isMac)() ? 'Shift+Meta+z' : 'Control+y']: ()=>{
            if (state.isComposing) return false;
            apply((state)=>state.redo());
        },
        ArrowLeft: ()=>{
            return moveSelection('left', 'character');
        },
        [`${wordModKey}+ArrowLeft`]: ()=>{
            return moveSelection('left', 'word');
        },
        'Shift+ArrowLeft': ()=>{
            return moveSelection('left', 'character', true);
        },
        [`Shift+${wordModKey}+ArrowLeft`]: ()=>{
            return moveSelection('left', 'word', true);
        },
        ArrowRight: ()=>{
            return moveSelection('right', 'character');
        },
        [`${wordModKey}+ArrowRight`]: ()=>{
            return moveSelection('right', 'word');
        },
        'Shift+ArrowRight': ()=>{
            return moveSelection('right', 'character', true);
        },
        [`Shift+${wordModKey}+ArrowRight`]: ()=>{
            return moveSelection('right', 'word', true);
        },
        Home: ()=>{
            // Browsers do not behave consistently when there are tokens.
            let selection = getSelection(ref.current);
            if (!selection) return false;
            let boundary = value.findLineBoundary(selection[0], (0, _useTokenFieldState.TokenFieldValue).Direction.Backward);
            if (boundary) {
                setCursor(ref.current, boundary, true);
                return true;
            }
            return false;
        },
        End: ()=>{
            let selection = getSelection(ref.current);
            if (!selection) return false;
            let boundary = value.findLineBoundary(selection[1], (0, _useTokenFieldState.TokenFieldValue).Direction.Forward);
            if (boundary) {
                setCursor(ref.current, boundary, true);
                return true;
            }
            return false;
        }
    };
    // TODO: user provided onKeyDown currently relies on user provided preventDefault to stop submit
    // maybe can have them specify a format like shortcuts and merge into above?
    let { keyboardProps } = (0, _useKeyboard.useKeyboard)({
        isDisabled: isDisabled || isReadOnly,
        onKeyDown: props.onKeyDown,
        onKeyUp: props.onKeyUp,
        shortcuts: shortcuts,
        allowRepeats: true
    });
    let { focusableProps } = (0, _useFocusable.useFocusable)(props, ref);
    let { labelProps, fieldProps, descriptionProps } = (0, _useField.useField)({
        ...props,
        labelElementType: 'span'
    });
    return {
        labelProps: {
            ...labelProps,
            onClick: ()=>{
                if (!props.isDisabled) {
                    ref.current?.focus();
                    // Show the focus ring so the user knows where focus went
                    (0, _useFocusVisible.setInteractionModality)('keyboard');
                }
            }
        },
        descriptionProps,
        tokenFieldProps: (0, _mergeProps.mergeProps)(focusableProps, keyboardProps, fieldProps, {
            onPaste: props.onPaste,
            onCopy: props.onCopy,
            onCut: props.onCut,
            contentEditable: !isDisabled && !isReadOnly,
            suppressContentEditableWarning: true,
            role,
            'aria-multiline': multiline,
            'aria-details': ariaDetails,
            'aria-readonly': isReadOnly,
            'aria-disabled': isDisabled,
            style: {
                whiteSpace: 'pre-wrap'
            }
        })
    };
}
function indexOfNode(node) {
    let index = 0;
    let n = node;
    while(n = n.previousSibling)index++;
    return index;
}
function getSelection(container) {
    let selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return null;
    let range = selection.getRangeAt(0);
    return rangeToPositions(container, range);
}
function getSelectedRange(container) {
    let selection = window.getSelection();
    if (!selection || !selection.anchorNode || !selection.focusNode || !(0, _domfunctions.nodeContains)(container, selection.anchorNode) || !(0, _domfunctions.nodeContains)(container, selection.focusNode)) return null;
    let anchor = getPosition(container, selection.anchorNode, selection.anchorOffset, false);
    let current = getPosition(container, selection.focusNode, selection.focusOffset, !selection.isCollapsed);
    return new (0, _useTokenFieldState.TokenFieldValue).SelectedRange(anchor, current);
}
function rangeToPositions(container, range) {
    let start = getPosition(container, range.startContainer, range.startOffset, false);
    let end = getPosition(container, range.endContainer, range.endOffset, !range.collapsed);
    return [
        start,
        end
    ];
}
function getPosition(container, node, offset, isRangeEnd = false) {
    if (node === container) return {
        index: offset,
        offset: 0
    };
    let originalNode = node;
    while(node.parentNode !== container)node = node.parentNode;
    let index = indexOfNode(node);
    if (node.nodeType === Node.ELEMENT_NODE) {
        let tokenNode = node.childNodes[1];
        let atEnd;
        let endOffset = 0;
        if (originalNode === tokenNode) // Cursor is inside the token.
        atEnd = isRangeEnd || offset > 0;
        else if (originalNode === node) // Cursor is inside the wrapper element.
        atEnd = offset > 1;
        else {
            // Cursor is on one of the zero width spaces.
            atEnd = originalNode !== tokenNode.previousSibling;
            // If the offset is greater than 1, the browser is trying to insert text into
            // the zero width space node. This will actually end up in the next text node.
            endOffset = atEnd && offset > 1 ? offset - 1 : 0;
        }
        offset = atEnd ? tokenNode?.textContent?.length ?? 0 : 0;
        // Several positions are equivalent due to the zero width spaces around tokens.
        // Normalize offset to the end of the preceding text node, or the beginning of the following node.
        if (offset === 0 && node.previousSibling?.nodeType === Node.TEXT_NODE) {
            index--;
            offset = node.previousSibling?.textContent?.length ?? 0;
        } else if (atEnd) {
            index++;
            offset = endOffset;
        }
    }
    return {
        index,
        offset
    };
}
let isProgrammaticSelectionChange = Symbol('isProgrammaticSelectionChange');
function setCursor(root, pos, fireEvent = false) {
    setTokenFieldSelection(root, new (0, _useTokenFieldState.TokenFieldValue).SelectedRange(pos), fireEvent);
}
function setTokenFieldSelection(root, selectedRange, fireEvent = false) {
    let selection = window.getSelection();
    if (selection) {
        // Use setBaseAndExtent to preserve the selection direction. A plain Range +
        // addRange always produces a forward selection and collapses when the
        // anchor comes after the current position (backward selections).
        let [anchorNode, anchorOffset] = getDOMPosition(root, selectedRange.anchor);
        let [focusNode, focusOffset] = getDOMPosition(root, selectedRange.current);
        root[isProgrammaticSelectionChange] = !fireEvent;
        // Only set selection if it has changed, because this can clobber the browser's selection direction.
        if (selection.anchorNode !== anchorNode || selection.anchorOffset !== anchorOffset || selection.focusNode !== focusNode || selection.focusOffset !== focusOffset) selection.setBaseAndExtent(anchorNode, anchorOffset, focusNode, focusOffset);
    }
}
function tokenFieldPositionToDOMRange(root, pos) {
    // Unlike createDOMRange (used for caret/selection placement), this range is only
    // measured via getBoundingClientRect to position things like an autocomplete popover.
    // Place the endpoints inside the token's zero width space wrappers so the range has a
    // valid rect at the token, rather than a collapsed root-level position.
    let range = document.createRange();
    let [startContainer, startOffset] = getDOMRectPosition(root, pos);
    range.setStart(startContainer, startOffset);
    range.setEnd(startContainer, startOffset);
    return range;
}
function getDOMRectPosition(root, pos) {
    let child = root.childNodes[pos.index];
    if (child && child.nodeType === Node.ELEMENT_NODE) {
        // Place the position inside the zero width space wrappers around the token.
        if (pos.offset > 0) return [
            child.lastChild,
            1
        ];
        else return [
            child.firstChild,
            0
        ];
    }
    return getDOMPosition(root, pos);
}
function createDOMRange(root, start, end) {
    let range = document.createRange();
    let [startContainer, startOffset] = getDOMPosition(root, start);
    let [endContainer, endOffset] = getDOMPosition(root, end);
    range.setStart(startContainer, startOffset);
    range.setEnd(endContainer, endOffset);
    return range;
}
function getDOMPosition(root, pos) {
    let index = Math.max(0, Math.min(root.childNodes.length, pos.index));
    let child = root.childNodes[index];
    if (!child) return [
        root,
        index
    ];
    else if (child.nodeType === Node.ELEMENT_NODE) {
        // Place the cursor outside the token wrapper element.
        // This is necessary for composition events.
        if (pos.offset > 0) return [
            root,
            index + 1
        ];
        else return [
            root,
            index
        ];
    } else {
        let offset = Math.max(0, Math.min(child.textContent?.length ?? 0, pos.offset));
        return [
            child,
            offset
        ];
    }
}
function isSamePosition(a, b) {
    return a.index === b.index && a.offset === b.offset;
}
// Parse and validate segments from clipboard/drag data. Returns null if the data is not valid
// JSON or does not match the expected shape, so malformed or untrusted data is ignored rather
// than throwing or being inserted into the field.
function parseSegments(json) {
    try {
        let data = JSON.parse(json);
        if (Array.isArray(data) && data.length > 0 && data.every(isValidSegment)) return data;
    } catch  {
    // Ignore invalid clipboard data.
    }
    return null;
}
function isValidSegment(segment) {
    return typeof segment === 'object' && segment != null && (segment.type === 'text' || segment.type === 'token') && typeof segment.text === 'string';
}
function useSelectionChange(ref, handler) {
    (0, _useEvent.useEvent)((0, _react.useRef)(typeof document !== 'undefined' ? document : null), 'selectionchange', ()=>{
        if (ref.current && ref.current[isProgrammaticSelectionChange]) {
            ref.current[isProgrammaticSelectionChange] = false;
            return;
        }
        let selection = window.getSelection();
        if (!selection || selection.rangeCount === 0 || !ref.current) return;
        let range = selection.getRangeAt(0);
        if (range.intersectsNode(ref.current)) handler();
    });
}
function useMutationTracker(ref) {
    let mutationTracker = (0, _react.useRef)(null);
    // Disconnect the mutation observer if the field unmounts mid-composition.
    (0, _useLayoutEffect.useLayoutEffect)(()=>()=>{
            mutationTracker.current?.();
            mutationTracker.current = null;
        }, []);
    return (0, _react.useMemo)(()=>({
            start () {
                // Android sometimes fires two compositionstart events in a row, without a compositionend.
                // In that case, reuse the existing tracker.
                mutationTracker.current ||= trackMutations(ref.current);
            },
            stop () {
                mutationTracker.current?.();
                mutationTracker.current = null;
            }
        }), // eslint-disable-next-line react-hooks/exhaustive-deps - conflicts with compiler
    []);
}
// Tracks mutations to the DOM until the returned function is called,
// at which point the mutations are reverted.
function trackMutations(element) {
    let mutations = [];
    let observer = new MutationObserver((records)=>{
        mutations.push(...records);
    });
    observer.observe(element, {
        childList: true,
        subtree: true,
        characterData: true,
        characterDataOldValue: true
    });
    return ()=>{
        mutations.push(...observer.takeRecords());
        observer.disconnect();
        for (let record of mutations.reverse())switch(record.type){
            case 'childList':
                for (let node of record.removedNodes)record.target.insertBefore(node, record.nextSibling);
                for (let node of record.addedNodes)record.target.removeChild(node);
                break;
            case 'characterData':
                record.target.nodeValue = record.oldValue;
                break;
        }
    };
}
function announceToken(value, range = value.selectedRange) {
    if (range.isCollapsed) {
        // Announce adjacent tokens.
        let segment = value.segments[range.current.index];
        if (segment && segment.type !== 'token') {
            if (range.current.offset === 0) segment = value.segments[range.current.index - 1];
            else if (range.current.offset === segment.text.length) segment = value.segments[range.current.index + 1];
        }
        if (segment?.type === 'token') (0, _liveAnnouncer.announce)(segment.text, 'assertive');
    } else {
        // Announce token if it is the only thing selected.
        let selected = value.slice(range.start, range.end).segments;
        if (selected.length === 1 && selected[0].type === 'token') (0, _liveAnnouncer.announce)(selected[0].text, 'assertive');
    }
}

},{"../live-announcer/LiveAnnouncer":"1Ww5F","react":"a1TxN","../utils/shadowdom/DOMFunctions":"93ERU","../utils/domHelpers":"cOsVz","../utils/platform":"hqE84","../utils/mergeProps":"1CzGd","react-stately/useTokenFieldState":"bUglb","../interactions/useFocusVisible":"9a2nM","../utils/useEvent":"lMVDh","../label/useField":"1B1oA","../interactions/useFocusable":"8M8mb","../interactions/useKeyboard":"jUMGt","../utils/useLayoutEffect":"k6VV7","../i18n/I18nProvider":"l34Wn","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jdTUJ":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenFieldContext", ()=>TokenFieldContext);
parcelHelpers.export(exports, "TokenField", ()=>TokenField);
parcelHelpers.export(exports, "TokenInput", ()=>TokenInput);
parcelHelpers.export(exports, "Token", ()=>Token);
var _utils = require("./utils");
var _hidden = require("react-aria/private/collections/Hidden");
var _autocomplete = require("./Autocomplete");
var _filterDOMProps = require("react-aria/filterDOMProps");
var _useHover = require("react-aria/useHover");
var _domHelpers = require("react-aria/private/utils/domHelpers");
var _label = require("./Label");
var _mergeProps = require("react-aria/mergeProps");
var _mergeRefs = require("react-aria/mergeRefs");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("./Text");
var _useTokenFieldState = require("react-stately/useTokenFieldState");
var _useFocusRing = require("react-aria/useFocusRing");
var _useLayoutEffect = require("react-aria/private/utils/useLayoutEffect");
var _useObjectRef = require("react-aria/useObjectRef");
var _useTokenField = require("react-aria/useTokenField");
const TokenFieldContext = /*#__PURE__*/ (0, _react.createContext)(null);
const TokenInputContext = /*#__PURE__*/ (0, _react.createContext)(null);
const TokenField = /*#__PURE__*/ (0, _hidden.createHideableComponent)(function TokenField(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, TokenFieldContext);
    let [labelRef, label] = (0, _utils.useSlot)(!props['aria-label'] && !props['aria-labelledby']);
    let fieldCtx = (0, _utils.useSlottedContext)((0, _autocomplete.FieldInputContext), props.slot);
    let { value: _autocompleteValue, onChange: onAutocompleteChange, ref: autocompleteRef, ...autocompleteProps } = fieldCtx ?? {};
    let inputRef = (0, _useObjectRef.useObjectRef)(autocompleteRef);
    let isDisabled = props.isDisabled || false;
    let isReadOnly = props.isReadOnly || false;
    let state = (0, _useTokenFieldState.useTokenFieldState)({
        ...props,
        onChange: (value)=>{
            props.onChange?.(value);
            onAutocompleteChange?.(value.toString());
        }
    });
    let { tokenFieldProps, labelProps, descriptionProps } = (0, _useTokenField.useTokenField)({
        ...props,
        // @ts-ignore - not a public prop, used to determine if slot is present
        label,
        role: props.role || autocompleteProps['role'] || 'textbox'
    }, state, inputRef);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        values: {
            isDisabled,
            isReadOnly
        },
        defaultClassName: 'react-aria-TokenField'
    });
    let DOMProps = (0, _filterDOMProps.filterDOMProps)(props, {
        global: true
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.dom).div, {
        ...DOMProps,
        ...renderProps,
        ref: ref,
        slot: props.slot || undefined,
        "data-disabled": isDisabled || undefined,
        "data-readonly": isReadOnly || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _label.LabelContext),
                {
                    ...labelProps,
                    elementType: 'span',
                    ref: labelRef
                }
            ],
            [
                (0, _text.TextContext),
                {
                    slots: {
                        description: descriptionProps
                    }
                }
            ],
            [
                TokenInputContext,
                {
                    tokenFieldProps,
                    state: state,
                    isDisabled,
                    isReadOnly,
                    autocompleteProps: autocompleteProps,
                    ref: inputRef
                }
            ]
        ]
    }, renderProps.children));
});
const TokenInput = /*#__PURE__*/ (0, _react.forwardRef)(function TokenInput(props, forwardedRef) {
    let { tokenFieldProps, state, isDisabled = false, isReadOnly = false, autocompleteProps, ref: contextRef } = (0, _react.useContext)(TokenInputContext);
    let ref = (0, _react.useMemo)(()=>(0, _mergeRefs.mergeRefs)(contextRef, forwardedRef), [
        contextRef,
        forwardedRef
    ]);
    let { children, ...domProps } = props;
    let { isHovered, hoverProps } = (0, _useHover.useHover)(domProps);
    let { isFocused, isFocusVisible, focusProps } = (0, _useFocusRing.useFocusRing)();
    let renderProps = (0, _utils.useRenderProps)({
        ...domProps,
        defaultClassName: 'react-aria-TokenInput',
        values: {
            isHovered,
            isFocused,
            isFocusVisible,
            isDisabled,
            isReadOnly
        }
    });
    let DOMProps = (0, _filterDOMProps.filterDOMProps)(domProps, {
        global: true
    });
    let objectRef = (0, _useObjectRef.useObjectRef)(ref);
    (0, _useLayoutEffect.useLayoutEffect)(()=>insertSelectionStyle(objectRef), [
        objectRef
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.dom).div, {
        ...(0, _mergeProps.mergeProps)(DOMProps, renderProps, focusProps, hoverProps, tokenFieldProps, autocompleteProps),
        ref: objectRef,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-disabled": isDisabled || undefined,
        "data-readonly": isReadOnly || undefined,
        style: {
            ...renderProps.style,
            ...tokenFieldProps?.style
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(CompositionRenderBlocker, {
        isComposing: state.isComposing
    }, state.value.segments.map((v, i)=>{
        switch(v.type){
            case 'token':
                {
                    let token = children(v);
                    return(// Wrap tokens in zero-width spaces so the cursor is placed correctly.
                    /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                        key: i,
                        "data-react-aria-token": true
                    }, '\u200b', token, '\u200b'));
                }
            case 'text':
                return v.text;
        }
    }), state.value.segments.at(-1)?.text.endsWith('\n') && /*#__PURE__*/ (0, _reactDefault.default).createElement("br", null)));
});
const Token = /*#__PURE__*/ (0, _react.forwardRef)(function Token(props, ref) {
    let { isDisabled } = (0, _react.useContext)(TokenInputContext);
    let objectRef = (0, _useObjectRef.useObjectRef)(ref);
    let { tokenProps, isSelected } = (0, _useTokenField.useToken)(props, {}, objectRef);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        defaultClassName: 'react-aria-Token',
        values: {
            isSelected,
            isDisabled
        }
    });
    let DOMProps = (0, _filterDOMProps.filterDOMProps)(props, {
        global: true
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.dom).span, {
        ref: objectRef,
        ...(0, _mergeProps.mergeProps)(DOMProps, renderProps, tokenProps),
        "data-selected": isSelected || undefined,
        "data-disabled": isDisabled || undefined,
        style: {
            ...renderProps.style,
            ...tokenProps.style
        }
    }, renderProps.children);
});
// Prevents React from re-rendering during composition events.
const CompositionRenderBlocker = /*#__PURE__*/ (0, _react.memo)(({ children })=>children, (prevProps, nextProps)=>nextProps.isComposing ? true : prevProps.children === nextProps.children);
// Inserts a stylesheet into the document / shadow root that hides the native text selection on tokens.
function insertSelectionStyle(ref) {
    if (typeof CSSStyleSheet !== 'function' || !ref || !ref.current) return;
    let root = ref.current.getRootNode();
    if (!(0, _domHelpers.isDocument)(root) && !(0, _domHelpers.isShadowRoot)(root)) return;
    if (!root.adoptedStyleSheets) return;
    // Skip if we already inserted it.
    let sym = Symbol.for('react-aria-token-style');
    if (root.adoptedStyleSheets.some((s)=>s[sym])) return;
    let style = new CSSStyleSheet();
    style[sym] = true;
    // Firefox ignores completely transparent selection colors, so use a nearly transparent color instead.
    style.replaceSync('[data-react-aria-token]::selection,[data-react-aria-token]>*::selection{background:#ffffff01}');
    root.adoptedStyleSheets.push(style);
    return ()=>{
        let index = root.adoptedStyleSheets.indexOf(style);
        if (index >= 0) root.adoptedStyleSheets.splice(index, 1);
    };
}

},{"./utils":"bA6Cz","react-aria/private/collections/Hidden":"dY6qg","./Autocomplete":"92IrI","react-aria/filterDOMProps":"c0Owd","react-aria/useHover":"9zlAr","react-aria/private/utils/domHelpers":"cOsVz","./Label":"fjKq6","react-aria/mergeProps":"1CzGd","react-aria/mergeRefs":"h7MZp","react":"a1TxN","./Text":"jt9fm","react-stately/useTokenFieldState":"96oTS","react-aria/useFocusRing":"5qaYX","react-aria/private/utils/useLayoutEffect":"k6VV7","react-aria/useObjectRef":"hJ6Rk","react-aria/useTokenField":[["useToken","e0qRc"],["useTokenField","YD96B"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"96oTS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides state management for a token field. Tracks the field value and the
 * composition state.
 */ parcelHelpers.export(exports, "useTokenFieldState", ()=>useTokenFieldState);
var _tokenFieldValue = require("./TokenFieldValue");
var _useControlledState = require("../utils/useControlledState");
var _react = require("react");
function useTokenFieldState(props) {
    let { value: valueProp, defaultValue: defaultValueProp = new (0, _tokenFieldValue.TokenFieldValue)([]), onChange } = props;
    let [value, setValue] = (0, _useControlledState.useControlledState)(valueProp, defaultValueProp, onChange);
    let [isComposing, setComposing] = (0, _react.useState)(false);
    return {
        value,
        setValue,
        isComposing,
        setComposing
    };
}

},{"./TokenFieldValue":"bUglb","../utils/useControlledState":"iZt2P","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"e0qRc":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a token within a token field.
 * A token field allows users to enter text with inline tokens.
 */ parcelHelpers.export(exports, "useToken", ()=>useToken);
var _react = require("react");
var _isVirtualEvent = require("../utils/isVirtualEvent");
var _useEvent = require("../utils/useEvent");
function useToken(// Unused but matches the normal signature.
_props, _state, ref) {
    let [isSelected, setSelected] = (0, _react.useState)(false);
    (0, _useEvent.useEvent)((0, _react.useRef)(typeof document !== 'undefined' ? document : null), 'selectionchange', ()=>{
        let selection = window.getSelection();
        if (!selection || !ref.current) return;
        let range = selection.rangeCount === 0 ? null : selection.getRangeAt(0);
        if (!range?.collapsed && range?.intersectsNode(ref.current)) setSelected(true);
        else setSelected(false);
    });
    return {
        tokenProps: {
            contentEditable: false,
            suppressContentEditableWarning: true,
            style: {
                userSelect: 'all',
                WebkitUserSelect: 'all',
                WebkitTapHighlightColor: 'transparent'
            },
            onClick (e) {
                // Select the token when a screen reader clicks on it.
                if (isSelected || !(0, _isVirtualEvent.isVirtualClick)(e.nativeEvent)) return;
                let selection = window.getSelection();
                let wrapper = ref.current?.parentElement;
                if (!selection || !wrapper) return;
                let range = document.createRange();
                range.setStartBefore(wrapper);
                range.setEndAfter(wrapper);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        },
        isSelected
    };
}

},{"react":"a1TxN","../utils/isVirtualEvent":"4DFYe","../utils/useEvent":"lMVDh","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"le7XT":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference path="./speech-recognition.d.ts" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useVoiceInput", ()=>useVoiceInput);
var _react = require("react");
var _useEffectEvent = require("react-aria/private/utils/useEffectEvent");
/**
 * Chromium brands whose Web Speech backend is known to work. Other Chromium
 * forks (Arc, Brave, Edge) expose the API but route to a backend that does not
 * return results, so they are excluded. Safari has no `userAgentData` and is
 * trusted directly. Add a brand here to enable another Chromium fork.
 */ const VOICE_INPUT_CHROMIUM_BROWSERS = new Set([
    'Google Chrome'
]);
/** Resolves the recognizer constructor, applying the Chromium brand allowlist. */ const getRecognitionCtor = ()=>{
    if (typeof window === 'undefined') return null;
    const ctor = window.SpeechRecognition ?? window.webkitSpeechRecognition ?? null;
    if (!ctor) return null;
    const brands = navigator.userAgentData?.brands;
    if (brands && !brands.some((b)=>VOICE_INPUT_CHROMIUM_BROWSERS.has(b.brand))) return null;
    return ctor;
};
/** SpeechRecognition requires a secure context (HTTPS / localhost). */ const isSecureVoiceContext = ()=>typeof window !== 'undefined' && window.isSecureContext === true;
/** Maps a raw recognition error to a normalised code, or `null` to ignore it. */ const mapErrorCode = (error)=>{
    switch(error){
        case 'aborted':
            return null;
        case 'not-allowed':
        case 'service-not-allowed':
            return 'not-allowed';
        case 'network':
            return 'network';
        case 'no-speech':
            return 'no-speech';
        case 'audio-capture':
            return 'audio-capture';
        case 'language-not-supported':
            return 'language-not-supported';
        case 'phrases-not-supported':
            return 'phrases-not-supported';
        default:
            return 'unknown';
    }
};
/** Maps a getUserMedia rejection to a normalised error code. */ const mapMediaError = (err)=>{
    const name = err instanceof DOMException ? err.name : '';
    if (name === 'NotAllowedError' || name === 'SecurityError') return 'not-allowed';
    if (name === 'NotFoundError' || name === 'NotReadableError') return 'audio-capture';
    return 'unknown';
};
/**
 * Requests microphone access so the browser permission prompt reliably opens and
 * a denial is detected before recognition starts. Returns `null` on success (or
 * when getUserMedia is unavailable, deferring to the recognizer's own prompt),
 * or an error code on failure. The granted stream is released immediately —
 * SpeechRecognition opens its own.
 */ const requestMicrophone = async ()=>{
    const media = typeof navigator !== 'undefined' ? navigator.mediaDevices : undefined;
    if (!media?.getUserMedia) return null;
    try {
        const stream = await media.getUserMedia({
            audio: true
        });
        stream.getTracks().forEach((track)=>track.stop());
        return null;
    } catch (err) {
        return mapMediaError(err);
    }
};
/** Accumulates interim vs final transcripts from a recognition result event. */ const readTranscript = (event)=>{
    let interim = '';
    let final = '';
    for(let i = event.resultIndex; i < event.results.length; i++){
        const result = event.results[i];
        const alternative = result?.[0];
        if (result && alternative) {
            if (result.isFinal) final += alternative.transcript;
            else interim += alternative.transcript;
        }
    }
    return {
        interim,
        final
    };
};
/**
 * Creates and wires a SpeechRecognition instance. On error/end the ref is cleared,
 * but only when this instance is still the active one, so a late event from a
 * previous session can't wipe out a newly-started recognizer.
 */ const createRecognizer = (ctor, lang, setup)=>{
    const recognition = new ctor();
    recognition.continuous = true;
    recognition.interimResults = true;
    recognition.lang = lang;
    // Ignore events from a session that is no longer the active recognizer (e.g. a
    // late onend/onerror after a new session started), so they can't flip the
    // listening state, surface a st ale error, or clear a newer recognizer.
    const isActive = ()=>setup.recognitionRef.current === recognition;
    recognition.onstart = ()=>{
        setup.setListening(true);
        setup.onListeningChange(true);
    };
    recognition.onresult = (event)=>{
        if (!isActive()) return;
        const { interim, final } = readTranscript(event);
        if (final) setup.appendFinal(final);
        setup.setInterim(interim);
    };
    recognition.onerror = (event)=>{
        if (!isActive()) return;
        const code = mapErrorCode(event.error);
        if (code) {
            setup.setError(code);
            setup.onError(code);
        }
        setup.setListening(false);
        setup.onListeningChange(false);
        setup.setInterim('');
        // Clear so the next press starts a fresh session instead of calling stop().
        setup.recognitionRef.current = null;
    };
    recognition.onend = ()=>{
        if (!isActive()) return;
        setup.setListening(false);
        setup.onListeningChange(false);
        setup.setInterim('');
        setup.recognitionRef.current = null;
    };
    return recognition;
};
const useVoiceInput = (options)=>{
    const { lang, onError, onListeningChange } = options;
    // Resolve support once — it cannot change for the lifetime of the page.
    const ctor = (0, _react.useMemo)(()=>isSecureVoiceContext() ? getRecognitionCtor() : null, []);
    const isSupported = ctor !== null;
    const [isListening, setIsListening] = (0, _react.useState)(false);
    const [errorCode, setErrorCode] = (0, _react.useState)(null);
    const [interimTranscript, setInterimTranscript] = (0, _react.useState)('');
    const [finalTranscript, setFinalTranscript] = (0, _react.useState)('');
    const transcript = finalTranscript + interimTranscript;
    const recognitionRef = (0, _react.useRef)(null);
    const startingRef = (0, _react.useRef)(false);
    const handleError = (0, _useEffectEvent.useEffectEvent)((code)=>{
        onError?.(code);
    });
    const handleListeningChange = (0, _useEffectEvent.useEffectEvent)((v)=>{
        onListeningChange?.(v);
    });
    const stop = (0, _react.useCallback)(()=>{
        recognitionRef.current?.stop();
    }, []);
    const start = (0, _react.useCallback)(()=>{
        // Guard against double-start (a started recognizer throws InvalidStateError)
        // and against re-entry while the permission prompt is open.
        if (!ctor || recognitionRef.current || startingRef.current) return;
        startingRef.current = true;
        setErrorCode(null);
        setInterimTranscript('');
        setFinalTranscript('');
        // Request mic access first so the browser permission prompt reliably opens
        // and a denial is reported before recognition starts.
        requestMicrophone().then((micError)=>{
            startingRef.current = false;
            if (micError) {
                setErrorCode(micError);
                handleError(micError);
                return;
            }
            // Bail if already started while the permission prompt was open.
            if (recognitionRef.current) return;
            const recognition = createRecognizer(ctor, lang ?? navigator.language ?? 'en-US', {
                recognitionRef,
                setListening: setIsListening,
                onListeningChange: handleListeningChange,
                onError: handleError,
                setError: setErrorCode,
                setInterim: setInterimTranscript,
                appendFinal: (s)=>setFinalTranscript((prev)=>prev + s)
            });
            recognitionRef.current = recognition;
            recognition.start();
        });
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ctor,
        lang,
        handleError,
        handleListeningChange
    ]);
    const toggle = (0, _react.useCallback)(()=>{
        if (recognitionRef.current) stop();
        else start();
    }, [
        start,
        stop
    ]);
    // Abort on unmount so dangling callbacks never fire after teardown.
    (0, _react.useEffect)(()=>{
        return ()=>{
            recognitionRef.current?.abort();
        };
    }, []);
    return {
        isSupported,
        isListening,
        errorCode,
        transcript,
        start,
        stop,
        toggle
    };
};

},{"react":"a1TxN","react-aria/private/utils/useEffectEvent":"fVIcf","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=ai-components.c262750f.js.map
